import { __ } from '@wordpress/i18n';
import { applyFilters } from '@wordpress/hooks';

// action
import {
    blockIconsActionAccountCircle,
    blockIconsActionCalendarToday,
    blockIconsActionCheckCircle,
    blockIconsActionCheckCircleOutline,
    blockIconsActionDashboard,
    blockIconsActionDelete,
    blockIconsActionDescription,
    blockIconsActionDone,
    blockIconsActionEvent,
    blockIconsActionFace,
    blockIconsActionFavoriteBorder,
    blockIconsActionFavorite,
    blockIconsActionFilterAlt,
    blockIconsActionFingerprint,
    blockIconsActionHelp,
    blockIconsActionHelpOutline,
    blockIconsActionHighlightOff,
    blockIconsActionHome,
    blockIconsActionInfo,
    blockIconsActionLanguage,
    blockIconsActionList,
    blockIconsActionLock,
    blockIconsActionLogin,
    blockIconsActionLogout,
    blockIconsActionManageAccounts,
    blockIconsActionPaid,
    blockIconsActionSchedule,
    blockIconsActionSearch,
    blockIconsActionSettings,
    blockIconsActionShoppingCart,
    blockIconsActionTaskAlt,
    blockIconsActionThumbUp,
    blockIconsActionVerified,
    blockIconsActionVisibility,
    blockIconsActionVisibilityOff,
} from './action';

// action
const actionIcons = [
    {
        name: 'blockIconsActionAccountCircle',
        title: __('Account Circle', 'block-icons-google'),
        icon: blockIconsActionAccountCircle,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionCalendarToday',
        title: __('Calendar Today', 'block-icons-google'),
        icon: blockIconsActionCalendarToday,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionCheckCircle',
        title: __('Check Circle', 'block-icons-google'),
        icon: blockIconsActionCheckCircle,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionCheckCircleOutline',
        title: __('Check Circle Outline', 'block-icons-google'),
        icon: blockIconsActionCheckCircleOutline,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionDashboard',
        title: __('Dashboard', 'block-icons-google'),
        icon: blockIconsActionDashboard,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionDelete',
        title: __('Delete', 'block-icons-google'),
        icon: blockIconsActionDelete,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionDescription',
        title: __('Description', 'block-icons-google'),
        icon: blockIconsActionDescription,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionDone',
        title: __('Done', 'block-icons-google'),
        icon: blockIconsActionDone,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionEvent',
        title: __('Event', 'block-icons-google'),
        icon: blockIconsActionEvent,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionFace',
        title: __('Face', 'block-icons-google'),
        icon: blockIconsActionFace,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionFavoriteBorder',
        title: __('Favorite Border', 'block-icons-google'),
        icon: blockIconsActionFavoriteBorder,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionFavorite',
        title: __('Favorite', 'block-icons-google'),
        icon: blockIconsActionFavorite,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionFilterAlt',
        title: __('Filter Alt', 'block-icons-google'),
        icon: blockIconsActionFilterAlt,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionFingerprint',
        title: __('Fingerprint', 'block-icons-google'),
        icon: blockIconsActionFingerprint,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionHelp',
        title: __('Help', 'block-icons-google'),
        icon: blockIconsActionHelp,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionHelpOutline',
        title: __('Help Outline', 'block-icons-google'),
        icon: blockIconsActionHelpOutline,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionHighlightOff',
        title: __('Highlight Off', 'block-icons-google'),
        icon: blockIconsActionHighlightOff,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionHome',
        title: __('Home', 'block-icons-google'),
        icon: blockIconsActionHome,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionInfo',
        title: __('Info', 'block-icons-google'),
        icon: blockIconsActionInfo,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionLanguage',
        title: __('Language', 'block-icons-google'),
        icon: blockIconsActionLanguage,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionList',
        title: __('List', 'block-icons-google'),
        icon: blockIconsActionList,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionLock',
        title: __('Lock', 'block-icons-google'),
        icon: blockIconsActionLock,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionLogin',
        title: __('Login', 'block-icons-google'),
        icon: blockIconsActionLogin,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionLogout',
        title: __('Logout', 'block-icons-google'),
        icon: blockIconsActionLogout,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionManageAccounts',
        title: __('Manage Accounts', 'block-icons-google'),
        icon: blockIconsActionManageAccounts,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionPaid',
        title: __('Paid', 'block-icons-google'),
        icon: blockIconsActionPaid,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionSchedule',
        title: __('Schedule', 'block-icons-google'),
        icon: blockIconsActionSchedule,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionSearch',
        title: __('Search', 'block-icons-google'),
        icon: blockIconsActionSearch,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionSettings',
        title: __('Settings', 'block-icons-google'),
        icon: blockIconsActionSettings,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionShoppingCart',
        title: __('Shopping Cart', 'block-icons-google'),
        icon: blockIconsActionShoppingCart,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionTaskAlt',
        title: __('Task Alt', 'block-icons-google'),
        icon: blockIconsActionTaskAlt,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionThumbUp',
        title: __('Thumb Up', 'block-icons-google'),
        icon: blockIconsActionThumbUp,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionVerified',
        title: __('Verified', 'block-icons-google'),
        icon: blockIconsActionVerified,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionVisibility',
        title: __('Visibility', 'block-icons-google'),
        icon: blockIconsActionVisibility,
        categories: ['action'],
    },
    {
        name: 'blockIconsActionVisibilityOff',
        title: __('Visibility Off', 'block-icons-google'),
        icon: blockIconsActionVisibilityOff,
        categories: ['action'],
    },
];

// activities-new
import {
    blockIconsActivitiesAirNew,
    blockIconsActivitiesArchitectureNew,
    blockIconsActivitiesBackpackNew,
    blockIconsActivitiesBiotechNew,
    blockIconsActivitiesCakeNew,
    blockIconsActivitiesCampaignNew,
    blockIconsActivitiesCampingNew,
    blockIconsActivitiesConfirmationNumberNew,
    blockIconsActivitiesConstructionNew,
    blockIconsActivitiesDownhillSkiingNew,
    blockIconsActivitiesEngineeringNew,
    blockIconsActivitiesExperimentNew,
    blockIconsActivitiesHikingNew,
    blockIconsActivitiesHowToVoteNew,
    blockIconsActivitiesNightsStayNew,
    blockIconsActivitiesPersonalInjuryNew,
    blockIconsActivitiesPianoNew,
    blockIconsActivitiesRealEstateAgentNew,
    blockIconsActivitiesSchoolNew,
    blockIconsActivitiesScienceNew,
    blockIconsActivitiesScoreboardNew,
    blockIconsActivitiesSelfImprovementNew,
    blockIconsActivitiesSportsBaseballNew,
    blockIconsActivitiesSportsBasketballNew,
    blockIconsActivitiesSportsEsportsNew,
    blockIconsActivitiesSportsGymnasticsNew,
    blockIconsActivitiesSportsKabaddiNew,
    blockIconsActivitiesSportsMartialArtsNew,
    blockIconsActivitiesSportsMotorsportsNew,
    blockIconsActivitiesSportsNew,
    blockIconsActivitiesSportsScoreNew,
    blockIconsActivitiesSportsSoccerNew,
    blockIconsActivitiesSportsTennisNew,
    blockIconsActivitiesSportsVolleyballNew,
    blockIconsActivitiesSurfingNew,
    blockIconsActivitiesSwitchAccountNew,
    blockIconsActivitiesSwordsNew,
    blockIconsActivitiesTheatersNew,
    blockIconsActivitiesToysNew,
    blockIconsActivitiesVolunteerActivismNew,
    blockIconsActivitiesWaterNew,
    blockIconsActivitiesWavesNew,
} from './activities-new';

// activities-new
const activitiesNewIcons = [
    {
        name: 'blockIconsActivitiesAirNew',
        title: __('Air', 'block-icons-google'),
        icon: blockIconsActivitiesAirNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesArchitectureNew',
        title: __('Architecture', 'block-icons-google'),
        icon: blockIconsActivitiesArchitectureNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesBackpackNew',
        title: __('Backpack', 'block-icons-google'),
        icon: blockIconsActivitiesBackpackNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesBiotechNew',
        title: __('Biotech', 'block-icons-google'),
        icon: blockIconsActivitiesBiotechNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesCakeNew',
        title: __('Cake', 'block-icons-google'),
        icon: blockIconsActivitiesCakeNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesCampaignNew',
        title: __('Campaign', 'block-icons-google'),
        icon: blockIconsActivitiesCampaignNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesCampingNew',
        title: __('Camping', 'block-icons-google'),
        icon: blockIconsActivitiesCampingNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesConfirmationNumberNew',
        title: __('Confirmation Number', 'block-icons-google'),
        icon: blockIconsActivitiesConfirmationNumberNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesConstructionNew',
        title: __('Construction', 'block-icons-google'),
        icon: blockIconsActivitiesConstructionNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesDownhillSkiingNew',
        title: __('Downhill Skiing', 'block-icons-google'),
        icon: blockIconsActivitiesDownhillSkiingNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesEngineeringNew',
        title: __('Engineering', 'block-icons-google'),
        icon: blockIconsActivitiesEngineeringNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesExperimentNew',
        title: __('Experiment', 'block-icons-google'),
        icon: blockIconsActivitiesExperimentNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesHikingNew',
        title: __('Hiking', 'block-icons-google'),
        icon: blockIconsActivitiesHikingNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesHowToVoteNew',
        title: __('How To Vote', 'block-icons-google'),
        icon: blockIconsActivitiesHowToVoteNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesNightsStayNew',
        title: __('Nights Stay', 'block-icons-google'),
        icon: blockIconsActivitiesNightsStayNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesPersonalInjuryNew',
        title: __('Personal Injury', 'block-icons-google'),
        icon: blockIconsActivitiesPersonalInjuryNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesPianoNew',
        title: __('Piano', 'block-icons-google'),
        icon: blockIconsActivitiesPianoNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesRealEstateAgentNew',
        title: __('Real Estate Agent', 'block-icons-google'),
        icon: blockIconsActivitiesRealEstateAgentNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSchoolNew',
        title: __('School', 'block-icons-google'),
        icon: blockIconsActivitiesSchoolNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesScienceNew',
        title: __('Science', 'block-icons-google'),
        icon: blockIconsActivitiesScienceNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesScoreboardNew',
        title: __('Scoreboard', 'block-icons-google'),
        icon: blockIconsActivitiesScoreboardNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSelfImprovementNew',
        title: __('Self Improvement', 'block-icons-google'),
        icon: blockIconsActivitiesSelfImprovementNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSportsBaseballNew',
        title: __('Sports Baseball', 'block-icons-google'),
        icon: blockIconsActivitiesSportsBaseballNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSportsBasketballNew',
        title: __('Sports Basketball', 'block-icons-google'),
        icon: blockIconsActivitiesSportsBasketballNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSportsEsportsNew',
        title: __('Sports Esports', 'block-icons-google'),
        icon: blockIconsActivitiesSportsEsportsNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSportsGymnasticsNew',
        title: __('Sports Gymnastics', 'block-icons-google'),
        icon: blockIconsActivitiesSportsGymnasticsNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSportsKabaddiNew',
        title: __('Sports Kabaddi', 'block-icons-google'),
        icon: blockIconsActivitiesSportsKabaddiNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSportsMartialArtsNew',
        title: __('Sports Martial Arts', 'block-icons-google'),
        icon: blockIconsActivitiesSportsMartialArtsNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSportsMotorsportsNew',
        title: __('Sports Motorsports', 'block-icons-google'),
        icon: blockIconsActivitiesSportsMotorsportsNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSportsNew',
        title: __('Sports', 'block-icons-google'),
        icon: blockIconsActivitiesSportsNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSportsScoreNew',
        title: __('Sports Score', 'block-icons-google'),
        icon: blockIconsActivitiesSportsScoreNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSportsSoccerNew',
        title: __('Sports Soccer', 'block-icons-google'),
        icon: blockIconsActivitiesSportsSoccerNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSportsTennisNew',
        title: __('Sports Tennis', 'block-icons-google'),
        icon: blockIconsActivitiesSportsTennisNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSportsVolleyballNew',
        title: __('Sports Volleyball', 'block-icons-google'),
        icon: blockIconsActivitiesSportsVolleyballNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSurfingNew',
        title: __('Surfing', 'block-icons-google'),
        icon: blockIconsActivitiesSurfingNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSwitchAccountNew',
        title: __('Switch Account', 'block-icons-google'),
        icon: blockIconsActivitiesSwitchAccountNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesSwordsNew',
        title: __('Swords', 'block-icons-google'),
        icon: blockIconsActivitiesSwordsNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesTheatersNew',
        title: __('Theaters', 'block-icons-google'),
        icon: blockIconsActivitiesTheatersNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesToysNew',
        title: __('Toys', 'block-icons-google'),
        icon: blockIconsActivitiesToysNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesVolunteerActivismNew',
        title: __('Volunteer Activism', 'block-icons-google'),
        icon: blockIconsActivitiesVolunteerActivismNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesWaterNew',
        title: __('Water', 'block-icons-google'),
        icon: blockIconsActivitiesWaterNew,
        categories: ['activities-new'],
    },
    {
        name: 'blockIconsActivitiesWavesNew',
        title: __('Waves', 'block-icons-google'),
        icon: blockIconsActivitiesWavesNew,
        categories: ['activities-new'],
    },
];

// alert
import {
    blockIconsAlertAddAlert,
    blockIconsAlertAutoDelete,
    blockIconsAlertError,
    blockIconsAlertErrorOutline,
    blockIconsAlertNotificationImportant,
    blockIconsAlertWarningAmber,
    blockIconsAlertWarning,
} from './alert';

// alert
const alertIcons = [
    {
        name: 'blockIconsAlertAddAlert',
        title: __('Add', 'block-icons-google'),
        icon: blockIconsAlertAddAlert,
        categories: ['alert'],
    },
    {
        name: 'blockIconsAlertAutoDelete',
        title: __('Auto Delete', 'block-icons-google'),
        icon: blockIconsAlertAutoDelete,
        categories: ['alert'],
    },
    {
        name: 'blockIconsAlertError',
        title: __('Error', 'block-icons-google'),
        icon: blockIconsAlertError,
        categories: ['alert'],
    },
    {
        name: 'blockIconsAlertErrorOutline',
        title: __('Error Outline', 'block-icons-google'),
        icon: blockIconsAlertErrorOutline,
        categories: ['alert'],
    },
    {
        name: 'blockIconsAlertNotificationImportant',
        title: __('Notification Important', 'block-icons-google'),
        icon: blockIconsAlertNotificationImportant,
        categories: ['alert'],
    },
    {
        name: 'blockIconsAlertWarningAmber',
        title: __('Warning Amber', 'block-icons-google'),
        icon: blockIconsAlertWarningAmber,
        categories: ['alert'],
    },
    {
        name: 'blockIconsAlertWarning',
        title: __('Warning', 'block-icons-google'),
        icon: blockIconsAlertWarning,
        categories: ['alert'],
    },
];

// android-new
import {
    blockIconsAndroidAirplanemodeActiveNew,
    blockIconsAndroidAndroidNew,
    blockIconsAndroidBattery0BarNew,
    blockIconsAndroidBattery4BarNew,
    blockIconsAndroidBattery5BarNew,
    blockIconsAndroidBattery6BarNew,
    blockIconsAndroidBatteryChargingFullNew,
    blockIconsAndroidBatteryFullAltNew,
    blockIconsAndroidBatteryFullNew,
    blockIconsAndroidBluetoothNew,
    blockIconsAndroidCableNew,
    blockIconsAndroidCameraswitchNew,
    blockIconsAndroidChargerNew,
    blockIconsAndroidDarkModeNew,
    blockIconsAndroidDataUsageNew,
    blockIconsAndroidDvrNew,
    blockIconsAndroidFlashlightOnNew,
    blockIconsAndroidGppBadNew,
    blockIconsAndroidGppMaybeNew,
    blockIconsAndroidGraphicEqNew,
    blockIconsAndroidLightModeNew,
    blockIconsAndroidNetworkCheckNew,
    blockIconsAndroidNightlightNew,
    blockIconsAndroidPasswordNew,
    blockIconsAndroidPinNew,
    blockIconsAndroidQuickPhrasesNew,
    blockIconsAndroidRadarNew,
    blockIconsAndroidRssFeedNew,
    blockIconsAndroidSignalCellular4BarNew,
    blockIconsAndroidSignalCellularAltNew,
    blockIconsAndroidSignalDisconnectedNew,
    blockIconsAndroidSignalWifi4BarNew,
    blockIconsAndroidSimCardDownloadNew,
    blockIconsAndroidSplitscreenNew,
    blockIconsAndroidStorageNew,
    blockIconsAndroidThermostatNew,
    blockIconsAndroidUsbNew,
    blockIconsAndroidWallpaperNew,
    blockIconsAndroidWidgetsNew,
    blockIconsAndroidWifiNew,
    blockIconsAndroidWifiOffNew,
    blockIconsAndroidWifiTetheringNew,
} from './android-new';

// android-new
const androidNewIcons = [
    {
        name: 'blockIconsAndroidAirplanemodeActiveNew',
        title: __('Airplanemode Active', 'block-icons-google'),
        icon: blockIconsAndroidAirplanemodeActiveNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidAndroidNew',
        title: __('', 'block-icons-google'),
        icon: blockIconsAndroidAndroidNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidBattery0BarNew',
        title: __('Battery0Bar', 'block-icons-google'),
        icon: blockIconsAndroidBattery0BarNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidBattery4BarNew',
        title: __('Battery4Bar', 'block-icons-google'),
        icon: blockIconsAndroidBattery4BarNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidBattery5BarNew',
        title: __('Battery5Bar', 'block-icons-google'),
        icon: blockIconsAndroidBattery5BarNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidBattery6BarNew',
        title: __('Battery6Bar', 'block-icons-google'),
        icon: blockIconsAndroidBattery6BarNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidBatteryChargingFullNew',
        title: __('Battery Charging Full', 'block-icons-google'),
        icon: blockIconsAndroidBatteryChargingFullNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidBatteryFullAltNew',
        title: __('Battery Full Alt', 'block-icons-google'),
        icon: blockIconsAndroidBatteryFullAltNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidBatteryFullNew',
        title: __('Battery Full', 'block-icons-google'),
        icon: blockIconsAndroidBatteryFullNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidBluetoothNew',
        title: __('Bluetooth', 'block-icons-google'),
        icon: blockIconsAndroidBluetoothNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidCableNew',
        title: __('Cable', 'block-icons-google'),
        icon: blockIconsAndroidCableNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidCameraswitchNew',
        title: __('Cameraswitch', 'block-icons-google'),
        icon: blockIconsAndroidCameraswitchNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidChargerNew',
        title: __('Charger', 'block-icons-google'),
        icon: blockIconsAndroidChargerNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidDarkModeNew',
        title: __('Dark Mode', 'block-icons-google'),
        icon: blockIconsAndroidDarkModeNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidDataUsageNew',
        title: __('Data Usage', 'block-icons-google'),
        icon: blockIconsAndroidDataUsageNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidDvrNew',
        title: __('Dvr', 'block-icons-google'),
        icon: blockIconsAndroidDvrNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidFlashlightOnNew',
        title: __('Flashlight On', 'block-icons-google'),
        icon: blockIconsAndroidFlashlightOnNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidGppBadNew',
        title: __('Gpp Bad', 'block-icons-google'),
        icon: blockIconsAndroidGppBadNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidGppMaybeNew',
        title: __('Gpp Maybe', 'block-icons-google'),
        icon: blockIconsAndroidGppMaybeNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidGraphicEqNew',
        title: __('Graphic Eq', 'block-icons-google'),
        icon: blockIconsAndroidGraphicEqNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidLightModeNew',
        title: __('Light Mode', 'block-icons-google'),
        icon: blockIconsAndroidLightModeNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidNetworkCheckNew',
        title: __('Network Check', 'block-icons-google'),
        icon: blockIconsAndroidNetworkCheckNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidNightlightNew',
        title: __('Nightlight', 'block-icons-google'),
        icon: blockIconsAndroidNightlightNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidPasswordNew',
        title: __('Password', 'block-icons-google'),
        icon: blockIconsAndroidPasswordNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidPinNew',
        title: __('Pin', 'block-icons-google'),
        icon: blockIconsAndroidPinNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidQuickPhrasesNew',
        title: __('Quick Phrases', 'block-icons-google'),
        icon: blockIconsAndroidQuickPhrasesNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidRadarNew',
        title: __('Radar', 'block-icons-google'),
        icon: blockIconsAndroidRadarNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidRssFeedNew',
        title: __('Rss Feed', 'block-icons-google'),
        icon: blockIconsAndroidRssFeedNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidSignalCellular4BarNew',
        title: __('Signal Cellular4Bar', 'block-icons-google'),
        icon: blockIconsAndroidSignalCellular4BarNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidSignalCellularAltNew',
        title: __('Signal Cellular Alt', 'block-icons-google'),
        icon: blockIconsAndroidSignalCellularAltNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidSignalDisconnectedNew',
        title: __('Signal Disconnected', 'block-icons-google'),
        icon: blockIconsAndroidSignalDisconnectedNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidSignalWifi4BarNew',
        title: __('Signal Wifi4Bar', 'block-icons-google'),
        icon: blockIconsAndroidSignalWifi4BarNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidSimCardDownloadNew',
        title: __('Sim Card Download', 'block-icons-google'),
        icon: blockIconsAndroidSimCardDownloadNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidSplitscreenNew',
        title: __('Splitscreen', 'block-icons-google'),
        icon: blockIconsAndroidSplitscreenNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidStorageNew',
        title: __('Storage', 'block-icons-google'),
        icon: blockIconsAndroidStorageNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidThermostatNew',
        title: __('Thermostat', 'block-icons-google'),
        icon: blockIconsAndroidThermostatNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidUsbNew',
        title: __('Usb', 'block-icons-google'),
        icon: blockIconsAndroidUsbNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidWallpaperNew',
        title: __('Wallpaper', 'block-icons-google'),
        icon: blockIconsAndroidWallpaperNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidWidgetsNew',
        title: __('Widgets', 'block-icons-google'),
        icon: blockIconsAndroidWidgetsNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidWifiNew',
        title: __('Wifi', 'block-icons-google'),
        icon: blockIconsAndroidWifiNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidWifiOffNew',
        title: __('Wifi Off', 'block-icons-google'),
        icon: blockIconsAndroidWifiOffNew,
        categories: ['android-new'],
    },
    {
        name: 'blockIconsAndroidWifiTetheringNew',
        title: __('Wifi Tethering', 'block-icons-google'),
        icon: blockIconsAndroidWifiTetheringNew,
        categories: ['android-new'],
    },
];

// audio-and-video
import {
    blockIconsAudioandvideoEqualizer,
    blockIconsAudioandvideoFastForward,
    blockIconsAudioandvideoFiberManualRecord,
    blockIconsAudioandvideoLibraryAdd,
    blockIconsAudioandvideoLibraryBooks,
    blockIconsAudioandvideoLoop,
    blockIconsAudioandvideoMic,
    blockIconsAudioandvideoMicOff,
    blockIconsAudioandvideoMovie,
    blockIconsAudioandvideoNewReleases,
    blockIconsAudioandvideoNotInterested,
    blockIconsAudioandvideoPauseCircle,
    blockIconsAudioandvideoPause,
    blockIconsAudioandvideoPlayArrow,
    // blockIconsAudioandvideoPlayCircleFilled,
    // blockIconsAudioandvideoPlayCircle,
    // blockIconsAudioandvideoPlayCircleOutline,
    blockIconsAudioandvideoPlaylistAddCheck,
    blockIconsAudioandvideoPlaylistAdd,
    blockIconsAudioandvideoRepeat,
    blockIconsAudioandvideoReplay,
    blockIconsAudioandvideoShuffle,
    blockIconsAudioandvideoSkipNext,
    blockIconsAudioandvideoSkipPrevious,
    blockIconsAudioandvideoSpeed,
    blockIconsAudioandvideoStopCircle,
    blockIconsAudioandvideoStop,
    blockIconsAudioandvideoSubscriptions,
    blockIconsAudioandvideoVideoCall,
    blockIconsAudioandvideoVideocam,
    blockIconsAudioandvideoVideoLibrary,
    blockIconsAudioandvideoVolumeMute,
    blockIconsAudioandvideoVolumeOff,
    blockIconsAudioandvideoVolumeUp,
    blockIconsAudioandvideoWeb,
} from './audio-and-video';

// audio-and-video
const audioAndVideoIcons = [
    {
        name: 'blockIconsAudioandvideoEqualizer',
        title: __('Audioandvideo Equalizer', 'block-icons-google'),
        icon: blockIconsAudioandvideoEqualizer,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoFastForward',
        title: __('Audioandvideo Fast Forward', 'block-icons-google'),
        icon: blockIconsAudioandvideoFastForward,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoFiberManualRecord',
        title: __('Audioandvideo Fiber Manual Record', 'block-icons-google'),
        icon: blockIconsAudioandvideoFiberManualRecord,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoLibraryAdd',
        title: __('Audioandvideo Library Add', 'block-icons-google'),
        icon: blockIconsAudioandvideoLibraryAdd,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoLibraryBooks',
        title: __('Audioandvideo Library Books', 'block-icons-google'),
        icon: blockIconsAudioandvideoLibraryBooks,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoLoop',
        title: __('Audioandvideo Loop', 'block-icons-google'),
        icon: blockIconsAudioandvideoLoop,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoMic',
        title: __('Audioandvideo Mic', 'block-icons-google'),
        icon: blockIconsAudioandvideoMic,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoMicOff',
        title: __('Audioandvideo Mic Off', 'block-icons-google'),
        icon: blockIconsAudioandvideoMicOff,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoMovie',
        title: __('Audioandvideo Movie', 'block-icons-google'),
        icon: blockIconsAudioandvideoMovie,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoNewReleases',
        title: __('Audioandvideo Releases', 'block-icons-google'),
        icon: blockIconsAudioandvideoNewReleases,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoNotInterested',
        title: __('Audioandvideo Not Interested', 'block-icons-google'),
        icon: blockIconsAudioandvideoNotInterested,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoPauseCircle',
        title: __('Audioandvideo Pause Circle', 'block-icons-google'),
        icon: blockIconsAudioandvideoPauseCircle,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoPause',
        title: __('Audioandvideo Pause', 'block-icons-google'),
        icon: blockIconsAudioandvideoPause,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoPlayArrow',
        title: __('Audioandvideo Play Arrow', 'block-icons-google'),
        icon: blockIconsAudioandvideoPlayArrow,
        categories: ['audio-and-video'],
    },
    // {
    //     name: 'blockIconsAudioandvideoPlayCircleFilled',
    //     title: __('Audioandvideo Play Circle Filled', 'block-icons-google'),
    //     icon: blockIconsAudioandvideoPlayCircleFilled,
    //     categories: ['audio-and-video'],
    // },
    // {
    //     name: 'blockIconsAudioandvideoPlayCircle',
    //     title: __('Audioandvideo Play Circle', 'block-icons-google'),
    //     icon: blockIconsAudioandvideoPlayCircle,
    //     categories: ['audio-and-video'],
    // },
    // {
    //     name: 'blockIconsAudioandvideoPlayCircleOutline',
    //     title: __('Audioandvideo Play Circle Outline', 'block-icons-google'),
    //     icon: blockIconsAudioandvideoPlayCircleOutline,
    //     categories: ['audio-and-video'],
    // },
    {
        name: 'blockIconsAudioandvideoPlaylistAddCheck',
        title: __('Audioandvideo Playlist Add Check', 'block-icons-google'),
        icon: blockIconsAudioandvideoPlaylistAddCheck,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoPlaylistAdd',
        title: __('Audioandvideo Playlist Add', 'block-icons-google'),
        icon: blockIconsAudioandvideoPlaylistAdd,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoRepeat',
        title: __('Audioandvideo Repeat', 'block-icons-google'),
        icon: blockIconsAudioandvideoRepeat,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoReplay',
        title: __('Audioandvideo Replay', 'block-icons-google'),
        icon: blockIconsAudioandvideoReplay,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoShuffle',
        title: __('Audioandvideo Shuffle', 'block-icons-google'),
        icon: blockIconsAudioandvideoShuffle,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoSkipNext',
        title: __('Audioandvideo Skip Next', 'block-icons-google'),
        icon: blockIconsAudioandvideoSkipNext,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoSkipPrevious',
        title: __('Audioandvideo Skip Previous', 'block-icons-google'),
        icon: blockIconsAudioandvideoSkipPrevious,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoSpeed',
        title: __('Audioandvideo Speed', 'block-icons-google'),
        icon: blockIconsAudioandvideoSpeed,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoStopCircle',
        title: __('Audioandvideo Stop Circle', 'block-icons-google'),
        icon: blockIconsAudioandvideoStopCircle,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoStop',
        title: __('Audioandvideo Stop', 'block-icons-google'),
        icon: blockIconsAudioandvideoStop,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoSubscriptions',
        title: __('Audioandvideo Subscriptions', 'block-icons-google'),
        icon: blockIconsAudioandvideoSubscriptions,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoVideoCall',
        title: __('Audioandvideo Video Call', 'block-icons-google'),
        icon: blockIconsAudioandvideoVideoCall,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoVideocam',
        title: __('Audioandvideo Videocam', 'block-icons-google'),
        icon: blockIconsAudioandvideoVideocam,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoVideoLibrary',
        title: __('Audioandvideo Video Library', 'block-icons-google'),
        icon: blockIconsAudioandvideoVideoLibrary,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoVolumeMute',
        title: __('Audioandvideo Volume Mute', 'block-icons-google'),
        icon: blockIconsAudioandvideoVolumeMute,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoVolumeOff',
        title: __('Audioandvideo Volume Off', 'block-icons-google'),
        icon: blockIconsAudioandvideoVolumeOff,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoVolumeUp',
        title: __('Audioandvideo Volume Up', 'block-icons-google'),
        icon: blockIconsAudioandvideoVolumeUp,
        categories: ['audio-and-video'],
    },
    {
        name: 'blockIconsAudioandvideoWeb',
        title: __('Audioandvideo Web', 'block-icons-google'),
        icon: blockIconsAudioandvideoWeb,
        categories: ['audio-and-video'],
    },
];

// audio-and-video-new
import {
    blockIconsAudioandvideoAlbumNew,
    blockIconsAudioandvideoEqualizerNew,
    blockIconsAudioandvideoFastForwardNew,
    blockIconsAudioandvideoFastRewindNew,
    blockIconsAudioandvideoFiberManualRecordNew,
    blockIconsAudioandvideoHearingNew,
    blockIconsAudioandvideoLibraryBooksNew,
    blockIconsAudioandvideoLibraryMusicNew,
    blockIconsAudioandvideoMicNew,
    blockIconsAudioandvideoMicOffNew,
    blockIconsAudioandvideoMovieNew,
    blockIconsAudioandvideoMusicNoteNew,
    blockIconsAudioandvideoPauseCircleNew,
    blockIconsAudioandvideoPauseNew,
    blockIconsAudioandvideoPlayArrowNew,
    blockIconsAudioandvideoPlayCircleNew,
    blockIconsAudioandvideoPlaylistAddCheckNew,
    blockIconsAudioandvideoPlaylistAddNew,
    blockIconsAudioandvideoPlayPauseNew,
    blockIconsAudioandvideoPodcastsNew,
    blockIconsAudioandvideoQueueMusicNew,
    blockIconsAudioandvideoRadioNew,
    blockIconsAudioandvideoRepeatNew,
    blockIconsAudioandvideoReplayNew,
    blockIconsAudioandvideoShuffleNew,
    blockIconsAudioandvideoSkipNextNew,
    blockIconsAudioandvideoSkipPreviousNew,
    blockIconsAudioandvideoSoundDetectionDogBarkingNew,
    blockIconsAudioandvideoSpeedNew,
    blockIconsAudioandvideoStopCircleNew,
    blockIconsAudioandvideoStopNew,
    blockIconsAudioandvideoSubscriptionsNew,
    blockIconsAudioandvideoSubtitlesNew,
    blockIconsAudioandvideoVideoCallNew,
    blockIconsAudioandvideoVideoCameraFrontNew,
    blockIconsAudioandvideoVideocamNew,
    blockIconsAudioandvideoVideoLibraryNew,
    blockIconsAudioandvideoViewInArNew,
    blockIconsAudioandvideoVolumeDownNew,
    blockIconsAudioandvideoVolumeMuteNew,
    blockIconsAudioandvideoVolumeOffNew,
    blockIconsAudioandvideoVolumeUpNew,
} from './audio-and-video-new';

// audio-and-video-new
const audioAndVideoNewIcons = [
    {
        name: 'blockIconsAudioandvideoAlbumNew',
        title: __('Audioandvideo Album', 'block-icons-google'),
        icon: blockIconsAudioandvideoAlbumNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoEqualizerNew',
        title: __('Audioandvideo Equalizer', 'block-icons-google'),
        icon: blockIconsAudioandvideoEqualizerNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoFastForwardNew',
        title: __('Audioandvideo Fast Forward', 'block-icons-google'),
        icon: blockIconsAudioandvideoFastForwardNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoFastRewindNew',
        title: __('Audioandvideo Fast Rewind', 'block-icons-google'),
        icon: blockIconsAudioandvideoFastRewindNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoFiberManualRecordNew',
        title: __('Audioandvideo Fiber Manual Record', 'block-icons-google'),
        icon: blockIconsAudioandvideoFiberManualRecordNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoHearingNew',
        title: __('Audioandvideo Hearing', 'block-icons-google'),
        icon: blockIconsAudioandvideoHearingNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoLibraryBooksNew',
        title: __('Audioandvideo Library Books', 'block-icons-google'),
        icon: blockIconsAudioandvideoLibraryBooksNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoLibraryMusicNew',
        title: __('Audioandvideo Library Music', 'block-icons-google'),
        icon: blockIconsAudioandvideoLibraryMusicNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoMicNew',
        title: __('Audioandvideo Mic', 'block-icons-google'),
        icon: blockIconsAudioandvideoMicNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoMicOffNew',
        title: __('Audioandvideo Mic Off', 'block-icons-google'),
        icon: blockIconsAudioandvideoMicOffNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoMovieNew',
        title: __('Audioandvideo Movie', 'block-icons-google'),
        icon: blockIconsAudioandvideoMovieNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoMusicNoteNew',
        title: __('Audioandvideo Music Note', 'block-icons-google'),
        icon: blockIconsAudioandvideoMusicNoteNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoPauseCircleNew',
        title: __('Audioandvideo Pause Circle', 'block-icons-google'),
        icon: blockIconsAudioandvideoPauseCircleNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoPauseNew',
        title: __('Audioandvideo Pause', 'block-icons-google'),
        icon: blockIconsAudioandvideoPauseNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoPlayArrowNew',
        title: __('Audioandvideo Play Arrow', 'block-icons-google'),
        icon: blockIconsAudioandvideoPlayArrowNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoPlayCircleNew',
        title: __('Audioandvideo Play Circle', 'block-icons-google'),
        icon: blockIconsAudioandvideoPlayCircleNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoPlaylistAddCheckNew',
        title: __('Audioandvideo Playlist Add Check', 'block-icons-google'),
        icon: blockIconsAudioandvideoPlaylistAddCheckNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoPlaylistAddNew',
        title: __('Audioandvideo Playlist Add', 'block-icons-google'),
        icon: blockIconsAudioandvideoPlaylistAddNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoPlayPauseNew',
        title: __('Audioandvideo Play Pause', 'block-icons-google'),
        icon: blockIconsAudioandvideoPlayPauseNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoPodcastsNew',
        title: __('Audioandvideo Podcasts', 'block-icons-google'),
        icon: blockIconsAudioandvideoPodcastsNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoQueueMusicNew',
        title: __('Audioandvideo Queue Music', 'block-icons-google'),
        icon: blockIconsAudioandvideoQueueMusicNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoRadioNew',
        title: __('Audioandvideo Radio', 'block-icons-google'),
        icon: blockIconsAudioandvideoRadioNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoRepeatNew',
        title: __('Audioandvideo Repeat', 'block-icons-google'),
        icon: blockIconsAudioandvideoRepeatNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoReplayNew',
        title: __('Audioandvideo Replay', 'block-icons-google'),
        icon: blockIconsAudioandvideoReplayNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoShuffleNew',
        title: __('Audioandvideo Shuffle', 'block-icons-google'),
        icon: blockIconsAudioandvideoShuffleNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoSkipNextNew',
        title: __('Audioandvideo Skip Next', 'block-icons-google'),
        icon: blockIconsAudioandvideoSkipNextNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoSkipPreviousNew',
        title: __('Audioandvideo Skip Previous', 'block-icons-google'),
        icon: blockIconsAudioandvideoSkipPreviousNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoSoundDetectionDogBarkingNew',
        title: __('Audioandvideo Sound Detection Dog Barking', 'block-icons-google'),
        icon: blockIconsAudioandvideoSoundDetectionDogBarkingNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoSpeedNew',
        title: __('Audioandvideo Speed', 'block-icons-google'),
        icon: blockIconsAudioandvideoSpeedNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoStopCircleNew',
        title: __('Audioandvideo Stop Circle', 'block-icons-google'),
        icon: blockIconsAudioandvideoStopCircleNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoStopNew',
        title: __('Audioandvideo Stop', 'block-icons-google'),
        icon: blockIconsAudioandvideoStopNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoSubscriptionsNew',
        title: __('Audioandvideo Subscriptions', 'block-icons-google'),
        icon: blockIconsAudioandvideoSubscriptionsNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoSubtitlesNew',
        title: __('Audioandvideo Subtitles', 'block-icons-google'),
        icon: blockIconsAudioandvideoSubtitlesNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoVideoCallNew',
        title: __('Audioandvideo Video Call', 'block-icons-google'),
        icon: blockIconsAudioandvideoVideoCallNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoVideoCameraFrontNew',
        title: __('Audioandvideo Video Camera Front', 'block-icons-google'),
        icon: blockIconsAudioandvideoVideoCameraFrontNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoVideocamNew',
        title: __('Audioandvideo Videocam', 'block-icons-google'),
        icon: blockIconsAudioandvideoVideocamNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoVideoLibraryNew',
        title: __('Audioandvideo Video Library', 'block-icons-google'),
        icon: blockIconsAudioandvideoVideoLibraryNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoViewInArNew',
        title: __('Audioandvideo View In Ar', 'block-icons-google'),
        icon: blockIconsAudioandvideoViewInArNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoVolumeDownNew',
        title: __('Audioandvideo Volume Down', 'block-icons-google'),
        icon: blockIconsAudioandvideoVolumeDownNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoVolumeMuteNew',
        title: __('Audioandvideo Volume Mute', 'block-icons-google'),
        icon: blockIconsAudioandvideoVolumeMuteNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoVolumeOffNew',
        title: __('Audioandvideo Volume Off', 'block-icons-google'),
        icon: blockIconsAudioandvideoVolumeOffNew,
        categories: ['audio-and-video-new'],
    },
    {
        name: 'blockIconsAudioandvideoVolumeUpNew',
        title: __('Audioandvideo Volume Up', 'block-icons-google'),
        icon: blockIconsAudioandvideoVolumeUpNew,
        categories: ['audio-and-video-new'],
    },
];

// brand-new
import {
    blockIconsBrandNestGaleWifiNew,
} from './brand-new';

// brand-new
const brandNewIcons = [
    {
        name: 'blockIconsBrandNestGaleWifiNew',
        title: __('Nest Gale Wifi', 'block-icons-google'),
        icon: blockIconsBrandNestGaleWifiNew,
        categories: ['brand-new'],
    },
];

// business-and-payments-new
import {
    blockIconsBusinessandpaymentsAccountBalanceNew,
    blockIconsBusinessandpaymentsAccountBalanceWalletNew,
    blockIconsBusinessandpaymentsAccountTreeNew,
    blockIconsBusinessandpaymentsAddShoppingCartNew,
    blockIconsBusinessandpaymentsAnalyticsNew,
    blockIconsBusinessandpaymentsAttachMoneyNew,
    blockIconsBusinessandpaymentsBarChartNew,
    blockIconsBusinessandpaymentsCalculateNew,
    blockIconsBusinessandpaymentsCorporateFareNew,
    blockIconsBusinessandpaymentsCreditCardNew,
    blockIconsBusinessandpaymentsCurrencyExchangeNew,
    blockIconsBusinessandpaymentsCurrencyRupeeNew,
    blockIconsBusinessandpaymentsDatabaseNew,
    blockIconsBusinessandpaymentsDomainNew,
    blockIconsBusinessandpaymentsInsertChartNew,
    blockIconsBusinessandpaymentsLeaderboardNew,
    blockIconsBusinessandpaymentsMonetizationOnNew,
    blockIconsBusinessandpaymentsMonitoringNew,
    blockIconsBusinessandpaymentsPaidNew,
    blockIconsBusinessandpaymentsPaymentsNew,
    blockIconsBusinessandpaymentsPrecisionManufacturingNew,
    blockIconsBusinessandpaymentsQrCode2New,
    blockIconsBusinessandpaymentsQrCodeNew,
    blockIconsBusinessandpaymentsQrCodeScannerNew,
    blockIconsBusinessandpaymentsQueryStatsNew,
    blockIconsBusinessandpaymentsReceiptLongNew,
    blockIconsBusinessandpaymentsReceiptNew,
    blockIconsBusinessandpaymentsRedeemNew,
    blockIconsBusinessandpaymentsSavingsNew,
    blockIconsBusinessandpaymentsSellNew,
    blockIconsBusinessandpaymentsShoppingBagNew,
    blockIconsBusinessandpaymentsShoppingBasketNew,
    blockIconsBusinessandpaymentsShoppingCartNew,
    blockIconsBusinessandpaymentsShowChartNew,
    blockIconsBusinessandpaymentsStorefrontNew,
    blockIconsBusinessandpaymentsStoreNew,
    blockIconsBusinessandpaymentsTimelineNew,
    blockIconsBusinessandpaymentsTrendingFlatNew,
    blockIconsBusinessandpaymentsTrendingUpNew,
    blockIconsBusinessandpaymentsWalletNew,
    blockIconsBusinessandpaymentsWorkHistoryNew,
    blockIconsBusinessandpaymentsWorkNew,
} from './business-and-payments-new';

// business-and-payments-new
const businessAndPaymentsNewIcons = [
    {
        name: 'blockIconsBusinessandpaymentsAccountBalanceNew',
        title: __('Businessandpayments Account Balance', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsAccountBalanceNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsAccountBalanceWalletNew',
        title: __('Businessandpayments Account Balance Wallet', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsAccountBalanceWalletNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsAccountTreeNew',
        title: __('Businessandpayments Account Tree', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsAccountTreeNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsAddShoppingCartNew',
        title: __('Businessandpayments Add Shopping Cart', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsAddShoppingCartNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsAnalyticsNew',
        title: __('Businessandpayments Analytics', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsAnalyticsNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsAttachMoneyNew',
        title: __('Businessandpayments Attach Money', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsAttachMoneyNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsBarChartNew',
        title: __('Businessandpayments Bar Chart', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsBarChartNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsCalculateNew',
        title: __('Businessandpayments Calculate', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsCalculateNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsCorporateFareNew',
        title: __('Businessandpayments Corporate Fare', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsCorporateFareNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsCreditCardNew',
        title: __('Businessandpayments Credit Card', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsCreditCardNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsCurrencyExchangeNew',
        title: __('Businessandpayments Currency Exchange', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsCurrencyExchangeNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsCurrencyRupeeNew',
        title: __('Businessandpayments Currency Rupee', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsCurrencyRupeeNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsDatabaseNew',
        title: __('Businessandpayments Database', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsDatabaseNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsDomainNew',
        title: __('Businessandpayments Domain', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsDomainNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsInsertChartNew',
        title: __('Businessandpayments Insert Chart', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsInsertChartNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsLeaderboardNew',
        title: __('Businessandpayments Leaderboard', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsLeaderboardNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsMonetizationOnNew',
        title: __('Businessandpayments Monetization On', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsMonetizationOnNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsMonitoringNew',
        title: __('Businessandpayments Monitoring', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsMonitoringNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsPaidNew',
        title: __('Businessandpayments Paid', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsPaidNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsPaymentsNew',
        title: __('Businessandpayments Payments', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsPaymentsNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsPrecisionManufacturingNew',
        title: __('Businessandpayments Precision Manufacturing', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsPrecisionManufacturingNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsQrCode2New',
        title: __('Businessandpayments Qr Code2', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsQrCode2New,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsQrCodeNew',
        title: __('Businessandpayments Qr Code', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsQrCodeNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsQrCodeScannerNew',
        title: __('Businessandpayments Qr Code Scanner', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsQrCodeScannerNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsQueryStatsNew',
        title: __('Businessandpayments Query Stats', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsQueryStatsNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsReceiptLongNew',
        title: __('Businessandpayments Receipt Long', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsReceiptLongNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsReceiptNew',
        title: __('Businessandpayments Receipt', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsReceiptNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsRedeemNew',
        title: __('Businessandpayments Redeem', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsRedeemNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsSavingsNew',
        title: __('Businessandpayments Savings', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsSavingsNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsSellNew',
        title: __('Businessandpayments Sell', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsSellNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsShoppingBagNew',
        title: __('Businessandpayments Shopping Bag', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsShoppingBagNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsShoppingBasketNew',
        title: __('Businessandpayments Shopping Basket', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsShoppingBasketNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsShoppingCartNew',
        title: __('Businessandpayments Shopping Cart', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsShoppingCartNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsShowChartNew',
        title: __('Businessandpayments Show Chart', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsShowChartNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsStorefrontNew',
        title: __('Businessandpayments Storefront', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsStorefrontNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsStoreNew',
        title: __('Businessandpayments Store', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsStoreNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsTimelineNew',
        title: __('Businessandpayments Timeline', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsTimelineNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsTrendingFlatNew',
        title: __('Businessandpayments Trending Flat', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsTrendingFlatNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsTrendingUpNew',
        title: __('Businessandpayments Trending Up', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsTrendingUpNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsWalletNew',
        title: __('Businessandpayments Wallet', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsWalletNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsWorkHistoryNew',
        title: __('Businessandpayments Work History', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsWorkHistoryNew,
        categories: ['business-and-payments-new'],
    },
    {
        name: 'blockIconsBusinessandpaymentsWorkNew',
        title: __('Businessandpayments Work', 'block-icons-google'),
        icon: blockIconsBusinessandpaymentsWorkNew,
        categories: ['business-and-payments-new'],
    },
];

// common-actions-new
import {
    blockIconsCommonactionsAccountBoxNew,
    blockIconsCommonactionsAccountCircleNew,
    blockIconsCommonactionsAdsClickNew,
    blockIconsCommonactionsBookmarkNew,
    blockIconsCommonactionsBugReportNew,
    blockIconsCommonactionsBuildNew,
    blockIconsCommonactionsCalendarMonthNew,
    blockIconsCommonactionsCalendarTodayNew,
    blockIconsCommonactionsCategoryNew,
    blockIconsCommonactionsCelebrationNew,
    blockIconsCommonactionsCodeNew,
    blockIconsCommonactionsDateRangeNew,
    blockIconsCommonactionsErrorNew,
    blockIconsCommonactionsEventAvailableNew,
    blockIconsCommonactionsEventNew,
    blockIconsCommonactionsFingerprintNew,
    blockIconsCommonactionsHelpNew,
    blockIconsCommonactionsHistoryNew,
    blockIconsCommonactionsInfoNew,
    blockIconsCommonactionsLanguageNew,
    blockIconsCommonactionsLightbulbNew,
    blockIconsCommonactionsLockNew,
    blockIconsCommonactionsLockOpenNew,
    blockIconsCommonactionsManageAccountsNew,
    blockIconsCommonactionsNewReleasesNew,
    blockIconsCommonactionsPendingNew,
    blockIconsCommonactionsPreviewNew,
    blockIconsCommonactionsPriorityHighNew,
    blockIconsCommonactionsQuestionMarkNew,
    blockIconsCommonactionsScheduleNew,
    blockIconsCommonactionsStarsNew,
    blockIconsCommonactionsSupervisorAccountNew,
    blockIconsCommonactionsTaskAltNew,
    blockIconsCommonactionsTodayNew,
    blockIconsCommonactionsTouchAppNew,
    blockIconsCommonactionsTranslateNew,
    blockIconsCommonactionsUpdateNew,
    blockIconsCommonactionsUploadFileNew,
    blockIconsCommonactionsVerifiedNew,
    blockIconsCommonactionsVisibilityNew,
    blockIconsCommonactionsVisibilityOffNew,
    blockIconsCommonactionsWarningNew,
} from './common-actions-new';

// common-actions-new
const commonActionsNewIcons = [
    {
        name: 'blockIconsCommonactionsAccountBoxNew',
        title: __('Commonactions Account Box', 'block-icons-google'),
        icon: blockIconsCommonactionsAccountBoxNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsAccountCircleNew',
        title: __('Commonactions Account Circle', 'block-icons-google'),
        icon: blockIconsCommonactionsAccountCircleNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsAdsClickNew',
        title: __('Commonactions Ads Click', 'block-icons-google'),
        icon: blockIconsCommonactionsAdsClickNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsBookmarkNew',
        title: __('Commonactions Bookmark', 'block-icons-google'),
        icon: blockIconsCommonactionsBookmarkNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsBugReportNew',
        title: __('Commonactions Bug Report', 'block-icons-google'),
        icon: blockIconsCommonactionsBugReportNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsBuildNew',
        title: __('Commonactions Build', 'block-icons-google'),
        icon: blockIconsCommonactionsBuildNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsCalendarMonthNew',
        title: __('Commonactions Calendar Month', 'block-icons-google'),
        icon: blockIconsCommonactionsCalendarMonthNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsCalendarTodayNew',
        title: __('Commonactions Calendar Today', 'block-icons-google'),
        icon: blockIconsCommonactionsCalendarTodayNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsCategoryNew',
        title: __('Commonactions Category', 'block-icons-google'),
        icon: blockIconsCommonactionsCategoryNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsCelebrationNew',
        title: __('Commonactions Celebration', 'block-icons-google'),
        icon: blockIconsCommonactionsCelebrationNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsCodeNew',
        title: __('Commonactions Code', 'block-icons-google'),
        icon: blockIconsCommonactionsCodeNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsDateRangeNew',
        title: __('Commonactions Date Range', 'block-icons-google'),
        icon: blockIconsCommonactionsDateRangeNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsErrorNew',
        title: __('Commonactions Error', 'block-icons-google'),
        icon: blockIconsCommonactionsErrorNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsEventAvailableNew',
        title: __('Commonactions Event Available', 'block-icons-google'),
        icon: blockIconsCommonactionsEventAvailableNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsEventNew',
        title: __('Commonactions Event', 'block-icons-google'),
        icon: blockIconsCommonactionsEventNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsFingerprintNew',
        title: __('Commonactions Fingerprint', 'block-icons-google'),
        icon: blockIconsCommonactionsFingerprintNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsHelpNew',
        title: __('Commonactions Help', 'block-icons-google'),
        icon: blockIconsCommonactionsHelpNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsHistoryNew',
        title: __('Commonactions History', 'block-icons-google'),
        icon: blockIconsCommonactionsHistoryNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsInfoNew',
        title: __('Commonactions Info', 'block-icons-google'),
        icon: blockIconsCommonactionsInfoNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsLanguageNew',
        title: __('Commonactions Language', 'block-icons-google'),
        icon: blockIconsCommonactionsLanguageNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsLightbulbNew',
        title: __('Commonactions Lightbulb', 'block-icons-google'),
        icon: blockIconsCommonactionsLightbulbNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsLockNew',
        title: __('Commonactions Lock', 'block-icons-google'),
        icon: blockIconsCommonactionsLockNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsLockOpenNew',
        title: __('Commonactions Lock Open', 'block-icons-google'),
        icon: blockIconsCommonactionsLockOpenNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsManageAccountsNew',
        title: __('Commonactions Manage Accounts', 'block-icons-google'),
        icon: blockIconsCommonactionsManageAccountsNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsNewReleasesNew',
        title: __('Commonactions Releases', 'block-icons-google'),
        icon: blockIconsCommonactionsNewReleasesNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsPendingNew',
        title: __('Commonactions Pending', 'block-icons-google'),
        icon: blockIconsCommonactionsPendingNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsPreviewNew',
        title: __('Commonactions Preview', 'block-icons-google'),
        icon: blockIconsCommonactionsPreviewNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsPriorityHighNew',
        title: __('Commonactions Priority High', 'block-icons-google'),
        icon: blockIconsCommonactionsPriorityHighNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsQuestionMarkNew',
        title: __('Commonactions Question Mark', 'block-icons-google'),
        icon: blockIconsCommonactionsQuestionMarkNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsScheduleNew',
        title: __('Commonactions Schedule', 'block-icons-google'),
        icon: blockIconsCommonactionsScheduleNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsStarsNew',
        title: __('Commonactions Stars', 'block-icons-google'),
        icon: blockIconsCommonactionsStarsNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsSupervisorAccountNew',
        title: __('Commonactions Supervisor Account', 'block-icons-google'),
        icon: blockIconsCommonactionsSupervisorAccountNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsTaskAltNew',
        title: __('Commonactions Task Alt', 'block-icons-google'),
        icon: blockIconsCommonactionsTaskAltNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsTodayNew',
        title: __('Commonactions Today', 'block-icons-google'),
        icon: blockIconsCommonactionsTodayNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsTouchAppNew',
        title: __('Commonactions Touch App', 'block-icons-google'),
        icon: blockIconsCommonactionsTouchAppNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsTranslateNew',
        title: __('Commonactions Translate', 'block-icons-google'),
        icon: blockIconsCommonactionsTranslateNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsUpdateNew',
        title: __('Commonactions Update', 'block-icons-google'),
        icon: blockIconsCommonactionsUpdateNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsUploadFileNew',
        title: __('Commonactions Upload File', 'block-icons-google'),
        icon: blockIconsCommonactionsUploadFileNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsVerifiedNew',
        title: __('Commonactions Verified', 'block-icons-google'),
        icon: blockIconsCommonactionsVerifiedNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsVisibilityNew',
        title: __('Commonactions Visibility', 'block-icons-google'),
        icon: blockIconsCommonactionsVisibilityNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsVisibilityOffNew',
        title: __('Commonactions Visibility Off', 'block-icons-google'),
        icon: blockIconsCommonactionsVisibilityOffNew,
        categories: ['common-actions-new'],
    },
    {
        name: 'blockIconsCommonactionsWarningNew',
        title: __('Commonactions Warning', 'block-icons-google'),
        icon: blockIconsCommonactionsWarningNew,
        categories: ['common-actions-new'],
    },
];

// communication
import {
    blockIconsCommunicationAlternateEmail,
    blockIconsCommunicationAppRegistration,
    blockIconsCommunicationBusiness,
    blockIconsCommunicationCall,
    blockIconsCommunicationChatBubble,
    blockIconsCommunicationChatBubbleOutline,
    blockIconsCommunicationChat,
    blockIconsCommunicationComment,
    blockIconsCommunicationContactMail,
    blockIconsCommunicationContactPhone,
    blockIconsCommunicationContacts,
    blockIconsCommunicationEmail,
    blockIconsCommunicationForum,
    blockIconsCommunicationForwardToInbox,
    blockIconsCommunicationHourglassBottom,
    blockIconsCommunicationHourglassTop,
    blockIconsCommunicationHub,
    blockIconsCommunicationImportContacts,
    blockIconsCommunicationImportExport,
    blockIconsCommunicationKey,
    blockIconsCommunicationListAlt,
    blockIconsCommunicationLiveHelp,
    blockIconsCommunicationLocationOn,
    blockIconsCommunicationMailOutline,
    blockIconsCommunicationMarkEmailRead,
    blockIconsCommunicationMessage,
    blockIconsCommunicationPersonSearch,
    blockIconsCommunicationPhone,
    blockIconsCommunicationQrCode2,
    blockIconsCommunicationQrCode,
    blockIconsCommunicationQrCodeScanner,
    blockIconsCommunicationRssFeed,
    blockIconsCommunicationSentimentSatisfiedAlt,
    blockIconsCommunicationTextsms,
    blockIconsCommunicationVpnKey,
} from './communication';

// communication
const communicationIcons = [
    {
        name: 'blockIconsCommunicationAlternateEmail',
        title: __('Alternate Email', 'block-icons-google'),
        icon: blockIconsCommunicationAlternateEmail,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationAppRegistration',
        title: __('App Registration', 'block-icons-google'),
        icon: blockIconsCommunicationAppRegistration,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationBusiness',
        title: __('Business', 'block-icons-google'),
        icon: blockIconsCommunicationBusiness,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationCall',
        title: __('Call', 'block-icons-google'),
        icon: blockIconsCommunicationCall,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationChatBubble',
        title: __('Chat Bubble', 'block-icons-google'),
        icon: blockIconsCommunicationChatBubble,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationChatBubbleOutline',
        title: __('Chat Bubble Outline', 'block-icons-google'),
        icon: blockIconsCommunicationChatBubbleOutline,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationChat',
        title: __('Chat', 'block-icons-google'),
        icon: blockIconsCommunicationChat,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationComment',
        title: __('Comment', 'block-icons-google'),
        icon: blockIconsCommunicationComment,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationContactMail',
        title: __('Contact Mail', 'block-icons-google'),
        icon: blockIconsCommunicationContactMail,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationContactPhone',
        title: __('Contact Phone', 'block-icons-google'),
        icon: blockIconsCommunicationContactPhone,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationContacts',
        title: __('Contacts', 'block-icons-google'),
        icon: blockIconsCommunicationContacts,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationEmail',
        title: __('Email', 'block-icons-google'),
        icon: blockIconsCommunicationEmail,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationForum',
        title: __('Forum', 'block-icons-google'),
        icon: blockIconsCommunicationForum,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationForwardToInbox',
        title: __('Forward To Inbox', 'block-icons-google'),
        icon: blockIconsCommunicationForwardToInbox,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationHourglassBottom',
        title: __('Hourglass Bottom', 'block-icons-google'),
        icon: blockIconsCommunicationHourglassBottom,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationHourglassTop',
        title: __('Hourglass Top', 'block-icons-google'),
        icon: blockIconsCommunicationHourglassTop,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationHub',
        title: __('Hub', 'block-icons-google'),
        icon: blockIconsCommunicationHub,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationImportContacts',
        title: __('Import Contacts', 'block-icons-google'),
        icon: blockIconsCommunicationImportContacts,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationImportExport',
        title: __('Import Export', 'block-icons-google'),
        icon: blockIconsCommunicationImportExport,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationKey',
        title: __('Key', 'block-icons-google'),
        icon: blockIconsCommunicationKey,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationListAlt',
        title: __('List Alt', 'block-icons-google'),
        icon: blockIconsCommunicationListAlt,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationLiveHelp',
        title: __('Live Help', 'block-icons-google'),
        icon: blockIconsCommunicationLiveHelp,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationLocationOn',
        title: __('Location On', 'block-icons-google'),
        icon: blockIconsCommunicationLocationOn,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationMailOutline',
        title: __('Mail Outline', 'block-icons-google'),
        icon: blockIconsCommunicationMailOutline,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationMarkEmailRead',
        title: __('Mark Email Read', 'block-icons-google'),
        icon: blockIconsCommunicationMarkEmailRead,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationMessage',
        title: __('Message', 'block-icons-google'),
        icon: blockIconsCommunicationMessage,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationPersonSearch',
        title: __('Person Search', 'block-icons-google'),
        icon: blockIconsCommunicationPersonSearch,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationPhone',
        title: __('Phone', 'block-icons-google'),
        icon: blockIconsCommunicationPhone,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationQrCode2',
        title: __('Qr Code2', 'block-icons-google'),
        icon: blockIconsCommunicationQrCode2,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationQrCode',
        title: __('Qr Code', 'block-icons-google'),
        icon: blockIconsCommunicationQrCode,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationQrCodeScanner',
        title: __('Qr Code Scanner', 'block-icons-google'),
        icon: blockIconsCommunicationQrCodeScanner,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationRssFeed',
        title: __('Rss Feed', 'block-icons-google'),
        icon: blockIconsCommunicationRssFeed,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationSentimentSatisfiedAlt',
        title: __('Sentiment Satisfied Alt', 'block-icons-google'),
        icon: blockIconsCommunicationSentimentSatisfiedAlt,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationTextsms',
        title: __('Textsms', 'block-icons-google'),
        icon: blockIconsCommunicationTextsms,
        categories: ['communication'],
    },
    {
        name: 'blockIconsCommunicationVpnKey',
        title: __('Vpn Key', 'block-icons-google'),
        icon: blockIconsCommunicationVpnKey,
        categories: ['communication'],
    },
];

// communication-new
import {
    blockIconsCommunicationAddCommentNew,
    blockIconsCommunicationAlternateEmailNew,
    blockIconsCommunicationCalendarAddOnNew,
    blockIconsCommunicationCallNew,
    blockIconsCommunicationChatBubbleNew,
    blockIconsCommunicationChatNew,
    blockIconsCommunicationCommentNew,
    blockIconsCommunicationContactMailNew,
    blockIconsCommunicationContactPhoneNew,
    blockIconsCommunicationContactsNew,
    blockIconsCommunicationContactSupportNew,
    blockIconsCommunicationCoPresentNew,
    blockIconsCommunicationDraftsNew,
    blockIconsCommunicationForumNew,
    blockIconsCommunicationForwardToInboxNew,
    blockIconsCommunicationGTranslateNew,
    blockIconsCommunicationHourglassBottomNew,
    blockIconsCommunicationHourglassTopNew,
    blockIconsCommunicationHubNew,
    blockIconsCommunicationImportContactsNew,
    blockIconsCommunicationInboxNew,
    blockIconsCommunicationInventory2New,
    blockIconsCommunicationLanNew,
    blockIconsCommunicationLinkNew,
    blockIconsCommunicationLinkOffNew,
    blockIconsCommunicationLiveHelpNew,
    blockIconsCommunicationMailNew,
    blockIconsCommunicationMarkEmailReadNew,
    blockIconsCommunicationMarkEmailUnreadNew,
    blockIconsCommunicationModeCommentNew,
    blockIconsCommunicationNotificationsActiveNew,
    blockIconsCommunicationNotificationsNew,
    blockIconsCommunicationOutgoingMailNew,
    blockIconsCommunicationPermPhoneMsgNew,
    blockIconsCommunicationPersonSearchNew,
    blockIconsCommunicationPhoneEnabledNew,
    blockIconsCommunicationPhoneInTalkNew,
    blockIconsCommunicationPowerSettingsNewNew,
    blockIconsCommunicationReviewsNew,
    blockIconsCommunicationSendNew,
    blockIconsCommunicationSmsNew,
    blockIconsCommunicationSpeakerNotesNew,
} from './communication-new';

// communication-new
const communicationNewIcons = [
    {
        name: 'blockIconsCommunicationAddCommentNew',
        title: __('Add Comment', 'block-icons-google'),
        icon: blockIconsCommunicationAddCommentNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationAlternateEmailNew',
        title: __('Alternate Email', 'block-icons-google'),
        icon: blockIconsCommunicationAlternateEmailNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationCalendarAddOnNew',
        title: __('Calendar Add On', 'block-icons-google'),
        icon: blockIconsCommunicationCalendarAddOnNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationCallNew',
        title: __('Call', 'block-icons-google'),
        icon: blockIconsCommunicationCallNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationChatBubbleNew',
        title: __('Chat Bubble', 'block-icons-google'),
        icon: blockIconsCommunicationChatBubbleNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationChatNew',
        title: __('Chat', 'block-icons-google'),
        icon: blockIconsCommunicationChatNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationCommentNew',
        title: __('Comment', 'block-icons-google'),
        icon: blockIconsCommunicationCommentNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationContactMailNew',
        title: __('Contact Mail', 'block-icons-google'),
        icon: blockIconsCommunicationContactMailNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationContactPhoneNew',
        title: __('Contact Phone', 'block-icons-google'),
        icon: blockIconsCommunicationContactPhoneNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationContactsNew',
        title: __('Contacts', 'block-icons-google'),
        icon: blockIconsCommunicationContactsNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationContactSupportNew',
        title: __('Contact Support', 'block-icons-google'),
        icon: blockIconsCommunicationContactSupportNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationCoPresentNew',
        title: __('Co Present', 'block-icons-google'),
        icon: blockIconsCommunicationCoPresentNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationDraftsNew',
        title: __('Drafts', 'block-icons-google'),
        icon: blockIconsCommunicationDraftsNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationForumNew',
        title: __('Forum', 'block-icons-google'),
        icon: blockIconsCommunicationForumNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationForwardToInboxNew',
        title: __('Forward To Inbox', 'block-icons-google'),
        icon: blockIconsCommunicationForwardToInboxNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationGTranslateNew',
        title: __('GTranslate', 'block-icons-google'),
        icon: blockIconsCommunicationGTranslateNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationHourglassBottomNew',
        title: __('Hourglass Bottom', 'block-icons-google'),
        icon: blockIconsCommunicationHourglassBottomNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationHourglassTopNew',
        title: __('Hourglass Top', 'block-icons-google'),
        icon: blockIconsCommunicationHourglassTopNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationHubNew',
        title: __('Hub', 'block-icons-google'),
        icon: blockIconsCommunicationHubNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationImportContactsNew',
        title: __('Import Contacts', 'block-icons-google'),
        icon: blockIconsCommunicationImportContactsNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationInboxNew',
        title: __('Inbox', 'block-icons-google'),
        icon: blockIconsCommunicationInboxNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationInventory2New',
        title: __('Inventory2', 'block-icons-google'),
        icon: blockIconsCommunicationInventory2New,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationLanNew',
        title: __('Lan', 'block-icons-google'),
        icon: blockIconsCommunicationLanNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationLinkNew',
        title: __('Link', 'block-icons-google'),
        icon: blockIconsCommunicationLinkNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationLinkOffNew',
        title: __('Link Off', 'block-icons-google'),
        icon: blockIconsCommunicationLinkOffNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationLiveHelpNew',
        title: __('Live Help', 'block-icons-google'),
        icon: blockIconsCommunicationLiveHelpNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationMailNew',
        title: __('Mail', 'block-icons-google'),
        icon: blockIconsCommunicationMailNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationMarkEmailReadNew',
        title: __('Mark Email Read', 'block-icons-google'),
        icon: blockIconsCommunicationMarkEmailReadNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationMarkEmailUnreadNew',
        title: __('Mark Email Unread', 'block-icons-google'),
        icon: blockIconsCommunicationMarkEmailUnreadNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationModeCommentNew',
        title: __('Mode Comment', 'block-icons-google'),
        icon: blockIconsCommunicationModeCommentNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationNotificationsActiveNew',
        title: __('Notifications Active', 'block-icons-google'),
        icon: blockIconsCommunicationNotificationsActiveNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationNotificationsNew',
        title: __('Notifications', 'block-icons-google'),
        icon: blockIconsCommunicationNotificationsNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationOutgoingMailNew',
        title: __('Outgoing Mail', 'block-icons-google'),
        icon: blockIconsCommunicationOutgoingMailNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationPermPhoneMsgNew',
        title: __('Perm Phone Msg', 'block-icons-google'),
        icon: blockIconsCommunicationPermPhoneMsgNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationPersonSearchNew',
        title: __('Person Search', 'block-icons-google'),
        icon: blockIconsCommunicationPersonSearchNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationPhoneEnabledNew',
        title: __('Phone Enabled', 'block-icons-google'),
        icon: blockIconsCommunicationPhoneEnabledNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationPhoneInTalkNew',
        title: __('Phone In Talk', 'block-icons-google'),
        icon: blockIconsCommunicationPhoneInTalkNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationPowerSettingsNewNew',
        title: __('Power Settings', 'block-icons-google'),
        icon: blockIconsCommunicationPowerSettingsNewNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationReviewsNew',
        title: __('Reviews', 'block-icons-google'),
        icon: blockIconsCommunicationReviewsNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationSendNew',
        title: __('Send', 'block-icons-google'),
        icon: blockIconsCommunicationSendNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationSmsNew',
        title: __('Sms', 'block-icons-google'),
        icon: blockIconsCommunicationSmsNew,
        categories: ['communication-new'],
    },
    {
        name: 'blockIconsCommunicationSpeakerNotesNew',
        title: __('Speaker Notes', 'block-icons-google'),
        icon: blockIconsCommunicationSpeakerNotesNew,
        categories: ['communication-new'],
    },
];

// content
import {
    blockIconsContentAddBox,
    blockIconsContentAddCircle,
    blockIconsContentAddCircleOutline,
    blockIconsContentAdd,
    blockIconsContentArchive,
    blockIconsContentBackspace,
    blockIconsContentBlock,
    blockIconsContentBolt,
    blockIconsContentCalculate,
    blockIconsContentClear,
    blockIconsContentContentCopy,
    blockIconsContentContentPaste,
    blockIconsContentCreate,
    blockIconsContentFileCopy,
    blockIconsContentFilterList,
    blockIconsContentFlag,
    blockIconsContentHowToReg,
    blockIconsContentInsights,
    blockIconsContentInventory2,
    blockIconsContentInventory,
    blockIconsContentLink,
    blockIconsContentMail,
    blockIconsContentPolicy,
    blockIconsContentPushPin,
    blockIconsContentRemoveCircle,
    blockIconsContentRemoveCircleOutline,
    blockIconsContentRemove,
    blockIconsContentReply,
    blockIconsContentReport,
    blockIconsContentSaveAlt,
    blockIconsContentSave,
    blockIconsContentSend,
    blockIconsContentShield,
    blockIconsContentSort,
    blockIconsContentUndo,
} from './content';

// content
const contentIcons = [
    {
        name: 'blockIconsContentAddBox',
        title: __('Add Box', 'block-icons-google'),
        icon: blockIconsContentAddBox,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentAddCircle',
        title: __('Add Circle', 'block-icons-google'),
        icon: blockIconsContentAddCircle,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentAddCircleOutline',
        title: __('Add Circle Outline', 'block-icons-google'),
        icon: blockIconsContentAddCircleOutline,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentAdd',
        title: __('Add', 'block-icons-google'),
        icon: blockIconsContentAdd,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentArchive',
        title: __('Archive', 'block-icons-google'),
        icon: blockIconsContentArchive,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentBackspace',
        title: __('Backspace', 'block-icons-google'),
        icon: blockIconsContentBackspace,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentBlock',
        title: __('Block', 'block-icons-google'),
        icon: blockIconsContentBlock,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentBolt',
        title: __('Bolt', 'block-icons-google'),
        icon: blockIconsContentBolt,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentCalculate',
        title: __('Calculate', 'block-icons-google'),
        icon: blockIconsContentCalculate,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentClear',
        title: __('Clear', 'block-icons-google'),
        icon: blockIconsContentClear,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentContentCopy',
        title: __('Copy', 'block-icons-google'),
        icon: blockIconsContentContentCopy,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentContentPaste',
        title: __('Paste', 'block-icons-google'),
        icon: blockIconsContentContentPaste,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentCreate',
        title: __('Create', 'block-icons-google'),
        icon: blockIconsContentCreate,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentFileCopy',
        title: __('File Copy', 'block-icons-google'),
        icon: blockIconsContentFileCopy,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentFilterList',
        title: __('Filter List', 'block-icons-google'),
        icon: blockIconsContentFilterList,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentFlag',
        title: __('Flag', 'block-icons-google'),
        icon: blockIconsContentFlag,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentHowToReg',
        title: __('How To Reg', 'block-icons-google'),
        icon: blockIconsContentHowToReg,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentInsights',
        title: __('Insights', 'block-icons-google'),
        icon: blockIconsContentInsights,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentInventory2',
        title: __('Inventory2', 'block-icons-google'),
        icon: blockIconsContentInventory2,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentInventory',
        title: __('Inventory', 'block-icons-google'),
        icon: blockIconsContentInventory,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentLink',
        title: __('Link', 'block-icons-google'),
        icon: blockIconsContentLink,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentMail',
        title: __('Mail', 'block-icons-google'),
        icon: blockIconsContentMail,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentPolicy',
        title: __('Policy', 'block-icons-google'),
        icon: blockIconsContentPolicy,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentPushPin',
        title: __('Push Pin', 'block-icons-google'),
        icon: blockIconsContentPushPin,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentRemoveCircle',
        title: __('Remove Circle', 'block-icons-google'),
        icon: blockIconsContentRemoveCircle,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentRemoveCircleOutline',
        title: __('Remove Circle Outline', 'block-icons-google'),
        icon: blockIconsContentRemoveCircleOutline,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentRemove',
        title: __('Remove', 'block-icons-google'),
        icon: blockIconsContentRemove,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentReply',
        title: __('Reply', 'block-icons-google'),
        icon: blockIconsContentReply,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentReport',
        title: __('Report', 'block-icons-google'),
        icon: blockIconsContentReport,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentSaveAlt',
        title: __('Save Alt', 'block-icons-google'),
        icon: blockIconsContentSaveAlt,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentSave',
        title: __('Save', 'block-icons-google'),
        icon: blockIconsContentSave,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentSend',
        title: __('Send', 'block-icons-google'),
        icon: blockIconsContentSend,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentShield',
        title: __('Shield', 'block-icons-google'),
        icon: blockIconsContentShield,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentSort',
        title: __('Sort', 'block-icons-google'),
        icon: blockIconsContentSort,
        categories: ['content'],
    },
    {
        name: 'blockIconsContentUndo',
        title: __('Undo', 'block-icons-google'),
        icon: blockIconsContentUndo,
        categories: ['content'],
    },
];

// device
import {
    blockIconsDeviceAccessTime,
    blockIconsDeviceAir,
    blockIconsDeviceBatteryChargingFull,
    blockIconsDeviceBatteryFull,
    blockIconsDeviceBluetooth,
    blockIconsDeviceCreditScore,
    blockIconsDeviceDarkMode,
    blockIconsDeviceDevices,
    blockIconsDeviceDvr,
    blockIconsDeviceFmdGood,
    blockIconsDeviceGppGood,
    blockIconsDeviceGpsFixed,
    blockIconsDeviceGraphicEq,
    blockIconsDeviceLightMode,
    blockIconsDeviceMedication,
    blockIconsDeviceMonitorHeart,
    blockIconsDeviceNightlight,
    blockIconsDeviceNoteAlt,
    blockIconsDevicePassword,
    blockIconsDevicePin,
    blockIconsDevicePriceChange,
    blockIconsDevicePriceCheck,
    blockIconsDeviceQuiz,
    blockIconsDeviceRestartAlt,
    blockIconsDeviceReviews,
    blockIconsDeviceSell,
    blockIconsDeviceSettingsSuggest,
    blockIconsDeviceSignalCellularAlt,
    blockIconsDeviceSportsScore,
    blockIconsDeviceStorage,
    blockIconsDeviceSummarize,
    blockIconsDeviceTask,
    blockIconsDeviceThermostat,
    blockIconsDeviceTungsten,
    blockIconsDeviceWidgets,
} from './device';

// device
const deviceIcons = [
    {
        name: 'blockIconsDeviceAccessTime',
        title: __('Access Time', 'block-icons-google'),
        icon: blockIconsDeviceAccessTime,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceAir',
        title: __('Air', 'block-icons-google'),
        icon: blockIconsDeviceAir,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceBatteryChargingFull',
        title: __('Battery Charging Full', 'block-icons-google'),
        icon: blockIconsDeviceBatteryChargingFull,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceBatteryFull',
        title: __('Battery Full', 'block-icons-google'),
        icon: blockIconsDeviceBatteryFull,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceBluetooth',
        title: __('Bluetooth', 'block-icons-google'),
        icon: blockIconsDeviceBluetooth,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceCreditScore',
        title: __('Credit Score', 'block-icons-google'),
        icon: blockIconsDeviceCreditScore,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceDarkMode',
        title: __('Dark Mode', 'block-icons-google'),
        icon: blockIconsDeviceDarkMode,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceDevices',
        title: __('s', 'block-icons-google'),
        icon: blockIconsDeviceDevices,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceDvr',
        title: __('Dvr', 'block-icons-google'),
        icon: blockIconsDeviceDvr,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceFmdGood',
        title: __('Fmd Good', 'block-icons-google'),
        icon: blockIconsDeviceFmdGood,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceGppGood',
        title: __('Gpp Good', 'block-icons-google'),
        icon: blockIconsDeviceGppGood,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceGpsFixed',
        title: __('Gps Fixed', 'block-icons-google'),
        icon: blockIconsDeviceGpsFixed,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceGraphicEq',
        title: __('Graphic Eq', 'block-icons-google'),
        icon: blockIconsDeviceGraphicEq,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceLightMode',
        title: __('Light Mode', 'block-icons-google'),
        icon: blockIconsDeviceLightMode,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceMedication',
        title: __('Medication', 'block-icons-google'),
        icon: blockIconsDeviceMedication,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceMonitorHeart',
        title: __('Monitor Heart', 'block-icons-google'),
        icon: blockIconsDeviceMonitorHeart,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceNightlight',
        title: __('Nightlight', 'block-icons-google'),
        icon: blockIconsDeviceNightlight,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceNoteAlt',
        title: __('Note Alt', 'block-icons-google'),
        icon: blockIconsDeviceNoteAlt,
        categories: ['device'],
    },
    {
        name: 'blockIconsDevicePassword',
        title: __('Password', 'block-icons-google'),
        icon: blockIconsDevicePassword,
        categories: ['device'],
    },
    {
        name: 'blockIconsDevicePin',
        title: __('Pin', 'block-icons-google'),
        icon: blockIconsDevicePin,
        categories: ['device'],
    },
    {
        name: 'blockIconsDevicePriceChange',
        title: __('Price Change', 'block-icons-google'),
        icon: blockIconsDevicePriceChange,
        categories: ['device'],
    },
    {
        name: 'blockIconsDevicePriceCheck',
        title: __('Price Check', 'block-icons-google'),
        icon: blockIconsDevicePriceCheck,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceQuiz',
        title: __('Quiz', 'block-icons-google'),
        icon: blockIconsDeviceQuiz,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceRestartAlt',
        title: __('Restart Alt', 'block-icons-google'),
        icon: blockIconsDeviceRestartAlt,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceReviews',
        title: __('Reviews', 'block-icons-google'),
        icon: blockIconsDeviceReviews,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceSell',
        title: __('Sell', 'block-icons-google'),
        icon: blockIconsDeviceSell,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceSettingsSuggest',
        title: __('Settings Suggest', 'block-icons-google'),
        icon: blockIconsDeviceSettingsSuggest,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceSignalCellularAlt',
        title: __('Signal Cellular Alt', 'block-icons-google'),
        icon: blockIconsDeviceSignalCellularAlt,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceSportsScore',
        title: __('Sports Score', 'block-icons-google'),
        icon: blockIconsDeviceSportsScore,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceStorage',
        title: __('Storage', 'block-icons-google'),
        icon: blockIconsDeviceStorage,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceSummarize',
        title: __('Summarize', 'block-icons-google'),
        icon: blockIconsDeviceSummarize,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceTask',
        title: __('Task', 'block-icons-google'),
        icon: blockIconsDeviceTask,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceThermostat',
        title: __('Thermostat', 'block-icons-google'),
        icon: blockIconsDeviceThermostat,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceTungsten',
        title: __('Tungsten', 'block-icons-google'),
        icon: blockIconsDeviceTungsten,
        categories: ['device'],
    },
    {
        name: 'blockIconsDeviceWidgets',
        title: __('Widgets', 'block-icons-google'),
        icon: blockIconsDeviceWidgets,
        categories: ['device'],
    },
];

// editor
import {
    blockIconsEditorAttachFile,
    blockIconsEditorAttachMoney,
    blockIconsEditorAutoGraph,
    blockIconsEditorBarChart,
    blockIconsEditorBorderColor,
    blockIconsEditorChecklist,
    blockIconsEditorChecklistRtl,
    blockIconsEditorDragHandle,
    blockIconsEditorDraw,
    blockIconsEditorEditNote,
    blockIconsEditorFormatBold,
    blockIconsEditorFormatListBulleted,
    blockIconsEditorFormatListNumbered,
    blockIconsEditorFormatQuote,
    blockIconsEditorFunctions,
    blockIconsEditorInsertChartOutlined,
    blockIconsEditorInsertDriveFile,
    blockIconsEditorInsertEmoticon,
    blockIconsEditorInsertLink,
    blockIconsEditorInsertPhoto,
    blockIconsEditorModeComment,
    blockIconsEditorModeEdit,
    blockIconsEditorModeEditOutline,
    blockIconsEditorMode,
    blockIconsEditorMonetizationOn,
    blockIconsEditorNotes,
    blockIconsEditorPieChart,
    blockIconsEditorPostAdd,
    blockIconsEditorPublish,
    blockIconsEditorQueryStats,
    blockIconsEditorShowChart,
    blockIconsEditorTableChart,
    blockIconsEditorTableRows,
    blockIconsEditorTextFields,
    blockIconsEditorTitle,
} from './editor';

// editor
const editorIcons = [
    {
        name: 'blockIconsEditorAttachFile',
        title: __('Attach File', 'block-icons-google'),
        icon: blockIconsEditorAttachFile,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorAttachMoney',
        title: __('Attach Money', 'block-icons-google'),
        icon: blockIconsEditorAttachMoney,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorAutoGraph',
        title: __('Auto Graph', 'block-icons-google'),
        icon: blockIconsEditorAutoGraph,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorBarChart',
        title: __('Bar Chart', 'block-icons-google'),
        icon: blockIconsEditorBarChart,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorBorderColor',
        title: __('Border Color', 'block-icons-google'),
        icon: blockIconsEditorBorderColor,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorChecklist',
        title: __('Checklist', 'block-icons-google'),
        icon: blockIconsEditorChecklist,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorChecklistRtl',
        title: __('Checklist Rtl', 'block-icons-google'),
        icon: blockIconsEditorChecklistRtl,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorDragHandle',
        title: __('Drag Handle', 'block-icons-google'),
        icon: blockIconsEditorDragHandle,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorDraw',
        title: __('Draw', 'block-icons-google'),
        icon: blockIconsEditorDraw,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorEditNote',
        title: __('Edit Note', 'block-icons-google'),
        icon: blockIconsEditorEditNote,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorFormatBold',
        title: __('Format Bold', 'block-icons-google'),
        icon: blockIconsEditorFormatBold,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorFormatListBulleted',
        title: __('Format List Bulleted', 'block-icons-google'),
        icon: blockIconsEditorFormatListBulleted,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorFormatListNumbered',
        title: __('Format List Numbered', 'block-icons-google'),
        icon: blockIconsEditorFormatListNumbered,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorFormatQuote',
        title: __('Format Quote', 'block-icons-google'),
        icon: blockIconsEditorFormatQuote,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorFunctions',
        title: __('Functions', 'block-icons-google'),
        icon: blockIconsEditorFunctions,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorInsertChartOutlined',
        title: __('Insert Chart Outlined', 'block-icons-google'),
        icon: blockIconsEditorInsertChartOutlined,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorInsertDriveFile',
        title: __('Insert Drive File', 'block-icons-google'),
        icon: blockIconsEditorInsertDriveFile,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorInsertEmoticon',
        title: __('Insert Emoticon', 'block-icons-google'),
        icon: blockIconsEditorInsertEmoticon,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorInsertLink',
        title: __('Insert Link', 'block-icons-google'),
        icon: blockIconsEditorInsertLink,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorInsertPhoto',
        title: __('Insert Photo', 'block-icons-google'),
        icon: blockIconsEditorInsertPhoto,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorModeComment',
        title: __('Mode Comment', 'block-icons-google'),
        icon: blockIconsEditorModeComment,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorModeEdit',
        title: __('Mode Edit', 'block-icons-google'),
        icon: blockIconsEditorModeEdit,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorModeEditOutline',
        title: __('Mode Edit Outline', 'block-icons-google'),
        icon: blockIconsEditorModeEditOutline,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorMode',
        title: __('Mode', 'block-icons-google'),
        icon: blockIconsEditorMode,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorMonetizationOn',
        title: __('Monetization On', 'block-icons-google'),
        icon: blockIconsEditorMonetizationOn,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorNotes',
        title: __('Notes', 'block-icons-google'),
        icon: blockIconsEditorNotes,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorPieChart',
        title: __('Pie Chart', 'block-icons-google'),
        icon: blockIconsEditorPieChart,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorPostAdd',
        title: __('Post Add', 'block-icons-google'),
        icon: blockIconsEditorPostAdd,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorPublish',
        title: __('Publish', 'block-icons-google'),
        icon: blockIconsEditorPublish,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorQueryStats',
        title: __('Query Stats', 'block-icons-google'),
        icon: blockIconsEditorQueryStats,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorShowChart',
        title: __('Show Chart', 'block-icons-google'),
        icon: blockIconsEditorShowChart,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorTableChart',
        title: __('Table Chart', 'block-icons-google'),
        icon: blockIconsEditorTableChart,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorTableRows',
        title: __('Table Rows', 'block-icons-google'),
        icon: blockIconsEditorTableRows,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorTextFields',
        title: __('Text Fields', 'block-icons-google'),
        icon: blockIconsEditorTextFields,
        categories: ['editor'],
    },
    {
        name: 'blockIconsEditorTitle',
        title: __('Title', 'block-icons-google'),
        icon: blockIconsEditorTitle,
        categories: ['editor'],
    },
];

// file
import {
    blockIconsFileApproval,
    blockIconsFileAttachEmail,
    blockIconsFileAttachment,
    blockIconsFileCloudDone,
    blockIconsFileCloudDownload,
    blockIconsFileCloud,
    blockIconsFileCloudOff,
    blockIconsFileCloudQueue,
    blockIconsFileCloudSync,
    blockIconsFileCloudUpload,
    blockIconsFileCreateNewFolder,
    blockIconsFileDownloadDone,
    blockIconsFileDownloadForOffline,
    blockIconsFileDownloading,
    blockIconsFileDownload,
    blockIconsFileDriveFileMove,
    blockIconsFileDriveFileRenameOutline,
    blockIconsFileDriveFolderUpload,
    blockIconsFileFileDownloadDone,
    blockIconsFileFileDownload,
    blockIconsFileFileOpen,
    blockIconsFileFileUpload,
    blockIconsFileFolder,
    blockIconsFileFolderOpen,
    blockIconsFileFolderShared,
    blockIconsFileFolderZip,
    blockIconsFileGridView,
    blockIconsFileNewspaper,
    blockIconsFileRequestQuote,
    blockIconsFileRuleFolder,
    blockIconsFileTextSnippet,
    blockIconsFileTopic,
    blockIconsFileUploadFile,
    blockIconsFileUpload,
    blockIconsFileWorkspaces,
} from './file';

// file
const fileIcons = [
    {
        name: 'blockIconsFileApproval',
        title: __('Approval', 'block-icons-google'),
        icon: blockIconsFileApproval,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileAttachEmail',
        title: __('Attach Email', 'block-icons-google'),
        icon: blockIconsFileAttachEmail,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileAttachment',
        title: __('Attachment', 'block-icons-google'),
        icon: blockIconsFileAttachment,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileCloudDone',
        title: __('Cloud Done', 'block-icons-google'),
        icon: blockIconsFileCloudDone,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileCloudDownload',
        title: __('Cloud Download', 'block-icons-google'),
        icon: blockIconsFileCloudDownload,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileCloud',
        title: __('Cloud', 'block-icons-google'),
        icon: blockIconsFileCloud,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileCloudOff',
        title: __('Cloud Off', 'block-icons-google'),
        icon: blockIconsFileCloudOff,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileCloudQueue',
        title: __('Cloud Queue', 'block-icons-google'),
        icon: blockIconsFileCloudQueue,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileCloudSync',
        title: __('Cloud Sync', 'block-icons-google'),
        icon: blockIconsFileCloudSync,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileCloudUpload',
        title: __('Cloud Upload', 'block-icons-google'),
        icon: blockIconsFileCloudUpload,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileCreateNewFolder',
        title: __('Create Folder', 'block-icons-google'),
        icon: blockIconsFileCreateNewFolder,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileDownloadDone',
        title: __('Download Done', 'block-icons-google'),
        icon: blockIconsFileDownloadDone,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileDownloadForOffline',
        title: __('Download For Offline', 'block-icons-google'),
        icon: blockIconsFileDownloadForOffline,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileDownloading',
        title: __('Downloading', 'block-icons-google'),
        icon: blockIconsFileDownloading,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileDownload',
        title: __('Download', 'block-icons-google'),
        icon: blockIconsFileDownload,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileDriveFileMove',
        title: __('Drive Move', 'block-icons-google'),
        icon: blockIconsFileDriveFileMove,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileDriveFileRenameOutline',
        title: __('Drive Rename Outline', 'block-icons-google'),
        icon: blockIconsFileDriveFileRenameOutline,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileDriveFolderUpload',
        title: __('Drive Folder Upload', 'block-icons-google'),
        icon: blockIconsFileDriveFolderUpload,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileFileDownloadDone',
        title: __('Download Done', 'block-icons-google'),
        icon: blockIconsFileFileDownloadDone,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileFileDownload',
        title: __('Download', 'block-icons-google'),
        icon: blockIconsFileFileDownload,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileFileOpen',
        title: __('Open', 'block-icons-google'),
        icon: blockIconsFileFileOpen,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileFileUpload',
        title: __('Upload', 'block-icons-google'),
        icon: blockIconsFileFileUpload,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileFolder',
        title: __('Folder', 'block-icons-google'),
        icon: blockIconsFileFolder,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileFolderOpen',
        title: __('Folder Open', 'block-icons-google'),
        icon: blockIconsFileFolderOpen,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileFolderShared',
        title: __('Folder Shared', 'block-icons-google'),
        icon: blockIconsFileFolderShared,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileFolderZip',
        title: __('Folder Zip', 'block-icons-google'),
        icon: blockIconsFileFolderZip,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileGridView',
        title: __('Grid View', 'block-icons-google'),
        icon: blockIconsFileGridView,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileNewspaper',
        title: __('spaper', 'block-icons-google'),
        icon: blockIconsFileNewspaper,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileRequestQuote',
        title: __('Request Quote', 'block-icons-google'),
        icon: blockIconsFileRequestQuote,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileRuleFolder',
        title: __('Rule Folder', 'block-icons-google'),
        icon: blockIconsFileRuleFolder,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileTextSnippet',
        title: __('Text Snippet', 'block-icons-google'),
        icon: blockIconsFileTextSnippet,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileTopic',
        title: __('Topic', 'block-icons-google'),
        icon: blockIconsFileTopic,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileUploadFile',
        title: __('Upload', 'block-icons-google'),
        icon: blockIconsFileUploadFile,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileUpload',
        title: __('Upload', 'block-icons-google'),
        icon: blockIconsFileUpload,
        categories: ['file'],
    },
    {
        name: 'blockIconsFileWorkspaces',
        title: __('Workspaces', 'block-icons-google'),
        icon: blockIconsFileWorkspaces,
        categories: ['file'],
    },
];

// hardware
import {
    blockIconsHardwareCastForEducation,
    blockIconsHardwareComputer,
    blockIconsHardwareDesktopWindows,
    blockIconsHardwareDeveloperBoard,
    blockIconsHardwareDeviceHub,
    blockIconsHardwareHeadphones,
    blockIconsHardwareHeadset,
    blockIconsHardwareHeadsetMic,
    blockIconsHardwareKeyboardArrowDown,
    blockIconsHardwareKeyboardArrowLeft,
    blockIconsHardwareKeyboardArrowRight,
    blockIconsHardwareKeyboardArrowUp,
    blockIconsHardwareKeyboardBackspace,
    blockIconsHardwareKeyboardDoubleArrowDown,
    blockIconsHardwareKeyboardDoubleArrowLeft,
    blockIconsHardwareKeyboardDoubleArrowRight,
    blockIconsHardwareKeyboardDoubleArrowUp,
    blockIconsHardwareKeyboard,
    blockIconsHardwareKeyboardReturn,
    blockIconsHardwareKeyboardVoice,
    blockIconsHardwareLaptop,
    blockIconsHardwareLaptopMac,
    blockIconsHardwareMemory,
    blockIconsHardwareMouse,
    blockIconsHardwarePhoneAndroid,
    blockIconsHardwarePhoneiPhone,
    blockIconsHardwarePointOfSale,
    blockIconsHardwareRouter,
    blockIconsHardwareSecurity,
    blockIconsHardwareSmartDisplay,
    blockIconsHardwareSmartphone,
    blockIconsHardwareSmartToy,
    blockIconsHardwareStart,
    blockIconsHardwareTv,
    blockIconsHardwareVideogameAsset,
} from './hardware';

// hardware
const hardwareIcons = [
    {
        name: 'blockIconsHardwareCastForEducation',
        title: __('Cast For Education', 'block-icons-google'),
        icon: blockIconsHardwareCastForEducation,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareComputer',
        title: __('Computer', 'block-icons-google'),
        icon: blockIconsHardwareComputer,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareDesktopWindows',
        title: __('Desktop Windows', 'block-icons-google'),
        icon: blockIconsHardwareDesktopWindows,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareDeveloperBoard',
        title: __('Developer Board', 'block-icons-google'),
        icon: blockIconsHardwareDeveloperBoard,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareDeviceHub',
        title: __('Device Hub', 'block-icons-google'),
        icon: blockIconsHardwareDeviceHub,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareHeadphones',
        title: __('Headphones', 'block-icons-google'),
        icon: blockIconsHardwareHeadphones,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareHeadset',
        title: __('Headset', 'block-icons-google'),
        icon: blockIconsHardwareHeadset,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareHeadsetMic',
        title: __('Headset Mic', 'block-icons-google'),
        icon: blockIconsHardwareHeadsetMic,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareKeyboardArrowDown',
        title: __('Keyboard Arrow Down', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardArrowDown,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareKeyboardArrowLeft',
        title: __('Keyboard Arrow Left', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardArrowLeft,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareKeyboardArrowRight',
        title: __('Keyboard Arrow Right', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardArrowRight,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareKeyboardArrowUp',
        title: __('Keyboard Arrow Up', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardArrowUp,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareKeyboardBackspace',
        title: __('Keyboard Backspace', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardBackspace,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareKeyboardDoubleArrowDown',
        title: __('Keyboard Double Arrow Down', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardDoubleArrowDown,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareKeyboardDoubleArrowLeft',
        title: __('Keyboard Double Arrow Left', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardDoubleArrowLeft,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareKeyboardDoubleArrowRight',
        title: __('Keyboard Double Arrow Right', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardDoubleArrowRight,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareKeyboardDoubleArrowUp',
        title: __('Keyboard Double Arrow Up', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardDoubleArrowUp,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareKeyboard',
        title: __('Keyboard', 'block-icons-google'),
        icon: blockIconsHardwareKeyboard,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareKeyboardReturn',
        title: __('Keyboard Return', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardReturn,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareKeyboardVoice',
        title: __('Keyboard Voice', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardVoice,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareLaptop',
        title: __('Laptop', 'block-icons-google'),
        icon: blockIconsHardwareLaptop,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareLaptopMac',
        title: __('Laptop Mac', 'block-icons-google'),
        icon: blockIconsHardwareLaptopMac,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareMemory',
        title: __('Memory', 'block-icons-google'),
        icon: blockIconsHardwareMemory,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareMouse',
        title: __('Mouse', 'block-icons-google'),
        icon: blockIconsHardwareMouse,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwarePhoneAndroid',
        title: __('Phone Android', 'block-icons-google'),
        icon: blockIconsHardwarePhoneAndroid,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwarePhoneiPhone',
        title: __('Phonei Phone', 'block-icons-google'),
        icon: blockIconsHardwarePhoneiPhone,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwarePointOfSale',
        title: __('Point Of Sale', 'block-icons-google'),
        icon: blockIconsHardwarePointOfSale,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareRouter',
        title: __('Router', 'block-icons-google'),
        icon: blockIconsHardwareRouter,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareSecurity',
        title: __('Security', 'block-icons-google'),
        icon: blockIconsHardwareSecurity,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareSmartDisplay',
        title: __('Smart Display', 'block-icons-google'),
        icon: blockIconsHardwareSmartDisplay,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareSmartphone',
        title: __('Smartphone', 'block-icons-google'),
        icon: blockIconsHardwareSmartphone,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareSmartToy',
        title: __('Smart Toy', 'block-icons-google'),
        icon: blockIconsHardwareSmartToy,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareStart',
        title: __('Start', 'block-icons-google'),
        icon: blockIconsHardwareStart,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareTv',
        title: __('Tv', 'block-icons-google'),
        icon: blockIconsHardwareTv,
        categories: ['hardware'],
    },
    {
        name: 'blockIconsHardwareVideogameAsset',
        title: __('Videogame Asset', 'block-icons-google'),
        icon: blockIconsHardwareVideogameAsset,
        categories: ['hardware'],
    },
];

// hardware-new
import {
    blockIconsHardwareBalanceNew,
    blockIconsHardwareBookOnlineNew,
    blockIconsHardwareCastNew,
    blockIconsHardwareComputerNew,
    blockIconsHardwareDesktopWindowsNew,
    blockIconsHardwareDeveloperBoardNew,
    blockIconsHardwareDeveloperModeNew,
    blockIconsHardwareDevicesNew,
    blockIconsHardwareDeviceThermostatNew,
    blockIconsHardwareDisplaySettingsNew,
    blockIconsHardwareDnsNew,
    blockIconsHardwareFaxNew,
    blockIconsHardwareHeadphonesNew,
    blockIconsHardwareHeadsetMicNew,
    blockIconsHardwareKeyboardArrowDownNew,
    blockIconsHardwareKeyboardArrowLeftNew,
    blockIconsHardwareKeyboardArrowRightNew,
    blockIconsHardwareKeyboardArrowUpNew,
    blockIconsHardwareKeyboardBackspaceNew,
    blockIconsHardwareKeyboardNew,
    blockIconsHardwareKeyboardReturnNew,
    blockIconsHardwareLaptopChromebookNew,
    blockIconsHardwareLaptopMacNew,
    blockIconsHardwareLaptopWindowsNew,
    blockIconsHardwareLiveTvNew,
    blockIconsHardwareMemoryNew,
    blockIconsHardwareMouseNew,
    blockIconsHardwarePhoneAndroidNew,
    blockIconsHardwarePhoneiPhoneNew,
    blockIconsHardwarePointOfSaleNew,
    blockIconsHardwarePowerNew,
    blockIconsHardwarePrintNew,
    blockIconsHardwareRouteNew,
    blockIconsHardwareRouterNew,
    blockIconsHardwareSaveNew,
    blockIconsHardwareScaleNew,
    blockIconsHardwareSmartDisplayNew,
    blockIconsHardwareSmartphoneNew,
    blockIconsHardwareSmartToyNew,
    blockIconsHardwareTvNew,
    blockIconsHardwareVideogameAssetNew,
    blockIconsHardwareWatchNew,
} from './hardware-new';

// hardware-new
const hardwareNewIcons = [
    {
        name: 'blockIconsHardwareBalanceNew',
        title: __('Balance', 'block-icons-google'),
        icon: blockIconsHardwareBalanceNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareBookOnlineNew',
        title: __('Book Online', 'block-icons-google'),
        icon: blockIconsHardwareBookOnlineNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareCastNew',
        title: __('Cast', 'block-icons-google'),
        icon: blockIconsHardwareCastNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareComputerNew',
        title: __('Computer', 'block-icons-google'),
        icon: blockIconsHardwareComputerNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareDesktopWindowsNew',
        title: __('Desktop Windows', 'block-icons-google'),
        icon: blockIconsHardwareDesktopWindowsNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareDeveloperBoardNew',
        title: __('Developer Board', 'block-icons-google'),
        icon: blockIconsHardwareDeveloperBoardNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareDeveloperModeNew',
        title: __('Developer Mode', 'block-icons-google'),
        icon: blockIconsHardwareDeveloperModeNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareDevicesNew',
        title: __('Devices', 'block-icons-google'),
        icon: blockIconsHardwareDevicesNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareDeviceThermostatNew',
        title: __('Device Thermostat', 'block-icons-google'),
        icon: blockIconsHardwareDeviceThermostatNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareDisplaySettingsNew',
        title: __('Display Settings', 'block-icons-google'),
        icon: blockIconsHardwareDisplaySettingsNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareDnsNew',
        title: __('Dns', 'block-icons-google'),
        icon: blockIconsHardwareDnsNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareFaxNew',
        title: __('Fax', 'block-icons-google'),
        icon: blockIconsHardwareFaxNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareHeadphonesNew',
        title: __('Headphones', 'block-icons-google'),
        icon: blockIconsHardwareHeadphonesNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareHeadsetMicNew',
        title: __('Headset Mic', 'block-icons-google'),
        icon: blockIconsHardwareHeadsetMicNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareKeyboardArrowDownNew',
        title: __('Keyboard Arrow Down', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardArrowDownNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareKeyboardArrowLeftNew',
        title: __('Keyboard Arrow Left', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardArrowLeftNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareKeyboardArrowRightNew',
        title: __('Keyboard Arrow Right', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardArrowRightNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareKeyboardArrowUpNew',
        title: __('Keyboard Arrow Up', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardArrowUpNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareKeyboardBackspaceNew',
        title: __('Keyboard Backspace', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardBackspaceNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareKeyboardNew',
        title: __('Keyboard', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareKeyboardReturnNew',
        title: __('Keyboard Return', 'block-icons-google'),
        icon: blockIconsHardwareKeyboardReturnNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareLaptopChromebookNew',
        title: __('Laptop Chromebook', 'block-icons-google'),
        icon: blockIconsHardwareLaptopChromebookNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareLaptopMacNew',
        title: __('Laptop Mac', 'block-icons-google'),
        icon: blockIconsHardwareLaptopMacNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareLaptopWindowsNew',
        title: __('Laptop Windows', 'block-icons-google'),
        icon: blockIconsHardwareLaptopWindowsNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareLiveTvNew',
        title: __('Live Tv', 'block-icons-google'),
        icon: blockIconsHardwareLiveTvNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareMemoryNew',
        title: __('Memory', 'block-icons-google'),
        icon: blockIconsHardwareMemoryNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareMouseNew',
        title: __('Mouse', 'block-icons-google'),
        icon: blockIconsHardwareMouseNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwarePhoneAndroidNew',
        title: __('Phone Android', 'block-icons-google'),
        icon: blockIconsHardwarePhoneAndroidNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwarePhoneiPhoneNew',
        title: __('Phonei Phone', 'block-icons-google'),
        icon: blockIconsHardwarePhoneiPhoneNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwarePointOfSaleNew',
        title: __('Point Of Sale', 'block-icons-google'),
        icon: blockIconsHardwarePointOfSaleNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwarePowerNew',
        title: __('Power', 'block-icons-google'),
        icon: blockIconsHardwarePowerNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwarePrintNew',
        title: __('Print', 'block-icons-google'),
        icon: blockIconsHardwarePrintNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareRouteNew',
        title: __('Route', 'block-icons-google'),
        icon: blockIconsHardwareRouteNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareRouterNew',
        title: __('Router', 'block-icons-google'),
        icon: blockIconsHardwareRouterNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareSaveNew',
        title: __('Save', 'block-icons-google'),
        icon: blockIconsHardwareSaveNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareScaleNew',
        title: __('Scale', 'block-icons-google'),
        icon: blockIconsHardwareScaleNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareSmartDisplayNew',
        title: __('Smart Display', 'block-icons-google'),
        icon: blockIconsHardwareSmartDisplayNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareSmartphoneNew',
        title: __('Smartphone', 'block-icons-google'),
        icon: blockIconsHardwareSmartphoneNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareSmartToyNew',
        title: __('Smart Toy', 'block-icons-google'),
        icon: blockIconsHardwareSmartToyNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareTvNew',
        title: __('Tv', 'block-icons-google'),
        icon: blockIconsHardwareTvNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareVideogameAssetNew',
        title: __('Videogame Asset', 'block-icons-google'),
        icon: blockIconsHardwareVideogameAssetNew,
        categories: ['hardware-new'],
    },
    {
        name: 'blockIconsHardwareWatchNew',
        title: __('Watch', 'block-icons-google'),
        icon: blockIconsHardwareWatchNew,
        categories: ['hardware-new'],
    },
];

// home
import {
    blockIconsHomeAutoMode,
    blockIconsHomeBlindsClosed,
    blockIconsHomeBlinds,
    blockIconsHomeBroadcastOnHome,
    blockIconsHomeBroadcastOnPersonal,
    blockIconsHomeCurtainsClosed,
    blockIconsHomeCurtains,
    blockIconsHomeElectricBolt,
    blockIconsHomeElectricMeter,
    blockIconsHomeEnergySavingsLeaf,
    blockIconsHomeGasMeter,
    blockIconsHomeHeatPump,
    blockIconsHomeModeFanOff,
    blockIconsHomeNestCamWiredStand,
    blockIconsHomeOilBarrel,
    blockIconsHomePropane,
    blockIconsHomePropaneTank,
    blockIconsHomeRollerShadesClosed,
    blockIconsHomeRollerShades,
    blockIconsHomeSensorDoor,
    blockIconsHomeSensorOccupied,
    blockIconsHomeSensorWindow,
    blockIconsHomeShieldMoon,
    blockIconsHomeSolarPower,
    blockIconsHomeVerticalShadesClosed,
    blockIconsHomeVerticalShades,
    blockIconsHomeWindPower,
} from './home';

// home
const homeIcons = [
    {
        name: 'blockIconsHomeAutoMode',
        title: __('Auto Mode', 'block-icons-google'),
        icon: blockIconsHomeAutoMode,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeBlindsClosed',
        title: __('Blinds Closed', 'block-icons-google'),
        icon: blockIconsHomeBlindsClosed,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeBlinds',
        title: __('Blinds', 'block-icons-google'),
        icon: blockIconsHomeBlinds,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeBroadcastOnHome',
        title: __('Broadcast On', 'block-icons-google'),
        icon: blockIconsHomeBroadcastOnHome,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeBroadcastOnPersonal',
        title: __('Broadcast On Personal', 'block-icons-google'),
        icon: blockIconsHomeBroadcastOnPersonal,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeCurtainsClosed',
        title: __('Curtains Closed', 'block-icons-google'),
        icon: blockIconsHomeCurtainsClosed,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeCurtains',
        title: __('Curtains', 'block-icons-google'),
        icon: blockIconsHomeCurtains,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeElectricBolt',
        title: __('Electric Bolt', 'block-icons-google'),
        icon: blockIconsHomeElectricBolt,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeElectricMeter',
        title: __('Electric Meter', 'block-icons-google'),
        icon: blockIconsHomeElectricMeter,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeEnergySavingsLeaf',
        title: __('Energy Savings Leaf', 'block-icons-google'),
        icon: blockIconsHomeEnergySavingsLeaf,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeGasMeter',
        title: __('Gas Meter', 'block-icons-google'),
        icon: blockIconsHomeGasMeter,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeHeatPump',
        title: __('Heat Pump', 'block-icons-google'),
        icon: blockIconsHomeHeatPump,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeModeFanOff',
        title: __('Mode Fan Off', 'block-icons-google'),
        icon: blockIconsHomeModeFanOff,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeNestCamWiredStand',
        title: __('Nest Cam Wired Stand', 'block-icons-google'),
        icon: blockIconsHomeNestCamWiredStand,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeOilBarrel',
        title: __('Oil Barrel', 'block-icons-google'),
        icon: blockIconsHomeOilBarrel,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomePropane',
        title: __('Propane', 'block-icons-google'),
        icon: blockIconsHomePropane,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomePropaneTank',
        title: __('Propane Tank', 'block-icons-google'),
        icon: blockIconsHomePropaneTank,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeRollerShadesClosed',
        title: __('Roller Shades Closed', 'block-icons-google'),
        icon: blockIconsHomeRollerShadesClosed,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeRollerShades',
        title: __('Roller Shades', 'block-icons-google'),
        icon: blockIconsHomeRollerShades,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeSensorDoor',
        title: __('Sensor Door', 'block-icons-google'),
        icon: blockIconsHomeSensorDoor,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeSensorOccupied',
        title: __('Sensor Occupied', 'block-icons-google'),
        icon: blockIconsHomeSensorOccupied,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeSensorWindow',
        title: __('Sensor Window', 'block-icons-google'),
        icon: blockIconsHomeSensorWindow,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeShieldMoon',
        title: __('Shield Moon', 'block-icons-google'),
        icon: blockIconsHomeShieldMoon,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeSolarPower',
        title: __('Solar Power', 'block-icons-google'),
        icon: blockIconsHomeSolarPower,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeVerticalShadesClosed',
        title: __('Vertical Shades Closed', 'block-icons-google'),
        icon: blockIconsHomeVerticalShadesClosed,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeVerticalShades',
        title: __('Vertical Shades', 'block-icons-google'),
        icon: blockIconsHomeVerticalShades,
        categories: ['home'],
    },
    {
        name: 'blockIconsHomeWindPower',
        title: __('Wind Power', 'block-icons-google'),
        icon: blockIconsHomeWindPower,
        categories: ['home'],
    },
];

// home-new
import {
    blockIconsHomeActivityZoneNew,
    blockIconsHomeAirwaveNew,
    blockIconsHomeArrowsMoreUpNew,
    blockIconsHomeBatteryHoriz000New,
    blockIconsHomeBatteryHoriz050New,
    blockIconsHomeBatteryHoriz075New,
    blockIconsHomeCleaningBucketNew,
    blockIconsHomeDetectionAndZoneNew,
    blockIconsHomeDetectorAlarmNew,
    blockIconsHomeDeviceResetNew,
    blockIconsHomeDoorOpenNew,
    blockIconsHomeEarlyOnNew,
    blockIconsHomeEvChargerNew,
    blockIconsHomeFamiliarFaceAndZoneNew,
    blockIconsHomeFloorLampNew,
    blockIconsHomeGoogleWifiNew,
    blockIconsHomeHomeStorageNew,
    blockIconsHomeLaundryNew,
    blockIconsHomeLightGroupNew,
    blockIconsHomeMfgNestYaleLockNew,
    blockIconsHomeNestCamIndoorNew,
    blockIconsHomeNestCamIqOutdoorNew,
    blockIconsHomeNestCamOutdoorNew,
    blockIconsHomeNestClockFarsightAnalogNew,
    blockIconsHomeNestDisplayNew,
    blockIconsHomeNestEcoLeafNew,
    blockIconsHomeNestHeatLinkENew,
    blockIconsHomeNestHeatLinkGen3New,
    blockIconsHomeNestMultiRoomNew,
    blockIconsHomeNestRemoteComfortSensorNew,
    blockIconsHomeNestRemoteNew,
    blockIconsHomeNestSecureAlarmNew,
    blockIconsHomeNestThermostatGen3New,
    blockIconsHomeProductivityNew,
    blockIconsHomeSettingsAlertNew,
    blockIconsHomeShieldWithHeartNew,
    blockIconsHomeStadiaControllerNew,
    blockIconsHomeTempPreferencesEcoNew,
    blockIconsHomeToolsLadderNew,
    blockIconsHomeToolsPliersWireStripperNew,
    blockIconsHomeToolsPowerDrillNew,
    blockIconsHomeWeatherSnowyNew,
} from './home-new';

// home-new
const homeNewIcons = [
    {
        name: 'blockIconsHomeActivityZoneNew',
        title: __('Activity Zone', 'block-icons-google'),
        icon: blockIconsHomeActivityZoneNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeAirwaveNew',
        title: __('Airwave', 'block-icons-google'),
        icon: blockIconsHomeAirwaveNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeArrowsMoreUpNew',
        title: __('Arrows More Up', 'block-icons-google'),
        icon: blockIconsHomeArrowsMoreUpNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeBatteryHoriz000New',
        title: __('Battery Horiz000', 'block-icons-google'),
        icon: blockIconsHomeBatteryHoriz000New,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeBatteryHoriz050New',
        title: __('Battery Horiz050', 'block-icons-google'),
        icon: blockIconsHomeBatteryHoriz050New,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeBatteryHoriz075New',
        title: __('Battery Horiz075', 'block-icons-google'),
        icon: blockIconsHomeBatteryHoriz075New,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeCleaningBucketNew',
        title: __('Cleaning Bucket', 'block-icons-google'),
        icon: blockIconsHomeCleaningBucketNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeDetectionAndZoneNew',
        title: __('Detection And Zone', 'block-icons-google'),
        icon: blockIconsHomeDetectionAndZoneNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeDetectorAlarmNew',
        title: __('Detector Alarm', 'block-icons-google'),
        icon: blockIconsHomeDetectorAlarmNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeDeviceResetNew',
        title: __('Device Reset', 'block-icons-google'),
        icon: blockIconsHomeDeviceResetNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeDoorOpenNew',
        title: __('Door Open', 'block-icons-google'),
        icon: blockIconsHomeDoorOpenNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeEarlyOnNew',
        title: __('Early On', 'block-icons-google'),
        icon: blockIconsHomeEarlyOnNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeEvChargerNew',
        title: __('Ev Charger', 'block-icons-google'),
        icon: blockIconsHomeEvChargerNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeFamiliarFaceAndZoneNew',
        title: __('Familiar Face And Zone', 'block-icons-google'),
        icon: blockIconsHomeFamiliarFaceAndZoneNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeFloorLampNew',
        title: __('Floor Lamp', 'block-icons-google'),
        icon: blockIconsHomeFloorLampNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeGoogleWifiNew',
        title: __('Google Wifi', 'block-icons-google'),
        icon: blockIconsHomeGoogleWifiNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeHomeStorageNew',
        title: __('Storage', 'block-icons-google'),
        icon: blockIconsHomeHomeStorageNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeLaundryNew',
        title: __('Laundry', 'block-icons-google'),
        icon: blockIconsHomeLaundryNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeLightGroupNew',
        title: __('Light Group', 'block-icons-google'),
        icon: blockIconsHomeLightGroupNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeMfgNestYaleLockNew',
        title: __('Mfg Nest Yale Lock', 'block-icons-google'),
        icon: blockIconsHomeMfgNestYaleLockNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestCamIndoorNew',
        title: __('Nest Cam Indoor', 'block-icons-google'),
        icon: blockIconsHomeNestCamIndoorNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestCamIqOutdoorNew',
        title: __('Nest Cam Iq Outdoor', 'block-icons-google'),
        icon: blockIconsHomeNestCamIqOutdoorNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestCamOutdoorNew',
        title: __('Nest Cam Outdoor', 'block-icons-google'),
        icon: blockIconsHomeNestCamOutdoorNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestClockFarsightAnalogNew',
        title: __('Nest Clock Farsight Analog', 'block-icons-google'),
        icon: blockIconsHomeNestClockFarsightAnalogNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestDisplayNew',
        title: __('Nest Display', 'block-icons-google'),
        icon: blockIconsHomeNestDisplayNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestEcoLeafNew',
        title: __('Nest Eco Leaf', 'block-icons-google'),
        icon: blockIconsHomeNestEcoLeafNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestHeatLinkENew',
        title: __('Nest Heat Link E', 'block-icons-google'),
        icon: blockIconsHomeNestHeatLinkENew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestHeatLinkGen3New',
        title: __('Nest Heat Link Gen3', 'block-icons-google'),
        icon: blockIconsHomeNestHeatLinkGen3New,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestMultiRoomNew',
        title: __('Nest Multi Room', 'block-icons-google'),
        icon: blockIconsHomeNestMultiRoomNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestRemoteComfortSensorNew',
        title: __('Nest Remote Comfort Sensor', 'block-icons-google'),
        icon: blockIconsHomeNestRemoteComfortSensorNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestRemoteNew',
        title: __('Nest Remote', 'block-icons-google'),
        icon: blockIconsHomeNestRemoteNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestSecureAlarmNew',
        title: __('Nest Secure Alarm', 'block-icons-google'),
        icon: blockIconsHomeNestSecureAlarmNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeNestThermostatGen3New',
        title: __('Nest Thermostat Gen3', 'block-icons-google'),
        icon: blockIconsHomeNestThermostatGen3New,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeProductivityNew',
        title: __('Productivity', 'block-icons-google'),
        icon: blockIconsHomeProductivityNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeSettingsAlertNew',
        title: __('Settings Alert', 'block-icons-google'),
        icon: blockIconsHomeSettingsAlertNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeShieldWithHeartNew',
        title: __('Shield With Heart', 'block-icons-google'),
        icon: blockIconsHomeShieldWithHeartNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeStadiaControllerNew',
        title: __('Stadia Controller', 'block-icons-google'),
        icon: blockIconsHomeStadiaControllerNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeTempPreferencesEcoNew',
        title: __('Temp Preferences Eco', 'block-icons-google'),
        icon: blockIconsHomeTempPreferencesEcoNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeToolsLadderNew',
        title: __('Tools Ladder', 'block-icons-google'),
        icon: blockIconsHomeToolsLadderNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeToolsPliersWireStripperNew',
        title: __('Tools Pliers Wire Stripper', 'block-icons-google'),
        icon: blockIconsHomeToolsPliersWireStripperNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeToolsPowerDrillNew',
        title: __('Tools Power Drill', 'block-icons-google'),
        icon: blockIconsHomeToolsPowerDrillNew,
        categories: ['home-new'],
    },
    {
        name: 'blockIconsHomeWeatherSnowyNew',
        title: __('Weather Snowy', 'block-icons-google'),
        icon: blockIconsHomeWeatherSnowyNew,
        categories: ['home-new'],
    },
];

// household-new
import {
    blockIconsHouseholdAcUnitNew,
    blockIconsHouseholdBackHandNew,
    blockIconsHouseholdBathtubNew,
    blockIconsHouseholdBedNew,
    blockIconsHouseholdChairNew,
    blockIconsHouseholdCheckroomNew,
    blockIconsHouseholdChildCareNew,
    blockIconsHouseholdCoffeeMakerNew,
    blockIconsHouseholdCoffeeNew,
    blockIconsHouseholdCookingNew,
    blockIconsHouseholdDeckNew,
    blockIconsHouseholdDiningNew,
    blockIconsHouseholdDoorFrontNew,
    blockIconsHouseholdElectricBoltNew,
    blockIconsHouseholdEmergencyHomeNew,
    blockIconsHouseholdEnergySavingsLeafNew,
    blockIconsHouseholdFlatwareNew,
    blockIconsHouseholdFoundationNew,
    blockIconsHouseholdGarageHomeNew,
    blockIconsHouseholdGarageNew,
    blockIconsHouseholdGrassNew,
    blockIconsHouseholdHighlightNew,
    blockIconsHouseholdHouseNew,
    blockIconsHouseholdHumidityHighNew,
    blockIconsHouseholdKingBedNew,
    blockIconsHouseholdKitchenNew,
    blockIconsHouseholdLightNew,
    blockIconsHouseholdModeFanNew,
    blockIconsHouseholdModeHeatNew,
    blockIconsHouseholdMopNew,
    blockIconsHouseholdOutdoorGrillNew,
    blockIconsHouseholdRoofingNew,
    blockIconsHouseholdSensorOccupiedNew,
    blockIconsHouseholdSensorsNew,
    blockIconsHouseholdShowerNew,
    blockIconsHouseholdStylerNew,
    blockIconsHouseholdTableRestaurantNew,
    blockIconsHouseholdThermometerNew,
    blockIconsHouseholdValveNew,
    blockIconsHouseholdWeekendNew,
    blockIconsHouseholdWindowNew,
    blockIconsHouseholdYardNew,
} from './household-new';

// household-new
const householdNewIcons = [
    {
        name: 'blockIconsHouseholdAcUnitNew',
        title: __('Ac Unit', 'block-icons-google'),
        icon: blockIconsHouseholdAcUnitNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdBackHandNew',
        title: __('Back Hand', 'block-icons-google'),
        icon: blockIconsHouseholdBackHandNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdBathtubNew',
        title: __('Bathtub', 'block-icons-google'),
        icon: blockIconsHouseholdBathtubNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdBedNew',
        title: __('Bed', 'block-icons-google'),
        icon: blockIconsHouseholdBedNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdChairNew',
        title: __('Chair', 'block-icons-google'),
        icon: blockIconsHouseholdChairNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdCheckroomNew',
        title: __('Checkroom', 'block-icons-google'),
        icon: blockIconsHouseholdCheckroomNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdChildCareNew',
        title: __('Child Care', 'block-icons-google'),
        icon: blockIconsHouseholdChildCareNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdCoffeeMakerNew',
        title: __('Coffee Maker', 'block-icons-google'),
        icon: blockIconsHouseholdCoffeeMakerNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdCoffeeNew',
        title: __('Coffee', 'block-icons-google'),
        icon: blockIconsHouseholdCoffeeNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdCookingNew',
        title: __('Cooking', 'block-icons-google'),
        icon: blockIconsHouseholdCookingNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdDeckNew',
        title: __('Deck', 'block-icons-google'),
        icon: blockIconsHouseholdDeckNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdDiningNew',
        title: __('Dining', 'block-icons-google'),
        icon: blockIconsHouseholdDiningNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdDoorFrontNew',
        title: __('Door Front', 'block-icons-google'),
        icon: blockIconsHouseholdDoorFrontNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdElectricBoltNew',
        title: __('Electric Bolt', 'block-icons-google'),
        icon: blockIconsHouseholdElectricBoltNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdEmergencyHomeNew',
        title: __('Emergency Home', 'block-icons-google'),
        icon: blockIconsHouseholdEmergencyHomeNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdEnergySavingsLeafNew',
        title: __('Energy Savings Leaf', 'block-icons-google'),
        icon: blockIconsHouseholdEnergySavingsLeafNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdFlatwareNew',
        title: __('Flatware', 'block-icons-google'),
        icon: blockIconsHouseholdFlatwareNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdFoundationNew',
        title: __('Foundation', 'block-icons-google'),
        icon: blockIconsHouseholdFoundationNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdGarageHomeNew',
        title: __('Garage Home', 'block-icons-google'),
        icon: blockIconsHouseholdGarageHomeNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdGarageNew',
        title: __('Garage', 'block-icons-google'),
        icon: blockIconsHouseholdGarageNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdGrassNew',
        title: __('Grass', 'block-icons-google'),
        icon: blockIconsHouseholdGrassNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdHighlightNew',
        title: __('Highlight', 'block-icons-google'),
        icon: blockIconsHouseholdHighlightNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdHouseNew',
        title: __('House', 'block-icons-google'),
        icon: blockIconsHouseholdHouseNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdHumidityHighNew',
        title: __('Humidity High', 'block-icons-google'),
        icon: blockIconsHouseholdHumidityHighNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdKingBedNew',
        title: __('King Bed', 'block-icons-google'),
        icon: blockIconsHouseholdKingBedNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdKitchenNew',
        title: __('Kitchen', 'block-icons-google'),
        icon: blockIconsHouseholdKitchenNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdLightNew',
        title: __('Light', 'block-icons-google'),
        icon: blockIconsHouseholdLightNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdModeFanNew',
        title: __('Mode Fan', 'block-icons-google'),
        icon: blockIconsHouseholdModeFanNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdModeHeatNew',
        title: __('Mode Heat', 'block-icons-google'),
        icon: blockIconsHouseholdModeHeatNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdMopNew',
        title: __('Mop', 'block-icons-google'),
        icon: blockIconsHouseholdMopNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdOutdoorGrillNew',
        title: __('Outdoor Grill', 'block-icons-google'),
        icon: blockIconsHouseholdOutdoorGrillNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdRoofingNew',
        title: __('Roofing', 'block-icons-google'),
        icon: blockIconsHouseholdRoofingNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdSensorOccupiedNew',
        title: __('Sensor Occupied', 'block-icons-google'),
        icon: blockIconsHouseholdSensorOccupiedNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdSensorsNew',
        title: __('Sensors', 'block-icons-google'),
        icon: blockIconsHouseholdSensorsNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdShowerNew',
        title: __('Shower', 'block-icons-google'),
        icon: blockIconsHouseholdShowerNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdStylerNew',
        title: __('Styler', 'block-icons-google'),
        icon: blockIconsHouseholdStylerNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdTableRestaurantNew',
        title: __('Table Restaurant', 'block-icons-google'),
        icon: blockIconsHouseholdTableRestaurantNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdThermometerNew',
        title: __('Thermometer', 'block-icons-google'),
        icon: blockIconsHouseholdThermometerNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdValveNew',
        title: __('Valve', 'block-icons-google'),
        icon: blockIconsHouseholdValveNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdWeekendNew',
        title: __('Weekend', 'block-icons-google'),
        icon: blockIconsHouseholdWeekendNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdWindowNew',
        title: __('Window', 'block-icons-google'),
        icon: blockIconsHouseholdWindowNew,
        categories: ['household-new'],
    },
    {
        name: 'blockIconsHouseholdYardNew',
        title: __('Yard', 'block-icons-google'),
        icon: blockIconsHouseholdYardNew,
        categories: ['household-new'],
    },
];

// image
import {
    blockIconsImageAddAPhoto,
    blockIconsImageAddPhotoAlternate,
    blockIconsImageAdjust,
    blockIconsImageAudiotrack,
    blockIconsImageAutoAwesome,
    blockIconsImageAutoFixHigh,
    blockIconsImageAutoStories,
    blockIconsImageBrush,
    blockIconsImageCameraAlt,
    blockIconsImageCamera,
    blockIconsImageCircle,
    blockIconsImageCollections,
    blockIconsImageControlPoint,
    blockIconsImageEdit,
    blockIconsImageEuro,
    blockIconsImageFlashOn,
    blockIconsImageImage,
    blockIconsImageLooksOne,
    blockIconsImageMusicNote,
    blockIconsImageNavigateBefore,
    blockIconsImageNavigateNext,
    blockIconsImagePalette,
    blockIconsImagePhotoCamera,
    blockIconsImagePhotoLibrary,
    blockIconsImagePictureAsPdf,
    blockIconsImagePortrait,
    blockIconsImageReceiptLong,
    blockIconsImageRemoveRedEye,
    blockIconsImageRotateRight,
    blockIconsImageStraighten,
    blockIconsImageStyle,
    blockIconsImageTimer,
    blockIconsImageTune,
    blockIconsImageVideoCameraFront,
    blockIconsImageWbSunny,
} from './image';

// image
const imageIcons = [
    {
        name: 'blockIconsImageAddAPhoto',
        title: __('Add APhoto', 'block-icons-google'),
        icon: blockIconsImageAddAPhoto,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageAddPhotoAlternate',
        title: __('Add Photo Alternate', 'block-icons-google'),
        icon: blockIconsImageAddPhotoAlternate,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageAdjust',
        title: __('Adjust', 'block-icons-google'),
        icon: blockIconsImageAdjust,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageAudiotrack',
        title: __('Audiotrack', 'block-icons-google'),
        icon: blockIconsImageAudiotrack,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageAutoAwesome',
        title: __('Auto Awesome', 'block-icons-google'),
        icon: blockIconsImageAutoAwesome,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageAutoFixHigh',
        title: __('Auto Fix High', 'block-icons-google'),
        icon: blockIconsImageAutoFixHigh,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageAutoStories',
        title: __('Auto Stories', 'block-icons-google'),
        icon: blockIconsImageAutoStories,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageBrush',
        title: __('Brush', 'block-icons-google'),
        icon: blockIconsImageBrush,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageCameraAlt',
        title: __('Camera Alt', 'block-icons-google'),
        icon: blockIconsImageCameraAlt,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageCamera',
        title: __('Camera', 'block-icons-google'),
        icon: blockIconsImageCamera,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageCircle',
        title: __('Circle', 'block-icons-google'),
        icon: blockIconsImageCircle,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageCollections',
        title: __('Collections', 'block-icons-google'),
        icon: blockIconsImageCollections,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageControlPoint',
        title: __('Control Point', 'block-icons-google'),
        icon: blockIconsImageControlPoint,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageEdit',
        title: __('Edit', 'block-icons-google'),
        icon: blockIconsImageEdit,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageEuro',
        title: __('Euro', 'block-icons-google'),
        icon: blockIconsImageEuro,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageFlashOn',
        title: __('Flash On', 'block-icons-google'),
        icon: blockIconsImageFlashOn,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageImage',
        title: __('', 'block-icons-google'),
        icon: blockIconsImageImage,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageLooksOne',
        title: __('Looks One', 'block-icons-google'),
        icon: blockIconsImageLooksOne,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageMusicNote',
        title: __('Music Note', 'block-icons-google'),
        icon: blockIconsImageMusicNote,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageNavigateBefore',
        title: __('Navigate Before', 'block-icons-google'),
        icon: blockIconsImageNavigateBefore,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageNavigateNext',
        title: __('Navigate Next', 'block-icons-google'),
        icon: blockIconsImageNavigateNext,
        categories: ['image'],
    },
    {
        name: 'blockIconsImagePalette',
        title: __('Palette', 'block-icons-google'),
        icon: blockIconsImagePalette,
        categories: ['image'],
    },
    {
        name: 'blockIconsImagePhotoCamera',
        title: __('Photo Camera', 'block-icons-google'),
        icon: blockIconsImagePhotoCamera,
        categories: ['image'],
    },
    {
        name: 'blockIconsImagePhotoLibrary',
        title: __('Photo Library', 'block-icons-google'),
        icon: blockIconsImagePhotoLibrary,
        categories: ['image'],
    },
    {
        name: 'blockIconsImagePictureAsPdf',
        title: __('Picture As Pdf', 'block-icons-google'),
        icon: blockIconsImagePictureAsPdf,
        categories: ['image'],
    },
    {
        name: 'blockIconsImagePortrait',
        title: __('Portrait', 'block-icons-google'),
        icon: blockIconsImagePortrait,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageReceiptLong',
        title: __('Receipt Long', 'block-icons-google'),
        icon: blockIconsImageReceiptLong,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageRemoveRedEye',
        title: __('Remove Red Eye', 'block-icons-google'),
        icon: blockIconsImageRemoveRedEye,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageRotateRight',
        title: __('Rotate Right', 'block-icons-google'),
        icon: blockIconsImageRotateRight,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageStraighten',
        title: __('Straighten', 'block-icons-google'),
        icon: blockIconsImageStraighten,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageStyle',
        title: __('Style', 'block-icons-google'),
        icon: blockIconsImageStyle,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageTimer',
        title: __('Timer', 'block-icons-google'),
        icon: blockIconsImageTimer,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageTune',
        title: __('Tune', 'block-icons-google'),
        icon: blockIconsImageTune,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageVideoCameraFront',
        title: __('Video Camera Front', 'block-icons-google'),
        icon: blockIconsImageVideoCameraFront,
        categories: ['image'],
    },
    {
        name: 'blockIconsImageWbSunny',
        title: __('Wb Sunny', 'block-icons-google'),
        icon: blockIconsImageWbSunny,
        categories: ['image'],
    },
];

// maps
import {
    blockIconsMapsBadge,
    blockIconsMapsCategory,
    blockIconsMapsCelebration,
    // blockIconsMapsDeliveryDining,
    blockIconsMapsDesignServices,
    blockIconsMapsDirectionsBus,
    blockIconsMapsDirectionsCar,
    blockIconsMapsDirectionsRun,
    blockIconsMapsDirectionsWalk,
    blockIconsMapsFlight,
    blockIconsMapsHandyman,
    blockIconsMapsLayers,
    blockIconsMapsLocalActivity,
    blockIconsMapsLocalAtm,
    blockIconsMapsLocalCafe,
    blockIconsMapsLocalFireDepartment,
    blockIconsMapsLocalHospital,
    blockIconsMapsLocalLibrary,
    blockIconsMapsLocalMall,
    blockIconsMapsLocalOffer,
    blockIconsMapsLocalShipping,
    blockIconsMapsLunchDining,
    blockIconsMapsMap,
    blockIconsMapsMedicalServices,
    blockIconsMapsMenuBook,
    blockIconsMapsMyLocation,
    blockIconsMapsNearMe,
    blockIconsMapsPark,
    blockIconsMapsPersonPin,
    blockIconsMapsPinDrop,
    blockIconsMapsPlace,
    blockIconsMapsRateReview,
    blockIconsMapsRestaurant,
    blockIconsMapsRestaurantMenu,
    blockIconsMapsVolunteerActivism,
} from './maps';

// maps
const mapsIcons = [
    {
        name: 'blockIconsMapsBadge',
        title: __('Badge', 'block-icons-google'),
        icon: blockIconsMapsBadge,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsCategory',
        title: __('Category', 'block-icons-google'),
        icon: blockIconsMapsCategory,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsCelebration',
        title: __('Celebration', 'block-icons-google'),
        icon: blockIconsMapsCelebration,
        categories: ['maps'],
    },
    // {
    //     name: 'blockIconsMapsDeliveryDining',
    //     title: __('Delivery Dining', 'block-icons-google'),
    //     icon: blockIconsMapsDeliveryDining,
    //     categories: ['maps'],
    // },
    {
        name: 'blockIconsMapsDesignServices',
        title: __('Design Services', 'block-icons-google'),
        icon: blockIconsMapsDesignServices,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsDirectionsBus',
        title: __('Directions Bus', 'block-icons-google'),
        icon: blockIconsMapsDirectionsBus,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsDirectionsCar',
        title: __('Directions Car', 'block-icons-google'),
        icon: blockIconsMapsDirectionsCar,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsDirectionsRun',
        title: __('Directions Run', 'block-icons-google'),
        icon: blockIconsMapsDirectionsRun,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsDirectionsWalk',
        title: __('Directions Walk', 'block-icons-google'),
        icon: blockIconsMapsDirectionsWalk,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsFlight',
        title: __('Flight', 'block-icons-google'),
        icon: blockIconsMapsFlight,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsHandyman',
        title: __('Handyman', 'block-icons-google'),
        icon: blockIconsMapsHandyman,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsLayers',
        title: __('Layers', 'block-icons-google'),
        icon: blockIconsMapsLayers,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsLocalActivity',
        title: __('Local Activity', 'block-icons-google'),
        icon: blockIconsMapsLocalActivity,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsLocalAtm',
        title: __('Local Atm', 'block-icons-google'),
        icon: blockIconsMapsLocalAtm,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsLocalCafe',
        title: __('Local Cafe', 'block-icons-google'),
        icon: blockIconsMapsLocalCafe,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsLocalFireDepartment',
        title: __('Local Fire Department', 'block-icons-google'),
        icon: blockIconsMapsLocalFireDepartment,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsLocalHospital',
        title: __('Local Hospital', 'block-icons-google'),
        icon: blockIconsMapsLocalHospital,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsLocalLibrary',
        title: __('Local Library', 'block-icons-google'),
        icon: blockIconsMapsLocalLibrary,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsLocalMall',
        title: __('Local Mall', 'block-icons-google'),
        icon: blockIconsMapsLocalMall,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsLocalOffer',
        title: __('Local Offer', 'block-icons-google'),
        icon: blockIconsMapsLocalOffer,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsLocalShipping',
        title: __('Local Shipping', 'block-icons-google'),
        icon: blockIconsMapsLocalShipping,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsLunchDining',
        title: __('Lunch Dining', 'block-icons-google'),
        icon: blockIconsMapsLunchDining,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsMap',
        title: __('Map', 'block-icons-google'),
        icon: blockIconsMapsMap,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsMedicalServices',
        title: __('Medical Services', 'block-icons-google'),
        icon: blockIconsMapsMedicalServices,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsMenuBook',
        title: __('Menu Book', 'block-icons-google'),
        icon: blockIconsMapsMenuBook,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsMyLocation',
        title: __('My Location', 'block-icons-google'),
        icon: blockIconsMapsMyLocation,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsNearMe',
        title: __('Near Me', 'block-icons-google'),
        icon: blockIconsMapsNearMe,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsPark',
        title: __('Park', 'block-icons-google'),
        icon: blockIconsMapsPark,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsPersonPin',
        title: __('Person Pin', 'block-icons-google'),
        icon: blockIconsMapsPersonPin,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsPinDrop',
        title: __('Pin Drop', 'block-icons-google'),
        icon: blockIconsMapsPinDrop,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsPlace',
        title: __('Place', 'block-icons-google'),
        icon: blockIconsMapsPlace,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsRateReview',
        title: __('Rate Review', 'block-icons-google'),
        icon: blockIconsMapsRateReview,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsRestaurant',
        title: __('Restaurant', 'block-icons-google'),
        icon: blockIconsMapsRestaurant,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsRestaurantMenu',
        title: __('Restaurant Menu', 'block-icons-google'),
        icon: blockIconsMapsRestaurantMenu,
        categories: ['maps'],
    },
    {
        name: 'blockIconsMapsVolunteerActivism',
        title: __('Volunteer Activism', 'block-icons-google'),
        icon: blockIconsMapsVolunteerActivism,
        categories: ['maps'],
    },
];

// maps-new
import {
    blockIconsMapsAddLocationNew,
    blockIconsMapsBusinessCenterNew,
    blockIconsMapsCrisisAlertNew,
    blockIconsMapsEastNew,
    blockIconsMapsEmergencyNew,
    blockIconsMapsExploreNew,
    blockIconsMapsFactoryNew,
    blockIconsMapsFastfoodNew,
    blockIconsMapsFlagNew,
    blockIconsMapsHandymanNew,
    blockIconsMapsHomePinNew,
    blockIconsMapsHomeRepairServiceNew,
    blockIconsMapsHomeWorkNew,
    blockIconsMapsLayersNew,
    blockIconsMapsLocalActivityNew,
    blockIconsMapsLocalFireDepartmentNew,
    blockIconsMapsLocalFloristNew,
    blockIconsMapsLocalHospitalNew,
    blockIconsMapsLocalLibraryNew,
    blockIconsMapsLocalMallNew,
    blockIconsMapsLocalParkingNew,
    blockIconsMapsLocalPoliceNew,
    blockIconsMapsLocationAwayNew,
    blockIconsMapsLocationOnNew,
    blockIconsMapsLocationSearchingNew,
    blockIconsMapsMapNew,
    blockIconsMapsMedicalServicesNew,
    blockIconsMapsMyLocationNew,
    blockIconsMapsNavigationNew,
    blockIconsMapsNearMeNew,
    blockIconsMapsNorthEastNew,
    blockIconsMapsPersonPinCircleNew,
    blockIconsMapsPersonPinNew,
    blockIconsMapsPinDropNew,
    blockIconsMapsRestaurantMenuNew,
    blockIconsMapsRestaurantNew,
    blockIconsMapsShareLocationNew,
    blockIconsMapsSouthNew,
    blockIconsMapsWarehouseNew,
    blockIconsMapsWestNew,
    blockIconsMapsWhereToVoteNew,
    blockIconsMapsZoomOutMapNew,
} from './maps-new';

// maps-new
const mapsNewIcons = [
    {
        name: 'blockIconsMapsAddLocationNew',
        title: __('Add Location', 'block-icons-google'),
        icon: blockIconsMapsAddLocationNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsBusinessCenterNew',
        title: __('Business Center', 'block-icons-google'),
        icon: blockIconsMapsBusinessCenterNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsCrisisAlertNew',
        title: __('Crisis Alert', 'block-icons-google'),
        icon: blockIconsMapsCrisisAlertNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsEastNew',
        title: __('East', 'block-icons-google'),
        icon: blockIconsMapsEastNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsEmergencyNew',
        title: __('Emergency', 'block-icons-google'),
        icon: blockIconsMapsEmergencyNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsExploreNew',
        title: __('Explore', 'block-icons-google'),
        icon: blockIconsMapsExploreNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsFactoryNew',
        title: __('Factory', 'block-icons-google'),
        icon: blockIconsMapsFactoryNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsFastfoodNew',
        title: __('Fastfood', 'block-icons-google'),
        icon: blockIconsMapsFastfoodNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsFlagNew',
        title: __('Flag', 'block-icons-google'),
        icon: blockIconsMapsFlagNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsHandymanNew',
        title: __('Handyman', 'block-icons-google'),
        icon: blockIconsMapsHandymanNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsHomePinNew',
        title: __('Home Pin', 'block-icons-google'),
        icon: blockIconsMapsHomePinNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsHomeRepairServiceNew',
        title: __('Home Repair Service', 'block-icons-google'),
        icon: blockIconsMapsHomeRepairServiceNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsHomeWorkNew',
        title: __('Home Work', 'block-icons-google'),
        icon: blockIconsMapsHomeWorkNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsLayersNew',
        title: __('Layers', 'block-icons-google'),
        icon: blockIconsMapsLayersNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsLocalActivityNew',
        title: __('Local Activity', 'block-icons-google'),
        icon: blockIconsMapsLocalActivityNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsLocalFireDepartmentNew',
        title: __('Local Fire Department', 'block-icons-google'),
        icon: blockIconsMapsLocalFireDepartmentNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsLocalFloristNew',
        title: __('Local Florist', 'block-icons-google'),
        icon: blockIconsMapsLocalFloristNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsLocalHospitalNew',
        title: __('Local Hospital', 'block-icons-google'),
        icon: blockIconsMapsLocalHospitalNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsLocalLibraryNew',
        title: __('Local Library', 'block-icons-google'),
        icon: blockIconsMapsLocalLibraryNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsLocalMallNew',
        title: __('Local Mall', 'block-icons-google'),
        icon: blockIconsMapsLocalMallNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsLocalParkingNew',
        title: __('Local Parking', 'block-icons-google'),
        icon: blockIconsMapsLocalParkingNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsLocalPoliceNew',
        title: __('Local Police', 'block-icons-google'),
        icon: blockIconsMapsLocalPoliceNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsLocationAwayNew',
        title: __('Location Away', 'block-icons-google'),
        icon: blockIconsMapsLocationAwayNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsLocationOnNew',
        title: __('Location On', 'block-icons-google'),
        icon: blockIconsMapsLocationOnNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsLocationSearchingNew',
        title: __('Location Searching', 'block-icons-google'),
        icon: blockIconsMapsLocationSearchingNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsMapNew',
        title: __('Map', 'block-icons-google'),
        icon: blockIconsMapsMapNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsMedicalServicesNew',
        title: __('Medical Services', 'block-icons-google'),
        icon: blockIconsMapsMedicalServicesNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsMyLocationNew',
        title: __('My Location', 'block-icons-google'),
        icon: blockIconsMapsMyLocationNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsNavigationNew',
        title: __('Navigation', 'block-icons-google'),
        icon: blockIconsMapsNavigationNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsNearMeNew',
        title: __('Near Me', 'block-icons-google'),
        icon: blockIconsMapsNearMeNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsNorthEastNew',
        title: __('North East', 'block-icons-google'),
        icon: blockIconsMapsNorthEastNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsPersonPinCircleNew',
        title: __('Person Pin Circle', 'block-icons-google'),
        icon: blockIconsMapsPersonPinCircleNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsPersonPinNew',
        title: __('Person Pin', 'block-icons-google'),
        icon: blockIconsMapsPersonPinNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsPinDropNew',
        title: __('Pin Drop', 'block-icons-google'),
        icon: blockIconsMapsPinDropNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsRestaurantMenuNew',
        title: __('Restaurant Menu', 'block-icons-google'),
        icon: blockIconsMapsRestaurantMenuNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsRestaurantNew',
        title: __('Restaurant', 'block-icons-google'),
        icon: blockIconsMapsRestaurantNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsShareLocationNew',
        title: __('Share Location', 'block-icons-google'),
        icon: blockIconsMapsShareLocationNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsSouthNew',
        title: __('South', 'block-icons-google'),
        icon: blockIconsMapsSouthNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsWarehouseNew',
        title: __('Warehouse', 'block-icons-google'),
        icon: blockIconsMapsWarehouseNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsWestNew',
        title: __('West', 'block-icons-google'),
        icon: blockIconsMapsWestNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsWhereToVoteNew',
        title: __('Where To Vote', 'block-icons-google'),
        icon: blockIconsMapsWhereToVoteNew,
        categories: ['maps-new'],
    },
    {
        name: 'blockIconsMapsZoomOutMapNew',
        title: __('Zoom Out Map', 'block-icons-google'),
        icon: blockIconsMapsZoomOutMapNew,
        categories: ['maps-new'],
    },
];

// navigation
import {
    blockIconsNavigationApps,
    blockIconsNavigationArrowBackiOS,
    blockIconsNavigationArrowBackiOSNew,
    blockIconsNavigationArrowBack,
    blockIconsNavigationArrowDownward,
    blockIconsNavigationArrowDropDown,
    blockIconsNavigationArrowDropUp,
    blockIconsNavigationArrowForwardiOS,
    blockIconsNavigationArrowForward,
    blockIconsNavigationArrowLeft,
    blockIconsNavigationArrowRight,
    blockIconsNavigationArrowUpward,
    blockIconsNavigationCampaign,
    blockIconsNavigationCancel,
    blockIconsNavigationCheck,
    blockIconsNavigationChevronLeft,
    blockIconsNavigationChevronRight,
    blockIconsNavigationClose,
    blockIconsNavigationDoubleArrow,
    blockIconsNavigationEast,
    blockIconsNavigationExpandCircleDown,
    blockIconsNavigationExpandLess,
    blockIconsNavigationExpandMore,
    blockIconsNavigationFullscreen,
    blockIconsNavigationMapsHomeWork,
    blockIconsNavigationMenu,
    blockIconsNavigationMenuOpen,
    blockIconsNavigationMoreHoriz,
    blockIconsNavigationMoreVert,
    blockIconsNavigationNorthEast,
    blockIconsNavigationPayments,
    blockIconsNavigationRefresh,
    blockIconsNavigationSouth,
    blockIconsNavigationUnfoldMore,
    blockIconsNavigationWest,
} from './navigation';

// navigation
const navigationIcons = [
    {
        name: 'blockIconsNavigationApps',
        title: __('Apps', 'block-icons-google'),
        icon: blockIconsNavigationApps,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationArrowBackiOS',
        title: __('Arrow Backi OS', 'block-icons-google'),
        icon: blockIconsNavigationArrowBackiOS,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationArrowBackiOSNew',
        title: __('Arrow Backi OS', 'block-icons-google'),
        icon: blockIconsNavigationArrowBackiOSNew,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationArrowBack',
        title: __('Arrow Back', 'block-icons-google'),
        icon: blockIconsNavigationArrowBack,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationArrowDownward',
        title: __('Arrow Downward', 'block-icons-google'),
        icon: blockIconsNavigationArrowDownward,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationArrowDropDown',
        title: __('Arrow Drop Down', 'block-icons-google'),
        icon: blockIconsNavigationArrowDropDown,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationArrowDropUp',
        title: __('Arrow Drop Up', 'block-icons-google'),
        icon: blockIconsNavigationArrowDropUp,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationArrowForwardiOS',
        title: __('Arrow Forwardi OS', 'block-icons-google'),
        icon: blockIconsNavigationArrowForwardiOS,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationArrowForward',
        title: __('Arrow Forward', 'block-icons-google'),
        icon: blockIconsNavigationArrowForward,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationArrowLeft',
        title: __('Arrow Left', 'block-icons-google'),
        icon: blockIconsNavigationArrowLeft,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationArrowRight',
        title: __('Arrow Right', 'block-icons-google'),
        icon: blockIconsNavigationArrowRight,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationArrowUpward',
        title: __('Arrow Upward', 'block-icons-google'),
        icon: blockIconsNavigationArrowUpward,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationCampaign',
        title: __('Campaign', 'block-icons-google'),
        icon: blockIconsNavigationCampaign,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationCancel',
        title: __('Cancel', 'block-icons-google'),
        icon: blockIconsNavigationCancel,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationCheck',
        title: __('Check', 'block-icons-google'),
        icon: blockIconsNavigationCheck,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationChevronLeft',
        title: __('Chevron Left', 'block-icons-google'),
        icon: blockIconsNavigationChevronLeft,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationChevronRight',
        title: __('Chevron Right', 'block-icons-google'),
        icon: blockIconsNavigationChevronRight,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationClose',
        title: __('Close', 'block-icons-google'),
        icon: blockIconsNavigationClose,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationDoubleArrow',
        title: __('Double Arrow', 'block-icons-google'),
        icon: blockIconsNavigationDoubleArrow,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationEast',
        title: __('East', 'block-icons-google'),
        icon: blockIconsNavigationEast,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationExpandCircleDown',
        title: __('Expand Circle Down', 'block-icons-google'),
        icon: blockIconsNavigationExpandCircleDown,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationExpandLess',
        title: __('Expand Less', 'block-icons-google'),
        icon: blockIconsNavigationExpandLess,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationExpandMore',
        title: __('Expand More', 'block-icons-google'),
        icon: blockIconsNavigationExpandMore,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationFullscreen',
        title: __('Fullscreen', 'block-icons-google'),
        icon: blockIconsNavigationFullscreen,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationMapsHomeWork',
        title: __('Maps Home Work', 'block-icons-google'),
        icon: blockIconsNavigationMapsHomeWork,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationMenu',
        title: __('Menu', 'block-icons-google'),
        icon: blockIconsNavigationMenu,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationMenuOpen',
        title: __('Menu Open', 'block-icons-google'),
        icon: blockIconsNavigationMenuOpen,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationMoreHoriz',
        title: __('More Horiz', 'block-icons-google'),
        icon: blockIconsNavigationMoreHoriz,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationMoreVert',
        title: __('More Vert', 'block-icons-google'),
        icon: blockIconsNavigationMoreVert,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationNorthEast',
        title: __('North East', 'block-icons-google'),
        icon: blockIconsNavigationNorthEast,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationPayments',
        title: __('Payments', 'block-icons-google'),
        icon: blockIconsNavigationPayments,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationRefresh',
        title: __('Refresh', 'block-icons-google'),
        icon: blockIconsNavigationRefresh,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationSouth',
        title: __('South', 'block-icons-google'),
        icon: blockIconsNavigationSouth,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationUnfoldMore',
        title: __('Unfold More', 'block-icons-google'),
        icon: blockIconsNavigationUnfoldMore,
        categories: ['navigation'],
    },
    {
        name: 'blockIconsNavigationWest',
        title: __('West', 'block-icons-google'),
        icon: blockIconsNavigationWest,
        categories: ['navigation'],
    },
];

// notification
import {
    blockIconsNotificationAccountTree,
    blockIconsNotificationADB,
    blockIconsNotificationConfirmationNumber,
    blockIconsNotificationDoDisturb,
    blockIconsNotificationDoDisturbOn,
    blockIconsNotificationDoNotDisturb,
    blockIconsNotificationDoNotDisturbOn,
    blockIconsNotificationDriveEta,
    blockIconsNotificationEnhancedEncryption,
    blockIconsNotificationEventAvailable,
    blockIconsNotificationEventBusy,
    blockIconsNotificationEventNote,
    blockIconsNotificationFolderSpecial,
    blockIconsNotificationLiveTv,
    blockIconsNotificationMore,
    blockIconsNotificationNetworkCheck,
    blockIconsNotificationOndemandVideo,
    blockIconsNotificationPersonalVideo,
    blockIconsNotificationPhoneCallback,
    blockIconsNotificationPhoneForwarded,
    blockIconsNotificationPower,
    blockIconsNotificationPowerOff,
    blockIconsNotificationPriorityHigh,
    blockIconsNotificationRunningWithErrors,
    blockIconsNotificationSmsFailed,
    blockIconsNotificationSms,
    blockIconsNotificationSupportAgent,
    blockIconsNotificationSync,
    blockIconsNotificationSyncProblem,
    blockIconsNotificationSystemUpdate,
    blockIconsNotificationTimeToLeave,
    blockIconsNotificationVpnLock,
    blockIconsNotificationWc,
    blockIconsNotificationWifi,
    blockIconsNotificationWifiOff,
} from './notification';

// notification
const notificationIcons = [
    {
        name: 'blockIconsNotificationAccountTree',
        title: __('Account Tree', 'block-icons-google'),
        icon: blockIconsNotificationAccountTree,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationADB',
        title: __('ADB', 'block-icons-google'),
        icon: blockIconsNotificationADB,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationConfirmationNumber',
        title: __('Confirmation Number', 'block-icons-google'),
        icon: blockIconsNotificationConfirmationNumber,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationDoDisturb',
        title: __('Do Disturb', 'block-icons-google'),
        icon: blockIconsNotificationDoDisturb,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationDoDisturbOn',
        title: __('Do Disturb On', 'block-icons-google'),
        icon: blockIconsNotificationDoDisturbOn,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationDoNotDisturb',
        title: __('Do Not Disturb', 'block-icons-google'),
        icon: blockIconsNotificationDoNotDisturb,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationDoNotDisturbOn',
        title: __('Do Not Disturb On', 'block-icons-google'),
        icon: blockIconsNotificationDoNotDisturbOn,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationDriveEta',
        title: __('Drive Eta', 'block-icons-google'),
        icon: blockIconsNotificationDriveEta,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationEnhancedEncryption',
        title: __('Enhanced Encryption', 'block-icons-google'),
        icon: blockIconsNotificationEnhancedEncryption,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationEventAvailable',
        title: __('Event Available', 'block-icons-google'),
        icon: blockIconsNotificationEventAvailable,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationEventBusy',
        title: __('Event Busy', 'block-icons-google'),
        icon: blockIconsNotificationEventBusy,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationEventNote',
        title: __('Event Note', 'block-icons-google'),
        icon: blockIconsNotificationEventNote,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationFolderSpecial',
        title: __('Folder Special', 'block-icons-google'),
        icon: blockIconsNotificationFolderSpecial,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationLiveTv',
        title: __('Live Tv', 'block-icons-google'),
        icon: blockIconsNotificationLiveTv,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationMore',
        title: __('More', 'block-icons-google'),
        icon: blockIconsNotificationMore,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationNetworkCheck',
        title: __('Network Check', 'block-icons-google'),
        icon: blockIconsNotificationNetworkCheck,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationOndemandVideo',
        title: __('Ondemand Video', 'block-icons-google'),
        icon: blockIconsNotificationOndemandVideo,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationPersonalVideo',
        title: __('Personal Video', 'block-icons-google'),
        icon: blockIconsNotificationPersonalVideo,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationPhoneCallback',
        title: __('Phone Callback', 'block-icons-google'),
        icon: blockIconsNotificationPhoneCallback,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationPhoneForwarded',
        title: __('Phone Forwarded', 'block-icons-google'),
        icon: blockIconsNotificationPhoneForwarded,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationPower',
        title: __('Power', 'block-icons-google'),
        icon: blockIconsNotificationPower,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationPowerOff',
        title: __('Power Off', 'block-icons-google'),
        icon: blockIconsNotificationPowerOff,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationPriorityHigh',
        title: __('Priority High', 'block-icons-google'),
        icon: blockIconsNotificationPriorityHigh,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationRunningWithErrors',
        title: __('Running With Errors', 'block-icons-google'),
        icon: blockIconsNotificationRunningWithErrors,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationSmsFailed',
        title: __('Sms Failed', 'block-icons-google'),
        icon: blockIconsNotificationSmsFailed,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationSms',
        title: __('Sms', 'block-icons-google'),
        icon: blockIconsNotificationSms,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationSupportAgent',
        title: __('Support Agent', 'block-icons-google'),
        icon: blockIconsNotificationSupportAgent,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationSync',
        title: __('Sync', 'block-icons-google'),
        icon: blockIconsNotificationSync,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationSyncProblem',
        title: __('Sync Problem', 'block-icons-google'),
        icon: blockIconsNotificationSyncProblem,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationSystemUpdate',
        title: __('System Update', 'block-icons-google'),
        icon: blockIconsNotificationSystemUpdate,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationTimeToLeave',
        title: __('Time To Leave', 'block-icons-google'),
        icon: blockIconsNotificationTimeToLeave,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationVpnLock',
        title: __('Vpn Lock', 'block-icons-google'),
        icon: blockIconsNotificationVpnLock,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationWc',
        title: __('Wc', 'block-icons-google'),
        icon: blockIconsNotificationWc,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationWifi',
        title: __('Wifi', 'block-icons-google'),
        icon: blockIconsNotificationWifi,
        categories: ['notification'],
    },
    {
        name: 'blockIconsNotificationWifiOff',
        title: __('Wifi Off', 'block-icons-google'),
        icon: blockIconsNotificationWifiOff,
        categories: ['notification'],
    },
];

// photo-and-image-new
import {
    blockIconsPhotoandimageAddAPhotoNew,
    blockIconsPhotoandimageAddPhotoAlternateNew,
    blockIconsPhotoandimageAdjustNew,
    blockIconsPhotoandimageAspectRatioNew,
    blockIconsPhotoandimageAutoStoriesNew,
    blockIconsPhotoandimageBlurOnNew,
    blockIconsPhotoandimageBrightness6New,
    blockIconsPhotoandimageBrushNew,
    blockIconsPhotoandimageCameraNew,
    blockIconsPhotoandimageCenterFocusStrongNew,
    blockIconsPhotoandimageCircleNew,
    blockIconsPhotoandimageContrastNew,
    blockIconsPhotoandimageCropFreeNew,
    blockIconsPhotoandimageCropNew,
    blockIconsPhotoandimageCropSquareNew,
    blockIconsPhotoandimageEditNew,
    blockIconsPhotoandimageFilterAltNew,
    blockIconsPhotoandimageFilterVintageNew,
    blockIconsPhotoandimageFlashOnNew,
    blockIconsPhotoandimageGridOnNew,
    blockIconsPhotoandimageImageNew,
    blockIconsPhotoandimageImageSearchNew,
    blockIconsPhotoandimageImagesmodeNew,
    blockIconsPhotoandimageLandscapeNew,
    blockIconsPhotoandimageLooksOneNew,
    blockIconsPhotoandimageNatureNew,
    blockIconsPhotoandimageNaturePeopleNew,
    blockIconsPhotoandimageNavigateBeforeNew,
    blockIconsPhotoandimageNavigateNextNew,
    blockIconsPhotoandimagePaletteNew,
    blockIconsPhotoandimagePhotoCameraNew,
    blockIconsPhotoandimagePhotoLibraryNew,
    blockIconsPhotoandimagePhotoNew,
    blockIconsPhotoandimagePictureAsPdfNew,
    blockIconsPhotoandimageRotateRightNew,
    blockIconsPhotoandimageSlideshowNew,
    blockIconsPhotoandimageStraightenNew,
    blockIconsPhotoandimageStyleNew,
    blockIconsPhotoandimageTimelapseNew,
    blockIconsPhotoandimageTimerNew,
    blockIconsPhotoandimageTuneNew,
    blockIconsPhotoandimageWbSunnyNew,
} from './photo-and-image-new';

// photo-and-image-new
const photoAndImageNewIcons = [
    {
        name: 'blockIconsPhotoandimageAddAPhotoNew',
        title: __('Photoandimage Add APhoto', 'block-icons-google'),
        icon: blockIconsPhotoandimageAddAPhotoNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageAddPhotoAlternateNew',
        title: __('Photoandimage Add Photo Alternate', 'block-icons-google'),
        icon: blockIconsPhotoandimageAddPhotoAlternateNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageAdjustNew',
        title: __('Photoandimage Adjust', 'block-icons-google'),
        icon: blockIconsPhotoandimageAdjustNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageAspectRatioNew',
        title: __('Photoandimage Aspect Ratio', 'block-icons-google'),
        icon: blockIconsPhotoandimageAspectRatioNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageAutoStoriesNew',
        title: __('Photoandimage Auto Stories', 'block-icons-google'),
        icon: blockIconsPhotoandimageAutoStoriesNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageBlurOnNew',
        title: __('Photoandimage Blur On', 'block-icons-google'),
        icon: blockIconsPhotoandimageBlurOnNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageBrightness6New',
        title: __('Photoandimage Brightness6', 'block-icons-google'),
        icon: blockIconsPhotoandimageBrightness6New,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageBrushNew',
        title: __('Photoandimage Brush', 'block-icons-google'),
        icon: blockIconsPhotoandimageBrushNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageCameraNew',
        title: __('Photoandimage Camera', 'block-icons-google'),
        icon: blockIconsPhotoandimageCameraNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageCenterFocusStrongNew',
        title: __('Photoandimage Center Focus Strong', 'block-icons-google'),
        icon: blockIconsPhotoandimageCenterFocusStrongNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageCircleNew',
        title: __('Photoandimage Circle', 'block-icons-google'),
        icon: blockIconsPhotoandimageCircleNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageContrastNew',
        title: __('Photoandimage Contrast', 'block-icons-google'),
        icon: blockIconsPhotoandimageContrastNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageCropFreeNew',
        title: __('Photoandimage Crop Free', 'block-icons-google'),
        icon: blockIconsPhotoandimageCropFreeNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageCropNew',
        title: __('Photoandimage Crop', 'block-icons-google'),
        icon: blockIconsPhotoandimageCropNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageCropSquareNew',
        title: __('Photoandimage Crop Square', 'block-icons-google'),
        icon: blockIconsPhotoandimageCropSquareNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageEditNew',
        title: __('Photoandimage Edit', 'block-icons-google'),
        icon: blockIconsPhotoandimageEditNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageFilterAltNew',
        title: __('Photoandimage Filter Alt', 'block-icons-google'),
        icon: blockIconsPhotoandimageFilterAltNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageFilterVintageNew',
        title: __('Photoandimage Filter Vintage', 'block-icons-google'),
        icon: blockIconsPhotoandimageFilterVintageNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageFlashOnNew',
        title: __('Photoandimage Flash On', 'block-icons-google'),
        icon: blockIconsPhotoandimageFlashOnNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageGridOnNew',
        title: __('Photoandimage Grid On', 'block-icons-google'),
        icon: blockIconsPhotoandimageGridOnNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageImageNew',
        title: __('Photoandimage Image', 'block-icons-google'),
        icon: blockIconsPhotoandimageImageNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageImageSearchNew',
        title: __('Photoandimage Image Search', 'block-icons-google'),
        icon: blockIconsPhotoandimageImageSearchNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageImagesmodeNew',
        title: __('Photoandimage Imagesmode', 'block-icons-google'),
        icon: blockIconsPhotoandimageImagesmodeNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageLandscapeNew',
        title: __('Photoandimage Landscape', 'block-icons-google'),
        icon: blockIconsPhotoandimageLandscapeNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageLooksOneNew',
        title: __('Photoandimage Looks One', 'block-icons-google'),
        icon: blockIconsPhotoandimageLooksOneNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageNatureNew',
        title: __('Photoandimage Nature', 'block-icons-google'),
        icon: blockIconsPhotoandimageNatureNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageNaturePeopleNew',
        title: __('Photoandimage Nature People', 'block-icons-google'),
        icon: blockIconsPhotoandimageNaturePeopleNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageNavigateBeforeNew',
        title: __('Photoandimage Navigate Before', 'block-icons-google'),
        icon: blockIconsPhotoandimageNavigateBeforeNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageNavigateNextNew',
        title: __('Photoandimage Navigate Next', 'block-icons-google'),
        icon: blockIconsPhotoandimageNavigateNextNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimagePaletteNew',
        title: __('Photoandimage Palette', 'block-icons-google'),
        icon: blockIconsPhotoandimagePaletteNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimagePhotoCameraNew',
        title: __('Photoandimage Photo Camera', 'block-icons-google'),
        icon: blockIconsPhotoandimagePhotoCameraNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimagePhotoLibraryNew',
        title: __('Photoandimage Photo Library', 'block-icons-google'),
        icon: blockIconsPhotoandimagePhotoLibraryNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimagePhotoNew',
        title: __('Photoandimage Photo', 'block-icons-google'),
        icon: blockIconsPhotoandimagePhotoNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimagePictureAsPdfNew',
        title: __('Photoandimage Picture As Pdf', 'block-icons-google'),
        icon: blockIconsPhotoandimagePictureAsPdfNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageRotateRightNew',
        title: __('Photoandimage Rotate Right', 'block-icons-google'),
        icon: blockIconsPhotoandimageRotateRightNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageSlideshowNew',
        title: __('Photoandimage Slideshow', 'block-icons-google'),
        icon: blockIconsPhotoandimageSlideshowNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageStraightenNew',
        title: __('Photoandimage Straighten', 'block-icons-google'),
        icon: blockIconsPhotoandimageStraightenNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageStyleNew',
        title: __('Photoandimage Style', 'block-icons-google'),
        icon: blockIconsPhotoandimageStyleNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageTimelapseNew',
        title: __('Photoandimage Timelapse', 'block-icons-google'),
        icon: blockIconsPhotoandimageTimelapseNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageTimerNew',
        title: __('Photoandimage Timer', 'block-icons-google'),
        icon: blockIconsPhotoandimageTimerNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageTuneNew',
        title: __('Photoandimage Tune', 'block-icons-google'),
        icon: blockIconsPhotoandimageTuneNew,
        categories: ['photo-and-image-new'],
    },
    {
        name: 'blockIconsPhotoandimageWbSunnyNew',
        title: __('Photoandimage Wb Sunny', 'block-icons-google'),
        icon: blockIconsPhotoandimageWbSunnyNew,
        categories: ['photo-and-image-new'],
    },
];

// places
import {
    blockIconsPlacesAcUnit,
    blockIconsPlacesAirportShuttle,
    blockIconsPlacesAllInclusive,
    blockIconsPlacesApartment,
    blockIconsPlacesBathtub,
    blockIconsPlacesBeachAccess,
    blockIconsPlacesBusinessCenter,
    blockIconsPlacesCasino,
    blockIconsPlacesCheckroom,
    blockIconsPlacesChildCare,
    blockIconsPlacesChildFriendly,
    blockIconsPlacesCorporateFare,
    blockIconsPlacesCottage,
    blockIconsPlacesEscalatorWarning,
    blockIconsPlacesFamilyRestroom,
    blockIconsPlacesFitnessCenter,
    blockIconsPlacesFoodBank,
    blockIconsPlacesFoundation,
    blockIconsPlacesFreeBreakfast,
    blockIconsPlacesGite,
    blockIconsPlacesGrass,
    blockIconsPlacesHolidayVillage,
    blockIconsPlacesHouse,
    blockIconsPlacesKitchen,
    blockIconsPlacesMeetingRoom,
    blockIconsPlacesNightShelter,
    blockIconsPlacesOtherHouses,
    blockIconsPlacesPool,
    blockIconsPlacesRoofing,
    blockIconsPlacesRoomPreferences,
    blockIconsPlacesRoomService,
    blockIconsPlacesSpa,
    blockIconsPlacesSportsBar,
    blockIconsPlacesStorefront,
    blockIconsPlacesVilla,
} from './places';

// places
const placesIcons = [
    {
        name: 'blockIconsPlacesAcUnit',
        title: __('Ac Unit', 'block-icons-google'),
        icon: blockIconsPlacesAcUnit,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesAirportShuttle',
        title: __('Airport Shuttle', 'block-icons-google'),
        icon: blockIconsPlacesAirportShuttle,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesAllInclusive',
        title: __('All Inclusive', 'block-icons-google'),
        icon: blockIconsPlacesAllInclusive,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesApartment',
        title: __('Apartment', 'block-icons-google'),
        icon: blockIconsPlacesApartment,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesBathtub',
        title: __('Bathtub', 'block-icons-google'),
        icon: blockIconsPlacesBathtub,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesBeachAccess',
        title: __('Beach Access', 'block-icons-google'),
        icon: blockIconsPlacesBeachAccess,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesBusinessCenter',
        title: __('Business Center', 'block-icons-google'),
        icon: blockIconsPlacesBusinessCenter,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesCasino',
        title: __('Casino', 'block-icons-google'),
        icon: blockIconsPlacesCasino,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesCheckroom',
        title: __('Checkroom', 'block-icons-google'),
        icon: blockIconsPlacesCheckroom,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesChildCare',
        title: __('Child Care', 'block-icons-google'),
        icon: blockIconsPlacesChildCare,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesChildFriendly',
        title: __('Child Friendly', 'block-icons-google'),
        icon: blockIconsPlacesChildFriendly,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesCorporateFare',
        title: __('Corporate Fare', 'block-icons-google'),
        icon: blockIconsPlacesCorporateFare,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesCottage',
        title: __('Cottage', 'block-icons-google'),
        icon: blockIconsPlacesCottage,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesEscalatorWarning',
        title: __('Escalator Warning', 'block-icons-google'),
        icon: blockIconsPlacesEscalatorWarning,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesFamilyRestroom',
        title: __('Family Restroom', 'block-icons-google'),
        icon: blockIconsPlacesFamilyRestroom,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesFitnessCenter',
        title: __('Fitness Center', 'block-icons-google'),
        icon: blockIconsPlacesFitnessCenter,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesFoodBank',
        title: __('Food Bank', 'block-icons-google'),
        icon: blockIconsPlacesFoodBank,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesFoundation',
        title: __('Foundation', 'block-icons-google'),
        icon: blockIconsPlacesFoundation,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesFreeBreakfast',
        title: __('Free Breakfast', 'block-icons-google'),
        icon: blockIconsPlacesFreeBreakfast,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesGite',
        title: __('Gite', 'block-icons-google'),
        icon: blockIconsPlacesGite,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesGrass',
        title: __('Grass', 'block-icons-google'),
        icon: blockIconsPlacesGrass,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesHolidayVillage',
        title: __('Holiday Village', 'block-icons-google'),
        icon: blockIconsPlacesHolidayVillage,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesHouse',
        title: __('House', 'block-icons-google'),
        icon: blockIconsPlacesHouse,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesKitchen',
        title: __('Kitchen', 'block-icons-google'),
        icon: blockIconsPlacesKitchen,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesMeetingRoom',
        title: __('Meeting Room', 'block-icons-google'),
        icon: blockIconsPlacesMeetingRoom,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesNightShelter',
        title: __('Night Shelter', 'block-icons-google'),
        icon: blockIconsPlacesNightShelter,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesOtherHouses',
        title: __('Other Houses', 'block-icons-google'),
        icon: blockIconsPlacesOtherHouses,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesPool',
        title: __('Pool', 'block-icons-google'),
        icon: blockIconsPlacesPool,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesRoofing',
        title: __('Roofing', 'block-icons-google'),
        icon: blockIconsPlacesRoofing,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesRoomPreferences',
        title: __('Room Preferences', 'block-icons-google'),
        icon: blockIconsPlacesRoomPreferences,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesRoomService',
        title: __('Room Service', 'block-icons-google'),
        icon: blockIconsPlacesRoomService,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesSpa',
        title: __('Spa', 'block-icons-google'),
        icon: blockIconsPlacesSpa,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesSportsBar',
        title: __('Sports Bar', 'block-icons-google'),
        icon: blockIconsPlacesSportsBar,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesStorefront',
        title: __('Storefront', 'block-icons-google'),
        icon: blockIconsPlacesStorefront,
        categories: ['places'],
    },
    {
        name: 'blockIconsPlacesVilla',
        title: __('Villa', 'block-icons-google'),
        icon: blockIconsPlacesVilla,
        categories: ['places'],
    },
];

// privacy-and-security-new
import {
    blockIconsPrivacyandsecurityAddModeratorNew,
    blockIconsPrivacyandsecurityAdminPanelSettingsNew,
    blockIconsPrivacyandsecurityAssuredWorkloadNew,
    blockIconsPrivacyandsecurityBadgeNew,
    blockIconsPrivacyandsecurityDisabledVisibleNew,
    blockIconsPrivacyandsecurityE911EmergencyNew,
    blockIconsPrivacyandsecurityEncryptedNew,
    blockIconsPrivacyandsecurityEnhancedEncryptionNew,
    blockIconsPrivacyandsecurityExclamationNew,
    blockIconsPrivacyandsecurityKeyVisualizerNew,
    blockIconsPrivacyandsecurityNoEncryptionNew,
    blockIconsPrivacyandsecurityPasskeyNew,
    blockIconsPrivacyandsecurityPolicyNew,
    blockIconsPrivacyandsecurityPrivacyTipNew,
    blockIconsPrivacyandsecurityPrivateConnectivityNew,
    blockIconsPrivacyandsecurityRemoveModeratorNew,
    blockIconsPrivacyandsecurityReportNew,
    blockIconsPrivacyandsecurityReportOffNew,
    blockIconsPrivacyandsecuritySecurityNew,
    blockIconsPrivacyandsecurityShieldLockedNew,
    blockIconsPrivacyandsecurityShieldLockNew,
    blockIconsPrivacyandsecurityShieldNew,
    blockIconsPrivacyandsecurityShieldPersonNew,
    blockIconsPrivacyandsecurityShieldQuestionNew,
    blockIconsPrivacyandsecuritySyncLockNew,
    blockIconsPrivacyandsecurityVerifiedUserNew,
    blockIconsPrivacyandsecurityVpnKeyAlertNew,
    blockIconsPrivacyandsecurityVpnKeyNew,
    blockIconsPrivacyandsecurityVpnKeyOffNew,
    blockIconsPrivacyandsecurityVpnLockNew,
    blockIconsPrivacyandsecurityWifiPasswordNew,
} from './privacy-and-security-new';

// privacy-and-security-new
const privacyAndSecurityNewIcons = [
    {
        name: 'blockIconsPrivacyandsecurityAddModeratorNew',
        title: __('Privacyandsecurity Add Moderator', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityAddModeratorNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityAdminPanelSettingsNew',
        title: __('Privacyandsecurity Admin Panel Settings', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityAdminPanelSettingsNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityAssuredWorkloadNew',
        title: __('Privacyandsecurity Assured Workload', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityAssuredWorkloadNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityBadgeNew',
        title: __('Privacyandsecurity Badge', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityBadgeNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityDisabledVisibleNew',
        title: __('Privacyandsecurity Disabled Visible', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityDisabledVisibleNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityE911EmergencyNew',
        title: __('Privacyandsecurity E911Emergency', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityE911EmergencyNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityEncryptedNew',
        title: __('Privacyandsecurity Encrypted', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityEncryptedNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityEnhancedEncryptionNew',
        title: __('Privacyandsecurity Enhanced Encryption', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityEnhancedEncryptionNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityExclamationNew',
        title: __('Privacyandsecurity Exclamation', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityExclamationNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityKeyVisualizerNew',
        title: __('Privacyandsecurity Key Visualizer', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityKeyVisualizerNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityNoEncryptionNew',
        title: __('Privacyandsecurity No Encryption', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityNoEncryptionNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityPasskeyNew',
        title: __('Privacyandsecurity Passkey', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityPasskeyNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityPolicyNew',
        title: __('Privacyandsecurity Policy', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityPolicyNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityPrivacyTipNew',
        title: __('Privacyandsecurity Privacy Tip', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityPrivacyTipNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityPrivateConnectivityNew',
        title: __('Privacyandsecurity Private Connectivity', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityPrivateConnectivityNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityRemoveModeratorNew',
        title: __('Privacyandsecurity Remove Moderator', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityRemoveModeratorNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityReportNew',
        title: __('Privacyandsecurity Report', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityReportNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityReportOffNew',
        title: __('Privacyandsecurity Report Off', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityReportOffNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecuritySecurityNew',
        title: __('Privacyandsecurity Security', 'block-icons-google'),
        icon: blockIconsPrivacyandsecuritySecurityNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityShieldLockedNew',
        title: __('Privacyandsecurity Shield Locked', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityShieldLockedNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityShieldLockNew',
        title: __('Privacyandsecurity Shield Lock', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityShieldLockNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityShieldNew',
        title: __('Privacyandsecurity Shield', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityShieldNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityShieldPersonNew',
        title: __('Privacyandsecurity Shield Person', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityShieldPersonNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityShieldQuestionNew',
        title: __('Privacyandsecurity Shield Question', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityShieldQuestionNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecuritySyncLockNew',
        title: __('Privacyandsecurity Sync Lock', 'block-icons-google'),
        icon: blockIconsPrivacyandsecuritySyncLockNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityVerifiedUserNew',
        title: __('Privacyandsecurity Verified User', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityVerifiedUserNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityVpnKeyAlertNew',
        title: __('Privacyandsecurity Vpn Key Alert', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityVpnKeyAlertNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityVpnKeyNew',
        title: __('Privacyandsecurity Vpn Key', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityVpnKeyNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityVpnKeyOffNew',
        title: __('Privacyandsecurity Vpn Key Off', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityVpnKeyOffNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityVpnLockNew',
        title: __('Privacyandsecurity Vpn Lock', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityVpnLockNew,
        categories: ['privacy-and-security-new'],
    },
    {
        name: 'blockIconsPrivacyandsecurityWifiPasswordNew',
        title: __('Privacyandsecurity Wifi Password', 'block-icons-google'),
        icon: blockIconsPrivacyandsecurityWifiPasswordNew,
        categories: ['privacy-and-security-new'],
    },
];

// search
import {
    blockIconsSearchBathroom,
    blockIconsSearchBed,
    blockIconsSearchBedroomBaby,
    blockIconsSearchBedroomChild,
    blockIconsSearchBedroomParent,
    blockIconsSearchBlender,
    blockIconsSearchCameraIndoor,
    blockIconsSearchCameraOutdoor,
    blockIconsSearchChairAlt,
    blockIconsSearchChair,
    blockIconsSearchCoffee,
    blockIconsSearchCoffeeMaker,
    blockIconsSearchDining,
    blockIconsSearchDoorBack,
    blockIconsSearchDoorbell,
    blockIconsSearchDoorFront,
    blockIconsSearchDoorSliding,
    blockIconsSearchFeed,
    blockIconsSearchFlatware,
    blockIconsSearchGarage,
    blockIconsSearchLight,
    blockIconsSearchLiving,
    blockIconsSearchManageSearch,
    blockIconsSearchPodcasts,
    blockIconsSearchShower,
    blockIconsSearchTableBar,
    blockIconsSearchTableRestaurant,
    blockIconsSearchWindow,
    blockIconsSearchYard,
} from './search';

// search
const searchIcons = [
    {
        name: 'blockIconsSearchBathroom',
        title: __('Bathroom', 'block-icons-google'),
        icon: blockIconsSearchBathroom,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchBed',
        title: __('Bed', 'block-icons-google'),
        icon: blockIconsSearchBed,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchBedroomBaby',
        title: __('Bedroom Baby', 'block-icons-google'),
        icon: blockIconsSearchBedroomBaby,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchBedroomChild',
        title: __('Bedroom Child', 'block-icons-google'),
        icon: blockIconsSearchBedroomChild,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchBedroomParent',
        title: __('Bedroom Parent', 'block-icons-google'),
        icon: blockIconsSearchBedroomParent,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchBlender',
        title: __('Blender', 'block-icons-google'),
        icon: blockIconsSearchBlender,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchCameraIndoor',
        title: __('Camera Indoor', 'block-icons-google'),
        icon: blockIconsSearchCameraIndoor,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchCameraOutdoor',
        title: __('Camera Outdoor', 'block-icons-google'),
        icon: blockIconsSearchCameraOutdoor,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchChairAlt',
        title: __('Chair Alt', 'block-icons-google'),
        icon: blockIconsSearchChairAlt,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchChair',
        title: __('Chair', 'block-icons-google'),
        icon: blockIconsSearchChair,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchCoffee',
        title: __('Coffee', 'block-icons-google'),
        icon: blockIconsSearchCoffee,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchCoffeeMaker',
        title: __('Coffee Maker', 'block-icons-google'),
        icon: blockIconsSearchCoffeeMaker,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchDining',
        title: __('Dining', 'block-icons-google'),
        icon: blockIconsSearchDining,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchDoorBack',
        title: __('Door Back', 'block-icons-google'),
        icon: blockIconsSearchDoorBack,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchDoorbell',
        title: __('Doorbell', 'block-icons-google'),
        icon: blockIconsSearchDoorbell,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchDoorFront',
        title: __('Door Front', 'block-icons-google'),
        icon: blockIconsSearchDoorFront,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchDoorSliding',
        title: __('Door Sliding', 'block-icons-google'),
        icon: blockIconsSearchDoorSliding,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchFeed',
        title: __('Feed', 'block-icons-google'),
        icon: blockIconsSearchFeed,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchFlatware',
        title: __('Flatware', 'block-icons-google'),
        icon: blockIconsSearchFlatware,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchGarage',
        title: __('Garage', 'block-icons-google'),
        icon: blockIconsSearchGarage,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchLight',
        title: __('Light', 'block-icons-google'),
        icon: blockIconsSearchLight,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchLiving',
        title: __('Living', 'block-icons-google'),
        icon: blockIconsSearchLiving,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchManageSearch',
        title: __('Manage', 'block-icons-google'),
        icon: blockIconsSearchManageSearch,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchPodcasts',
        title: __('Podcasts', 'block-icons-google'),
        icon: blockIconsSearchPodcasts,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchShower',
        title: __('Shower', 'block-icons-google'),
        icon: blockIconsSearchShower,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchTableBar',
        title: __('Table Bar', 'block-icons-google'),
        icon: blockIconsSearchTableBar,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchTableRestaurant',
        title: __('Table Restaurant', 'block-icons-google'),
        icon: blockIconsSearchTableRestaurant,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchWindow',
        title: __('Window', 'block-icons-google'),
        icon: blockIconsSearchWindow,
        categories: ['search'],
    },
    {
        name: 'blockIconsSearchYard',
        title: __('Yard', 'block-icons-google'),
        icon: blockIconsSearchYard,
        categories: ['search'],
    },
];

// social
import {
    blockIconsSocialConstruction,
    blockIconsSocialEmojiEmotions,
    blockIconsSocialEmojiEvents,
    blockIconsSocialEmojiObjects,
    blockIconsSocialEngineering,
    blockIconsSocialGroupAdd,
    blockIconsSocialGroup,
    blockIconsSocialGroups,
    blockIconsSocialHealthAndSafety,
    blockIconsSocialHistoryEdu,
    blockIconsSocialiOSShare,
    blockIconsSocialLocationCity,
    blockIconsSocialMilitaryTech,
    blockIconsSocialNotificationsActive,
    blockIconsSocialNotifications,
    blockIconsSocialNotificationsNone,
    blockIconsSocialPeopleAlt,
    blockIconsSocialPeople,
    blockIconsSocialPersonAddAlt,
    blockIconsSocialPersonAdd,
    blockIconsSocialPerson,
    blockIconsSocialPersonOutline,
    blockIconsSocialPrecisionManufacturing,
    blockIconsSocialPsychology,
    blockIconsSocialPublic,
    blockIconsSocialSchool,
    blockIconsSocialScience,
    blockIconsSocialSentimentSatisfied,
    blockIconsSocialSentimentVerySatisfied,
    blockIconsSocialShare,
    blockIconsSocialSportsEsports,
    blockIconsSocialThumbUpAlt,
    blockIconsSocialTravelExplore,
    blockIconsSocialWaterDrop,
    blockIconsSocialWorkspacePremium,
} from './social';

// social
const socialIcons = [
    {
        name: 'blockIconsSocialConstruction',
        title: __('Construction', 'block-icons-google'),
        icon: blockIconsSocialConstruction,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialEmojiEmotions',
        title: __('Emoji Emotions', 'block-icons-google'),
        icon: blockIconsSocialEmojiEmotions,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialEmojiEvents',
        title: __('Emoji Events', 'block-icons-google'),
        icon: blockIconsSocialEmojiEvents,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialEmojiObjects',
        title: __('Emoji Objects', 'block-icons-google'),
        icon: blockIconsSocialEmojiObjects,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialEngineering',
        title: __('Engineering', 'block-icons-google'),
        icon: blockIconsSocialEngineering,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialGroupAdd',
        title: __('Group Add', 'block-icons-google'),
        icon: blockIconsSocialGroupAdd,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialGroup',
        title: __('Group', 'block-icons-google'),
        icon: blockIconsSocialGroup,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialGroups',
        title: __('Groups', 'block-icons-google'),
        icon: blockIconsSocialGroups,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialHealthAndSafety',
        title: __('Health And Safety', 'block-icons-google'),
        icon: blockIconsSocialHealthAndSafety,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialHistoryEdu',
        title: __('History Edu', 'block-icons-google'),
        icon: blockIconsSocialHistoryEdu,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialiOSShare',
        title: __('i OSShare', 'block-icons-google'),
        icon: blockIconsSocialiOSShare,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialLocationCity',
        title: __('Location City', 'block-icons-google'),
        icon: blockIconsSocialLocationCity,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialMilitaryTech',
        title: __('Military Tech', 'block-icons-google'),
        icon: blockIconsSocialMilitaryTech,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialNotificationsActive',
        title: __('Notifications Active', 'block-icons-google'),
        icon: blockIconsSocialNotificationsActive,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialNotifications',
        title: __('Notifications', 'block-icons-google'),
        icon: blockIconsSocialNotifications,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialNotificationsNone',
        title: __('Notifications None', 'block-icons-google'),
        icon: blockIconsSocialNotificationsNone,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialPeopleAlt',
        title: __('People Alt', 'block-icons-google'),
        icon: blockIconsSocialPeopleAlt,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialPeople',
        title: __('People', 'block-icons-google'),
        icon: blockIconsSocialPeople,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialPersonAddAlt',
        title: __('Person Add Alt', 'block-icons-google'),
        icon: blockIconsSocialPersonAddAlt,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialPersonAdd',
        title: __('Person Add', 'block-icons-google'),
        icon: blockIconsSocialPersonAdd,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialPerson',
        title: __('Person', 'block-icons-google'),
        icon: blockIconsSocialPerson,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialPersonOutline',
        title: __('Person Outline', 'block-icons-google'),
        icon: blockIconsSocialPersonOutline,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialPrecisionManufacturing',
        title: __('Precision Manufacturing', 'block-icons-google'),
        icon: blockIconsSocialPrecisionManufacturing,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialPsychology',
        title: __('Psychology', 'block-icons-google'),
        icon: blockIconsSocialPsychology,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialPublic',
        title: __('Public', 'block-icons-google'),
        icon: blockIconsSocialPublic,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialSchool',
        title: __('School', 'block-icons-google'),
        icon: blockIconsSocialSchool,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialScience',
        title: __('Science', 'block-icons-google'),
        icon: blockIconsSocialScience,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialSentimentSatisfied',
        title: __('Sentiment Satisfied', 'block-icons-google'),
        icon: blockIconsSocialSentimentSatisfied,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialSentimentVerySatisfied',
        title: __('Sentiment Very Satisfied', 'block-icons-google'),
        icon: blockIconsSocialSentimentVerySatisfied,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialShare',
        title: __('Share', 'block-icons-google'),
        icon: blockIconsSocialShare,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialSportsEsports',
        title: __('Sports Esports', 'block-icons-google'),
        icon: blockIconsSocialSportsEsports,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialThumbUpAlt',
        title: __('Thumb Up Alt', 'block-icons-google'),
        icon: blockIconsSocialThumbUpAlt,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialTravelExplore',
        title: __('Travel Explore', 'block-icons-google'),
        icon: blockIconsSocialTravelExplore,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialWaterDrop',
        title: __('Water Drop', 'block-icons-google'),
        icon: blockIconsSocialWaterDrop,
        categories: ['social'],
    },
    {
        name: 'blockIconsSocialWorkspacePremium',
        title: __('Workspace Premium', 'block-icons-google'),
        icon: blockIconsSocialWorkspacePremium,
        categories: ['social'],
    },
];

// social-new
import {
    blockIconsSocialCompostNew,
    blockIconsSocialDiamondNew,
    blockIconsSocialDiversity1New,
    blockIconsSocialDiversity3New,
    blockIconsSocialEcoNew,
    blockIconsSocialEmojiObjectsNew,
    blockIconsSocialEmojiPeopleNew,
    blockIconsSocialFaceNew,
    blockIconsSocialForestNew,
    blockIconsSocialGavelNew,
    blockIconsSocialGroupAddNew,
    blockIconsSocialGroupNew,
    blockIconsSocialGroupsNew,
    blockIconsSocialHandshakeNew,
    blockIconsSocialHealthAndSafetyNew,
    blockIconsSocialMilitaryTechNew,
    blockIconsSocialMonitorHeartNew,
    blockIconsSocialMoodNew,
    blockIconsSocialPersonAddNew,
    blockIconsSocialPersonNew,
    blockIconsSocialPersonRemoveNew,
    blockIconsSocialPetsNew,
    blockIconsSocialPsychologyNew,
    blockIconsSocialPublicNew,
    blockIconsSocialQuizNew,
    blockIconsSocialRecommendNew,
    blockIconsSocialRecyclingNew,
    blockIconsSocialRocketLaunchNew,
    blockIconsSocialSentimentDissatisfiedNew,
    blockIconsSocialSentimentSatisfiedNew,
    blockIconsSocialSentimentVerySatisfiedNew,
    blockIconsSocialShareNew,
    blockIconsSocialSunnyNew,
    blockIconsSocialSupportAgentNew,
    blockIconsSocialThumbDownNew,
    blockIconsSocialThumbUpNew,
    blockIconsSocialTravelExploreNew,
    blockIconsSocialVaccinesNew,
    blockIconsSocialWaterDropNew,
    blockIconsSocialWavingHandNew,
    blockIconsSocialWorkspacePremiumNew,
    blockIconsSocialWorkspacesNew,
} from './social-new';

// social-new
const socialNewIcons = [
    {
        name: 'blockIconsSocialCompostNew',
        title: __('Compost', 'block-icons-google'),
        icon: blockIconsSocialCompostNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialDiamondNew',
        title: __('Diamond', 'block-icons-google'),
        icon: blockIconsSocialDiamondNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialDiversity1New',
        title: __('Diversity1', 'block-icons-google'),
        icon: blockIconsSocialDiversity1New,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialDiversity3New',
        title: __('Diversity3', 'block-icons-google'),
        icon: blockIconsSocialDiversity3New,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialEcoNew',
        title: __('Eco', 'block-icons-google'),
        icon: blockIconsSocialEcoNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialEmojiObjectsNew',
        title: __('Emoji Objects', 'block-icons-google'),
        icon: blockIconsSocialEmojiObjectsNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialEmojiPeopleNew',
        title: __('Emoji People', 'block-icons-google'),
        icon: blockIconsSocialEmojiPeopleNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialFaceNew',
        title: __('Face', 'block-icons-google'),
        icon: blockIconsSocialFaceNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialForestNew',
        title: __('Forest', 'block-icons-google'),
        icon: blockIconsSocialForestNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialGavelNew',
        title: __('Gavel', 'block-icons-google'),
        icon: blockIconsSocialGavelNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialGroupAddNew',
        title: __('Group Add', 'block-icons-google'),
        icon: blockIconsSocialGroupAddNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialGroupNew',
        title: __('Group', 'block-icons-google'),
        icon: blockIconsSocialGroupNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialGroupsNew',
        title: __('Groups', 'block-icons-google'),
        icon: blockIconsSocialGroupsNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialHandshakeNew',
        title: __('Handshake', 'block-icons-google'),
        icon: blockIconsSocialHandshakeNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialHealthAndSafetyNew',
        title: __('Health And Safety', 'block-icons-google'),
        icon: blockIconsSocialHealthAndSafetyNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialMilitaryTechNew',
        title: __('Military Tech', 'block-icons-google'),
        icon: blockIconsSocialMilitaryTechNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialMonitorHeartNew',
        title: __('Monitor Heart', 'block-icons-google'),
        icon: blockIconsSocialMonitorHeartNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialMoodNew',
        title: __('Mood', 'block-icons-google'),
        icon: blockIconsSocialMoodNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialPersonAddNew',
        title: __('Person Add', 'block-icons-google'),
        icon: blockIconsSocialPersonAddNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialPersonNew',
        title: __('Person', 'block-icons-google'),
        icon: blockIconsSocialPersonNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialPersonRemoveNew',
        title: __('Person Remove', 'block-icons-google'),
        icon: blockIconsSocialPersonRemoveNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialPetsNew',
        title: __('Pets', 'block-icons-google'),
        icon: blockIconsSocialPetsNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialPsychologyNew',
        title: __('Psychology', 'block-icons-google'),
        icon: blockIconsSocialPsychologyNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialPublicNew',
        title: __('Public', 'block-icons-google'),
        icon: blockIconsSocialPublicNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialQuizNew',
        title: __('Quiz', 'block-icons-google'),
        icon: blockIconsSocialQuizNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialRecommendNew',
        title: __('Recommend', 'block-icons-google'),
        icon: blockIconsSocialRecommendNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialRecyclingNew',
        title: __('Recycling', 'block-icons-google'),
        icon: blockIconsSocialRecyclingNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialRocketLaunchNew',
        title: __('Rocket Launch', 'block-icons-google'),
        icon: blockIconsSocialRocketLaunchNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialSentimentDissatisfiedNew',
        title: __('Sentiment Dissatisfied', 'block-icons-google'),
        icon: blockIconsSocialSentimentDissatisfiedNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialSentimentSatisfiedNew',
        title: __('Sentiment Satisfied', 'block-icons-google'),
        icon: blockIconsSocialSentimentSatisfiedNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialSentimentVerySatisfiedNew',
        title: __('Sentiment Very Satisfied', 'block-icons-google'),
        icon: blockIconsSocialSentimentVerySatisfiedNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialShareNew',
        title: __('Share', 'block-icons-google'),
        icon: blockIconsSocialShareNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialSunnyNew',
        title: __('Sunny', 'block-icons-google'),
        icon: blockIconsSocialSunnyNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialSupportAgentNew',
        title: __('Support Agent', 'block-icons-google'),
        icon: blockIconsSocialSupportAgentNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialThumbDownNew',
        title: __('Thumb Down', 'block-icons-google'),
        icon: blockIconsSocialThumbDownNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialThumbUpNew',
        title: __('Thumb Up', 'block-icons-google'),
        icon: blockIconsSocialThumbUpNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialTravelExploreNew',
        title: __('Travel Explore', 'block-icons-google'),
        icon: blockIconsSocialTravelExploreNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialVaccinesNew',
        title: __('Vaccines', 'block-icons-google'),
        icon: blockIconsSocialVaccinesNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialWaterDropNew',
        title: __('Water Drop', 'block-icons-google'),
        icon: blockIconsSocialWaterDropNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialWavingHandNew',
        title: __('Waving Hand', 'block-icons-google'),
        icon: blockIconsSocialWavingHandNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialWorkspacePremiumNew',
        title: __('Workspace Premium', 'block-icons-google'),
        icon: blockIconsSocialWorkspacePremiumNew,
        categories: ['social-new'],
    },
    {
        name: 'blockIconsSocialWorkspacesNew',
        title: __('Workspaces', 'block-icons-google'),
        icon: blockIconsSocialWorkspacesNew,
        categories: ['social-new'],
    },
];

// text-formatting-new
import {
    blockIconsTextformattingArchiveNew,
    blockIconsTextformattingArticleNew,
    blockIconsTextformattingAssignmentNew,
    blockIconsTextformattingAttachFileNew,
    blockIconsTextformattingBookNew,
    blockIconsTextformattingBorderColorNew,
    blockIconsTextformattingChecklistNew,
    blockIconsTextformattingCloudDownloadNew,
    blockIconsTextformattingCloudNew,
    blockIconsTextformattingCloudUploadNew,
    blockIconsTextformattingContactPageNew,
    blockIconsTextformattingContentCopyNew,
    blockIconsTextformattingDashboardNew,
    blockIconsTextformattingDescriptionNew,
    blockIconsTextformattingDesignServicesNew,
    blockIconsTextformattingDraftNew,
    blockIconsTextformattingDragHandleNew,
    blockIconsTextformattingDrawNew,
    blockIconsTextformattingEditNoteNew,
    blockIconsTextformattingFactCheckNew,
    blockIconsTextformattingFeedNew,
    blockIconsTextformattingFileCopyNew,
    blockIconsTextformattingFolderNew,
    blockIconsTextformattingFolderOpenNew,
    blockIconsTextformattingFormatListBulletedNew,
    blockIconsTextformattingFormatQuoteNew,
    blockIconsTextformattingGridViewNew,
    blockIconsTextformattingHistoryEduNew,
    blockIconsTextformattingInventoryNew,
    blockIconsTextformattingListAltNew,
    blockIconsTextformattingListNew,
    blockIconsTextformattingMenuBookNew,
    blockIconsTextformattingNewspaperNew,
    blockIconsTextformattingNoteAddNew,
    blockIconsTextformattingPendingActionsNew,
    blockIconsTextformattingPostAddNew,
    blockIconsTextformattingRequestQuoteNew,
    blockIconsTextformattingSpaceDashboardNew,
    blockIconsTextformattingSummarizeNew,
    blockIconsTextformattingTableNew,
    blockIconsTextformattingTaskNew,
    blockIconsTextformattingViewListNew,
} from './text-formatting-new';

// text-formatting-new
const textFormattingNewIcons = [
    {
        name: 'blockIconsTextformattingArchiveNew',
        title: __('Textformatting Archive', 'block-icons-google'),
        icon: blockIconsTextformattingArchiveNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingArticleNew',
        title: __('Textformatting Article', 'block-icons-google'),
        icon: blockIconsTextformattingArticleNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingAssignmentNew',
        title: __('Textformatting Assignment', 'block-icons-google'),
        icon: blockIconsTextformattingAssignmentNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingAttachFileNew',
        title: __('Textformatting Attach File', 'block-icons-google'),
        icon: blockIconsTextformattingAttachFileNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingBookNew',
        title: __('Textformatting Book', 'block-icons-google'),
        icon: blockIconsTextformattingBookNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingBorderColorNew',
        title: __('Textformatting Border Color', 'block-icons-google'),
        icon: blockIconsTextformattingBorderColorNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingChecklistNew',
        title: __('Textformatting Checklist', 'block-icons-google'),
        icon: blockIconsTextformattingChecklistNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingCloudDownloadNew',
        title: __('Textformatting Cloud Download', 'block-icons-google'),
        icon: blockIconsTextformattingCloudDownloadNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingCloudNew',
        title: __('Textformatting Cloud', 'block-icons-google'),
        icon: blockIconsTextformattingCloudNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingCloudUploadNew',
        title: __('Textformatting Cloud Upload', 'block-icons-google'),
        icon: blockIconsTextformattingCloudUploadNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingContactPageNew',
        title: __('Textformatting Contact Page', 'block-icons-google'),
        icon: blockIconsTextformattingContactPageNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingContentCopyNew',
        title: __('Textformatting Content Copy', 'block-icons-google'),
        icon: blockIconsTextformattingContentCopyNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingDashboardNew',
        title: __('Textformatting Dashboard', 'block-icons-google'),
        icon: blockIconsTextformattingDashboardNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingDescriptionNew',
        title: __('Textformatting Description', 'block-icons-google'),
        icon: blockIconsTextformattingDescriptionNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingDesignServicesNew',
        title: __('Textformatting Design Services', 'block-icons-google'),
        icon: blockIconsTextformattingDesignServicesNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingDraftNew',
        title: __('Textformatting Draft', 'block-icons-google'),
        icon: blockIconsTextformattingDraftNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingDragHandleNew',
        title: __('Textformatting Drag Handle', 'block-icons-google'),
        icon: blockIconsTextformattingDragHandleNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingDrawNew',
        title: __('Textformatting Draw', 'block-icons-google'),
        icon: blockIconsTextformattingDrawNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingEditNoteNew',
        title: __('Textformatting Edit Note', 'block-icons-google'),
        icon: blockIconsTextformattingEditNoteNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingFactCheckNew',
        title: __('Textformatting Fact Check', 'block-icons-google'),
        icon: blockIconsTextformattingFactCheckNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingFeedNew',
        title: __('Textformatting Feed', 'block-icons-google'),
        icon: blockIconsTextformattingFeedNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingFileCopyNew',
        title: __('Textformatting File Copy', 'block-icons-google'),
        icon: blockIconsTextformattingFileCopyNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingFolderNew',
        title: __('Textformatting Folder', 'block-icons-google'),
        icon: blockIconsTextformattingFolderNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingFolderOpenNew',
        title: __('Textformatting Folder Open', 'block-icons-google'),
        icon: blockIconsTextformattingFolderOpenNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingFormatListBulletedNew',
        title: __('Textformatting Format List Bulleted', 'block-icons-google'),
        icon: blockIconsTextformattingFormatListBulletedNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingFormatQuoteNew',
        title: __('Textformatting Format Quote', 'block-icons-google'),
        icon: blockIconsTextformattingFormatQuoteNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingGridViewNew',
        title: __('Textformatting Grid View', 'block-icons-google'),
        icon: blockIconsTextformattingGridViewNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingHistoryEduNew',
        title: __('Textformatting History Edu', 'block-icons-google'),
        icon: blockIconsTextformattingHistoryEduNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingInventoryNew',
        title: __('Textformatting Inventory', 'block-icons-google'),
        icon: blockIconsTextformattingInventoryNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingListAltNew',
        title: __('Textformatting List Alt', 'block-icons-google'),
        icon: blockIconsTextformattingListAltNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingListNew',
        title: __('Textformatting List', 'block-icons-google'),
        icon: blockIconsTextformattingListNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingMenuBookNew',
        title: __('Textformatting Menu Book', 'block-icons-google'),
        icon: blockIconsTextformattingMenuBookNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingNewspaperNew',
        title: __('Textformattingspaper', 'block-icons-google'),
        icon: blockIconsTextformattingNewspaperNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingNoteAddNew',
        title: __('Textformatting Note Add', 'block-icons-google'),
        icon: blockIconsTextformattingNoteAddNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingPendingActionsNew',
        title: __('Textformatting Pending Actions', 'block-icons-google'),
        icon: blockIconsTextformattingPendingActionsNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingPostAddNew',
        title: __('Textformatting Post Add', 'block-icons-google'),
        icon: blockIconsTextformattingPostAddNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingRequestQuoteNew',
        title: __('Textformatting Request Quote', 'block-icons-google'),
        icon: blockIconsTextformattingRequestQuoteNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingSpaceDashboardNew',
        title: __('Textformatting Space Dashboard', 'block-icons-google'),
        icon: blockIconsTextformattingSpaceDashboardNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingSummarizeNew',
        title: __('Textformatting Summarize', 'block-icons-google'),
        icon: blockIconsTextformattingSummarizeNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingTableNew',
        title: __('Textformatting Table', 'block-icons-google'),
        icon: blockIconsTextformattingTableNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingTaskNew',
        title: __('Textformatting Task', 'block-icons-google'),
        icon: blockIconsTextformattingTaskNew,
        categories: ['text-formatting-new'],
    },
    {
        name: 'blockIconsTextformattingViewListNew',
        title: __('Textformatting View List', 'block-icons-google'),
        icon: blockIconsTextformattingViewListNew,
        categories: ['text-formatting-new'],
    },
];

// toggle
import {
    blockIconsToggleCheckBox,
    blockIconsToggleCheckBoxOutlineBlank,
    blockIconsToggleIndeterminateCheckBox,
    blockIconsToggleRadioButtonChecked,
    blockIconsToggleRadioButtonUnchecked,
    blockIconsToggleStarBorder,
    blockIconsToggleStarBorderPurple500,
    blockIconsToggleStarHalf,
    blockIconsToggleStar,
    blockIconsToggleStarOutline,
    blockIconsToggleStarPurple500,
    blockIconsToggleToggleOff,
    blockIconsToggleToggleOn,
} from './toggle';

// toggle
const toggleIcons = [
    {
        name: 'blockIconsToggleCheckBox',
        title: __('Check Box', 'block-icons-google'),
        icon: blockIconsToggleCheckBox,
        categories: ['toggle'],
    },
    {
        name: 'blockIconsToggleCheckBoxOutlineBlank',
        title: __('Check Box Outline Blank', 'block-icons-google'),
        icon: blockIconsToggleCheckBoxOutlineBlank,
        categories: ['toggle'],
    },
    {
        name: 'blockIconsToggleIndeterminateCheckBox',
        title: __('Indeterminate Check Box', 'block-icons-google'),
        icon: blockIconsToggleIndeterminateCheckBox,
        categories: ['toggle'],
    },
    {
        name: 'blockIconsToggleRadioButtonChecked',
        title: __('Radio Button Checked', 'block-icons-google'),
        icon: blockIconsToggleRadioButtonChecked,
        categories: ['toggle'],
    },
    {
        name: 'blockIconsToggleRadioButtonUnchecked',
        title: __('Radio Button Unchecked', 'block-icons-google'),
        icon: blockIconsToggleRadioButtonUnchecked,
        categories: ['toggle'],
    },
    {
        name: 'blockIconsToggleStarBorder',
        title: __('Star Border', 'block-icons-google'),
        icon: blockIconsToggleStarBorder,
        categories: ['toggle'],
    },
    {
        name: 'blockIconsToggleStarBorderPurple500',
        title: __('Star Border Purple500', 'block-icons-google'),
        icon: blockIconsToggleStarBorderPurple500,
        categories: ['toggle'],
    },
    {
        name: 'blockIconsToggleStarHalf',
        title: __('Star Half', 'block-icons-google'),
        icon: blockIconsToggleStarHalf,
        categories: ['toggle'],
    },
    {
        name: 'blockIconsToggleStar',
        title: __('Star', 'block-icons-google'),
        icon: blockIconsToggleStar,
        categories: ['toggle'],
    },
    {
        name: 'blockIconsToggleStarOutline',
        title: __('Star Outline', 'block-icons-google'),
        icon: blockIconsToggleStarOutline,
        categories: ['toggle'],
    },
    {
        name: 'blockIconsToggleStarPurple500',
        title: __('Star Purple500', 'block-icons-google'),
        icon: blockIconsToggleStarPurple500,
        categories: ['toggle'],
    },
    {
        name: 'blockIconsToggleToggleOff',
        title: __('Off', 'block-icons-google'),
        icon: blockIconsToggleToggleOff,
        categories: ['toggle'],
    },
    {
        name: 'blockIconsToggleToggleOn',
        title: __('On', 'block-icons-google'),
        icon: blockIconsToggleToggleOn,
        categories: ['toggle'],
    },
];

// transportation-new
import {
    blockIconsTransportationAgricultureNew,
    blockIconsTransportationAirlinesNew,
    blockIconsTransportationAirportShuttleNew,
    blockIconsTransportationBusAlertNew,
    blockIconsTransportationCarCrashNew,
    blockIconsTransportationCommuteNew,
    blockIconsTransportationDepartureBoardNew,
    blockIconsTransportationDirectionsBikeNew,
    blockIconsTransportationDirectionsBoatNew,
    blockIconsTransportationDirectionsBusNew,
    blockIconsTransportationDirectionsCarNew,
    blockIconsTransportationDirectionsRailwayNew,
    blockIconsTransportationDirectionsRunNew,
    blockIconsTransportationDirectionsSubwayNew,
    blockIconsTransportationDirectionsWalkNew,
    blockIconsTransportationElectricBikeNew,
    blockIconsTransportationElectricCarNew,
    blockIconsTransportationElectricMopedNew,
    blockIconsTransportationElectricRickshawNew,
    blockIconsTransportationElectricScooterNew,
    blockIconsTransportationFlightLandNew,
    blockIconsTransportationFlightNew,
    blockIconsTransportationFlightTakeoffNew,
    blockIconsTransportationForkRightNew,
    blockIconsTransportationHailNew,
    blockIconsTransportationLocalShippingNew,
    blockIconsTransportationLocalTaxiNew,
    blockIconsTransportationMotorcycleNew,
    blockIconsTransportationNoCrashNew,
    blockIconsTransportationPedalBikeNew,
    blockIconsTransportationRvHookupNew,
    blockIconsTransportationSailingNew,
    blockIconsTransportationSubwayNew,
    blockIconsTransportationTaxiAlertNew,
    blockIconsTransportationTireRepairNew,
    blockIconsTransportationTrainNew,
    blockIconsTransportationTramNew,
    blockIconsTransportationTransportationNew,
    blockIconsTransportationTurnLeftNew,
    blockIconsTransportationTurnRightNew,
    blockIconsTransportationTwoWheelerNew,
    blockIconsTransportationUTurnLeftNew,
} from './transportation-new';

// transportation-new
const transportationNewIcons = [
    {
        name: 'blockIconsTransportationAgricultureNew',
        title: __('Agriculture', 'block-icons-google'),
        icon: blockIconsTransportationAgricultureNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationAirlinesNew',
        title: __('Airlines', 'block-icons-google'),
        icon: blockIconsTransportationAirlinesNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationAirportShuttleNew',
        title: __('Airport Shuttle', 'block-icons-google'),
        icon: blockIconsTransportationAirportShuttleNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationBusAlertNew',
        title: __('Bus Alert', 'block-icons-google'),
        icon: blockIconsTransportationBusAlertNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationCarCrashNew',
        title: __('Car Crash', 'block-icons-google'),
        icon: blockIconsTransportationCarCrashNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationCommuteNew',
        title: __('Commute', 'block-icons-google'),
        icon: blockIconsTransportationCommuteNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationDepartureBoardNew',
        title: __('Departure Board', 'block-icons-google'),
        icon: blockIconsTransportationDepartureBoardNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationDirectionsBikeNew',
        title: __('Directions Bike', 'block-icons-google'),
        icon: blockIconsTransportationDirectionsBikeNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationDirectionsBoatNew',
        title: __('Directions Boat', 'block-icons-google'),
        icon: blockIconsTransportationDirectionsBoatNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationDirectionsBusNew',
        title: __('Directions Bus', 'block-icons-google'),
        icon: blockIconsTransportationDirectionsBusNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationDirectionsCarNew',
        title: __('Directions Car', 'block-icons-google'),
        icon: blockIconsTransportationDirectionsCarNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationDirectionsRailwayNew',
        title: __('Directions Railway', 'block-icons-google'),
        icon: blockIconsTransportationDirectionsRailwayNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationDirectionsRunNew',
        title: __('Directions Run', 'block-icons-google'),
        icon: blockIconsTransportationDirectionsRunNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationDirectionsSubwayNew',
        title: __('Directions Subway', 'block-icons-google'),
        icon: blockIconsTransportationDirectionsSubwayNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationDirectionsWalkNew',
        title: __('Directions Walk', 'block-icons-google'),
        icon: blockIconsTransportationDirectionsWalkNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationElectricBikeNew',
        title: __('Electric Bike', 'block-icons-google'),
        icon: blockIconsTransportationElectricBikeNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationElectricCarNew',
        title: __('Electric Car', 'block-icons-google'),
        icon: blockIconsTransportationElectricCarNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationElectricMopedNew',
        title: __('Electric Moped', 'block-icons-google'),
        icon: blockIconsTransportationElectricMopedNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationElectricRickshawNew',
        title: __('Electric Rickshaw', 'block-icons-google'),
        icon: blockIconsTransportationElectricRickshawNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationElectricScooterNew',
        title: __('Electric Scooter', 'block-icons-google'),
        icon: blockIconsTransportationElectricScooterNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationFlightLandNew',
        title: __('Flight Land', 'block-icons-google'),
        icon: blockIconsTransportationFlightLandNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationFlightNew',
        title: __('Flight', 'block-icons-google'),
        icon: blockIconsTransportationFlightNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationFlightTakeoffNew',
        title: __('Flight Takeoff', 'block-icons-google'),
        icon: blockIconsTransportationFlightTakeoffNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationForkRightNew',
        title: __('Fork Right', 'block-icons-google'),
        icon: blockIconsTransportationForkRightNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationHailNew',
        title: __('Hail', 'block-icons-google'),
        icon: blockIconsTransportationHailNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationLocalShippingNew',
        title: __('Local Shipping', 'block-icons-google'),
        icon: blockIconsTransportationLocalShippingNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationLocalTaxiNew',
        title: __('Local Taxi', 'block-icons-google'),
        icon: blockIconsTransportationLocalTaxiNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationMotorcycleNew',
        title: __('Motorcycle', 'block-icons-google'),
        icon: blockIconsTransportationMotorcycleNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationNoCrashNew',
        title: __('No Crash', 'block-icons-google'),
        icon: blockIconsTransportationNoCrashNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationPedalBikeNew',
        title: __('Pedal Bike', 'block-icons-google'),
        icon: blockIconsTransportationPedalBikeNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationRvHookupNew',
        title: __('Rv Hookup', 'block-icons-google'),
        icon: blockIconsTransportationRvHookupNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationSailingNew',
        title: __('Sailing', 'block-icons-google'),
        icon: blockIconsTransportationSailingNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationSubwayNew',
        title: __('Subway', 'block-icons-google'),
        icon: blockIconsTransportationSubwayNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationTaxiAlertNew',
        title: __('Taxi Alert', 'block-icons-google'),
        icon: blockIconsTransportationTaxiAlertNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationTireRepairNew',
        title: __('Tire Repair', 'block-icons-google'),
        icon: blockIconsTransportationTireRepairNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationTrainNew',
        title: __('Train', 'block-icons-google'),
        icon: blockIconsTransportationTrainNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationTramNew',
        title: __('Tram', 'block-icons-google'),
        icon: blockIconsTransportationTramNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationTransportationNew',
        title: __('', 'block-icons-google'),
        icon: blockIconsTransportationTransportationNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationTurnLeftNew',
        title: __('Turn Left', 'block-icons-google'),
        icon: blockIconsTransportationTurnLeftNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationTurnRightNew',
        title: __('Turn Right', 'block-icons-google'),
        icon: blockIconsTransportationTurnRightNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationTwoWheelerNew',
        title: __('Two Wheeler', 'block-icons-google'),
        icon: blockIconsTransportationTwoWheelerNew,
        categories: ['transportation-new'],
    },
    {
        name: 'blockIconsTransportationUTurnLeftNew',
        title: __('UTurn Left', 'block-icons-google'),
        icon: blockIconsTransportationUTurnLeftNew,
        categories: ['transportation-new'],
    },
];

// travel-new
import {
    blockIconsTravelAirlineSeatReclineNormalNew,
    blockIconsTravelAirplaneTicketNew,
    blockIconsTravelApartmentNew,
    blockIconsTravelAttractionsNew,
    blockIconsTravelBakeryDiningNew,
    blockIconsTravelBeachAccessNew,
    blockIconsTravelCarRentalNew,
    blockIconsTravelCasinoNew,
    blockIconsTravelChildFriendlyNew,
    blockIconsTravelCottageNew,
    blockIconsTravelDinnerDiningNew,
    blockIconsTravelElevatorNew,
    blockIconsTravelEscalatorWarningNew,
    blockIconsTravelFamilyRestroomNew,
    blockIconsTravelFestivalNew,
    blockIconsTravelFitnessCenterNew,
    blockIconsTravelFoodBankNew,
    blockIconsTravelGiteNew,
    blockIconsTravelGolfCourseNew,
    blockIconsTravelHolidayVillageNew,
    blockIconsTravelHotelNew,
    blockIconsTravelIcecreamNew,
    blockIconsTravelLiquorNew,
    blockIconsTravelLocalBarNew,
    blockIconsTravelLocalCafeNew,
    blockIconsTravelLocalDiningNew,
    blockIconsTravelLocationCityNew,
    blockIconsTravelLuggageNew,
    blockIconsTravelLunchDiningNew,
    blockIconsTravelMuseumNew,
    blockIconsTravelNightlifeNew,
    blockIconsTravelNightShelterNew,
    blockIconsTravelOtherHousesNew,
    blockIconsTravelPoolNew,
    blockIconsTravelRamenDiningNew,
    blockIconsTravelRoomServiceNew,
    blockIconsTravelSmokeFreeNew,
    blockIconsTravelSmokingRoomsNew,
    blockIconsTravelSpaNew,
    blockIconsTravelSportsBarNew,
    blockIconsTravelStairsNew,
    blockIconsTravelVillaNew,
} from './travel-new';

// travel-new
const travelNewIcons = [
    {
        name: 'blockIconsTravelAirlineSeatReclineNormalNew',
        title: __('Airline Seat Recline Normal', 'block-icons-google'),
        icon: blockIconsTravelAirlineSeatReclineNormalNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelAirplaneTicketNew',
        title: __('Airplane Ticket', 'block-icons-google'),
        icon: blockIconsTravelAirplaneTicketNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelApartmentNew',
        title: __('Apartment', 'block-icons-google'),
        icon: blockIconsTravelApartmentNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelAttractionsNew',
        title: __('Attractions', 'block-icons-google'),
        icon: blockIconsTravelAttractionsNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelBakeryDiningNew',
        title: __('Bakery Dining', 'block-icons-google'),
        icon: blockIconsTravelBakeryDiningNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelBeachAccessNew',
        title: __('Beach Access', 'block-icons-google'),
        icon: blockIconsTravelBeachAccessNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelCarRentalNew',
        title: __('Car Rental', 'block-icons-google'),
        icon: blockIconsTravelCarRentalNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelCasinoNew',
        title: __('Casino', 'block-icons-google'),
        icon: blockIconsTravelCasinoNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelChildFriendlyNew',
        title: __('Child Friendly', 'block-icons-google'),
        icon: blockIconsTravelChildFriendlyNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelCottageNew',
        title: __('Cottage', 'block-icons-google'),
        icon: blockIconsTravelCottageNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelDinnerDiningNew',
        title: __('Dinner Dining', 'block-icons-google'),
        icon: blockIconsTravelDinnerDiningNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelElevatorNew',
        title: __('Elevator', 'block-icons-google'),
        icon: blockIconsTravelElevatorNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelEscalatorWarningNew',
        title: __('Escalator Warning', 'block-icons-google'),
        icon: blockIconsTravelEscalatorWarningNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelFamilyRestroomNew',
        title: __('Family Restroom', 'block-icons-google'),
        icon: blockIconsTravelFamilyRestroomNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelFestivalNew',
        title: __('Festival', 'block-icons-google'),
        icon: blockIconsTravelFestivalNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelFitnessCenterNew',
        title: __('Fitness Center', 'block-icons-google'),
        icon: blockIconsTravelFitnessCenterNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelFoodBankNew',
        title: __('Food Bank', 'block-icons-google'),
        icon: blockIconsTravelFoodBankNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelGiteNew',
        title: __('Gite', 'block-icons-google'),
        icon: blockIconsTravelGiteNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelGolfCourseNew',
        title: __('Golf Course', 'block-icons-google'),
        icon: blockIconsTravelGolfCourseNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelHolidayVillageNew',
        title: __('Holiday Village', 'block-icons-google'),
        icon: blockIconsTravelHolidayVillageNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelHotelNew',
        title: __('Hotel', 'block-icons-google'),
        icon: blockIconsTravelHotelNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelIcecreamNew',
        title: __('Icecream', 'block-icons-google'),
        icon: blockIconsTravelIcecreamNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelLiquorNew',
        title: __('Liquor', 'block-icons-google'),
        icon: blockIconsTravelLiquorNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelLocalBarNew',
        title: __('Local Bar', 'block-icons-google'),
        icon: blockIconsTravelLocalBarNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelLocalCafeNew',
        title: __('Local Cafe', 'block-icons-google'),
        icon: blockIconsTravelLocalCafeNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelLocalDiningNew',
        title: __('Local Dining', 'block-icons-google'),
        icon: blockIconsTravelLocalDiningNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelLocationCityNew',
        title: __('Location City', 'block-icons-google'),
        icon: blockIconsTravelLocationCityNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelLuggageNew',
        title: __('Luggage', 'block-icons-google'),
        icon: blockIconsTravelLuggageNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelLunchDiningNew',
        title: __('Lunch Dining', 'block-icons-google'),
        icon: blockIconsTravelLunchDiningNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelMuseumNew',
        title: __('Museum', 'block-icons-google'),
        icon: blockIconsTravelMuseumNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelNightlifeNew',
        title: __('Nightlife', 'block-icons-google'),
        icon: blockIconsTravelNightlifeNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelNightShelterNew',
        title: __('Night Shelter', 'block-icons-google'),
        icon: blockIconsTravelNightShelterNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelOtherHousesNew',
        title: __('Other Houses', 'block-icons-google'),
        icon: blockIconsTravelOtherHousesNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelPoolNew',
        title: __('Pool', 'block-icons-google'),
        icon: blockIconsTravelPoolNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelRamenDiningNew',
        title: __('Ramen Dining', 'block-icons-google'),
        icon: blockIconsTravelRamenDiningNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelRoomServiceNew',
        title: __('Room Service', 'block-icons-google'),
        icon: blockIconsTravelRoomServiceNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelSmokeFreeNew',
        title: __('Smoke Free', 'block-icons-google'),
        icon: blockIconsTravelSmokeFreeNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelSmokingRoomsNew',
        title: __('Smoking Rooms', 'block-icons-google'),
        icon: blockIconsTravelSmokingRoomsNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelSpaNew',
        title: __('Spa', 'block-icons-google'),
        icon: blockIconsTravelSpaNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelSportsBarNew',
        title: __('Sports Bar', 'block-icons-google'),
        icon: blockIconsTravelSportsBarNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelStairsNew',
        title: __('Stairs', 'block-icons-google'),
        icon: blockIconsTravelStairsNew,
        categories: ['travel-new'],
    },
    {
        name: 'blockIconsTravelVillaNew',
        title: __('Villa', 'block-icons-google'),
        icon: blockIconsTravelVillaNew,
        categories: ['travel-new'],
    },
];

// ui-actions-new
import {
    blockIconsUiactionsAddCircleNew,
    blockIconsUiactionsAddNew,
    blockIconsUiactionsAppsNew,
    blockIconsUiactionsArrowBackiOSNew,
    blockIconsUiactionsArrowBackNew,
    blockIconsUiactionsArrowDropDownNew,
    blockIconsUiactionsArrowForwardiOSNew,
    blockIconsUiactionsArrowForwardNew,
    blockIconsUiactionsArrowRightAltNew,
    blockIconsUiactionsArrowUpwardNew,
    blockIconsUiactionsBoltNew,
    blockIconsUiactionsCancelNew,
    blockIconsUiactionsCheckBoxNew,
    blockIconsUiactionsCheckBoxOutlineBlankNew,
    blockIconsUiactionsCheckCircleNew,
    blockIconsUiactionsCheckNew,
    blockIconsUiactionsChevronLeftNew,
    blockIconsUiactionsChevronRightNew,
    blockIconsUiactionsCloseNew,
    blockIconsUiactionsDeleteNew,
    blockIconsUiactionsDoneNew,
    blockIconsUiactionsDownloadNew,
    blockIconsUiactionsExpandLessNew,
    blockIconsUiactionsExpandMoreNew,
    blockIconsUiactionsFavoriteNew,
    blockIconsUiactionsGradeNew,
    blockIconsUiactionsHomeNew,
    blockIconsUiactionsLoginNew,
    blockIconsUiactionsLogoutNew,
    blockIconsUiactionsMenuNew,
    blockIconsUiactionsMoreHorizNew,
    blockIconsUiactionsMoreVertNew,
    blockIconsUiactionsOpenInNewNew,
    blockIconsUiactionsRadioButtonCheckedNew,
    blockIconsUiactionsRadioButtonUncheckedNew,
    blockIconsUiactionsRefreshNew,
    blockIconsUiactionsRemoveNew,
    blockIconsUiactionsSearchNew,
    blockIconsUiactionsSettingsNew,
    blockIconsUiactionsStarNew,
    blockIconsUiactionsToggleOffNew,
    blockIconsUiactionsToggleOnNew,
} from './ui-actions-new';

// ui-actions-new
const uiActionsNewIcons = [
    {
        name: 'blockIconsUiactionsAddCircleNew',
        title: __('Uiactions Add Circle', 'block-icons-google'),
        icon: blockIconsUiactionsAddCircleNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsAddNew',
        title: __('Uiactions Add', 'block-icons-google'),
        icon: blockIconsUiactionsAddNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsAppsNew',
        title: __('Uiactions Apps', 'block-icons-google'),
        icon: blockIconsUiactionsAppsNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsArrowBackiOSNew',
        title: __('Uiactions Arrow Backi OS', 'block-icons-google'),
        icon: blockIconsUiactionsArrowBackiOSNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsArrowBackNew',
        title: __('Uiactions Arrow Back', 'block-icons-google'),
        icon: blockIconsUiactionsArrowBackNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsArrowDropDownNew',
        title: __('Uiactions Arrow Drop Down', 'block-icons-google'),
        icon: blockIconsUiactionsArrowDropDownNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsArrowForwardiOSNew',
        title: __('Uiactions Arrow Forwardi OS', 'block-icons-google'),
        icon: blockIconsUiactionsArrowForwardiOSNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsArrowForwardNew',
        title: __('Uiactions Arrow Forward', 'block-icons-google'),
        icon: blockIconsUiactionsArrowForwardNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsArrowRightAltNew',
        title: __('Uiactions Arrow Right Alt', 'block-icons-google'),
        icon: blockIconsUiactionsArrowRightAltNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsArrowUpwardNew',
        title: __('Uiactions Arrow Upward', 'block-icons-google'),
        icon: blockIconsUiactionsArrowUpwardNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsBoltNew',
        title: __('Uiactions Bolt', 'block-icons-google'),
        icon: blockIconsUiactionsBoltNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsCancelNew',
        title: __('Uiactions Cancel', 'block-icons-google'),
        icon: blockIconsUiactionsCancelNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsCheckBoxNew',
        title: __('Uiactions Check Box', 'block-icons-google'),
        icon: blockIconsUiactionsCheckBoxNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsCheckBoxOutlineBlankNew',
        title: __('Uiactions Check Box Outline Blank', 'block-icons-google'),
        icon: blockIconsUiactionsCheckBoxOutlineBlankNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsCheckCircleNew',
        title: __('Uiactions Check Circle', 'block-icons-google'),
        icon: blockIconsUiactionsCheckCircleNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsCheckNew',
        title: __('Uiactions Check', 'block-icons-google'),
        icon: blockIconsUiactionsCheckNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsChevronLeftNew',
        title: __('Uiactions Chevron Left', 'block-icons-google'),
        icon: blockIconsUiactionsChevronLeftNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsChevronRightNew',
        title: __('Uiactions Chevron Right', 'block-icons-google'),
        icon: blockIconsUiactionsChevronRightNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsCloseNew',
        title: __('Uiactions Close', 'block-icons-google'),
        icon: blockIconsUiactionsCloseNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsDeleteNew',
        title: __('Uiactions Delete', 'block-icons-google'),
        icon: blockIconsUiactionsDeleteNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsDoneNew',
        title: __('Uiactions Done', 'block-icons-google'),
        icon: blockIconsUiactionsDoneNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsDownloadNew',
        title: __('Uiactions Download', 'block-icons-google'),
        icon: blockIconsUiactionsDownloadNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsExpandLessNew',
        title: __('Uiactions Expand Less', 'block-icons-google'),
        icon: blockIconsUiactionsExpandLessNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsExpandMoreNew',
        title: __('Uiactions Expand More', 'block-icons-google'),
        icon: blockIconsUiactionsExpandMoreNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsFavoriteNew',
        title: __('Uiactions Favorite', 'block-icons-google'),
        icon: blockIconsUiactionsFavoriteNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsGradeNew',
        title: __('Uiactions Grade', 'block-icons-google'),
        icon: blockIconsUiactionsGradeNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsHomeNew',
        title: __('Uiactions Home', 'block-icons-google'),
        icon: blockIconsUiactionsHomeNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsLoginNew',
        title: __('Uiactions Login', 'block-icons-google'),
        icon: blockIconsUiactionsLoginNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsLogoutNew',
        title: __('Uiactions Logout', 'block-icons-google'),
        icon: blockIconsUiactionsLogoutNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsMenuNew',
        title: __('Uiactions Menu', 'block-icons-google'),
        icon: blockIconsUiactionsMenuNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsMoreHorizNew',
        title: __('Uiactions More Horiz', 'block-icons-google'),
        icon: blockIconsUiactionsMoreHorizNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsMoreVertNew',
        title: __('Uiactions More Vert', 'block-icons-google'),
        icon: blockIconsUiactionsMoreVertNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsOpenInNewNew',
        title: __('Uiactions Open In', 'block-icons-google'),
        icon: blockIconsUiactionsOpenInNewNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsRadioButtonCheckedNew',
        title: __('Uiactions Radio Button Checked', 'block-icons-google'),
        icon: blockIconsUiactionsRadioButtonCheckedNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsRadioButtonUncheckedNew',
        title: __('Uiactions Radio Button Unchecked', 'block-icons-google'),
        icon: blockIconsUiactionsRadioButtonUncheckedNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsRefreshNew',
        title: __('Uiactions Refresh', 'block-icons-google'),
        icon: blockIconsUiactionsRefreshNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsRemoveNew',
        title: __('Uiactions Remove', 'block-icons-google'),
        icon: blockIconsUiactionsRemoveNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsSearchNew',
        title: __('Uiactions Search', 'block-icons-google'),
        icon: blockIconsUiactionsSearchNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsSettingsNew',
        title: __('Uiactions Settings', 'block-icons-google'),
        icon: blockIconsUiactionsSettingsNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsStarNew',
        title: __('Uiactions Star', 'block-icons-google'),
        icon: blockIconsUiactionsStarNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsToggleOffNew',
        title: __('Uiactions Toggle Off', 'block-icons-google'),
        icon: blockIconsUiactionsToggleOffNew,
        categories: ['ui-actions-new'],
    },
    {
        name: 'blockIconsUiactionsToggleOnNew',
        title: __('Uiactions Toggle On', 'block-icons-google'),
        icon: blockIconsUiactionsToggleOnNew,
        categories: ['ui-actions-new'],
    },
];

// Icons
const icons = [
    {
        isDefault: false,
        type: 'Icons',
        title: __('Google Icons', 'block-icons-google'),
        icons: [].concat(actionIcons, activitiesNewIcons, alertIcons, androidNewIcons, audioAndVideoIcons, audioAndVideoNewIcons, brandNewIcons, businessAndPaymentsNewIcons, commonActionsNewIcons, communicationIcons, communicationNewIcons, contentIcons, deviceIcons, editorIcons, fileIcons, hardwareIcons, hardwareNewIcons, homeIcons, homeNewIcons, householdNewIcons, imageIcons, mapsIcons, mapsNewIcons, navigationIcons, notificationIcons, photoAndImageNewIcons, placesIcons, privacyAndSecurityNewIcons, searchIcons, socialIcons, socialNewIcons, textFormattingNewIcons, toggleIcons, transportationNewIcons, travelNewIcons, uiActionsNewIcons),
        categories: [
					{
    			name: 'action',
    			title: __('Action', 'block-icons-google'),
			},
			{
    			name: 'activities-new',
    			title: __('Activities New', 'block-icons-google'),
			},
			{
    			name: 'alert',
    			title: __('Alert', 'block-icons-google'),
			},
			{
    			name: 'android-new',
    			title: __('Android New', 'block-icons-google'),
			},
			{
    			name: 'audio-and-video',
    			title: __('Audio And Video', 'block-icons-google'),
			},
			{
    			name: 'audio-and-video-new',
    			title: __('Audio And Video New', 'block-icons-google'),
			},
			{
    			name: 'brand-new',
    			title: __('Brand New', 'block-icons-google'),
			},
			{
    			name: 'business-and-payments-new',
    			title: __('Business And Payments New', 'block-icons-google'),
			},
			{
    			name: 'common-actions-new',
    			title: __('Common Actions New', 'block-icons-google'),
			},
			{
    			name: 'communication',
    			title: __('Communication', 'block-icons-google'),
			},
			{
    			name: 'communication-new',
    			title: __('Communication New', 'block-icons-google'),
			},
			{
    			name: 'content',
    			title: __('Content', 'block-icons-google'),
			},
			{
    			name: 'device',
    			title: __('Device', 'block-icons-google'),
			},
			{
    			name: 'editor',
    			title: __('Editor', 'block-icons-google'),
			},
			{
    			name: 'file',
    			title: __('File', 'block-icons-google'),
			},
			{
    			name: 'hardware',
    			title: __('Hardware', 'block-icons-google'),
			},
			{
    			name: 'hardware-new',
    			title: __('Hardware New', 'block-icons-google'),
			},
			{
    			name: 'home',
    			title: __('Home', 'block-icons-google'),
			},
			{
    			name: 'home-new',
    			title: __('Home New', 'block-icons-google'),
			},
			{
    			name: 'household-new',
    			title: __('Household New', 'block-icons-google'),
			},
			{
    			name: 'image',
    			title: __('Image', 'block-icons-google'),
			},
			{
    			name: 'maps',
    			title: __('Maps', 'block-icons-google'),
			},
			{
    			name: 'maps-new',
    			title: __('Maps New', 'block-icons-google'),
			},
			{
    			name: 'navigation',
    			title: __('Navigation', 'block-icons-google'),
			},
			{
    			name: 'notification',
    			title: __('Notification', 'block-icons-google'),
			},
			{
    			name: 'photo-and-image-new',
    			title: __('Photo And Image New', 'block-icons-google'),
			},
			{
    			name: 'places',
    			title: __('Places', 'block-icons-google'),
			},
			{
    			name: 'privacy-and-security-new',
    			title: __('Privacy And Security New', 'block-icons-google'),
			},
			{
    			name: 'search',
    			title: __('Search', 'block-icons-google'),
			},
			{
    			name: 'social',
    			title: __('Social', 'block-icons-google'),
			},
			{
    			name: 'social-new',
    			title: __('Social New', 'block-icons-google'),
			},
			{
    			name: 'text-formatting-new',
    			title: __('Text Formatting New', 'block-icons-google'),
			},
			{
    			name: 'toggle',
    			title: __('Toggle', 'block-icons-google'),
			},
			{
    			name: 'transportation-new',
    			title: __('Transportation New', 'block-icons-google'),
			},
			{
    			name: 'travel-new',
    			title: __('Travel New', 'block-icons-google'),
			},
			{
    			name: 'ui-actions-new',
    			title: __('Ui Actions New', 'block-icons-google'),
			},
        ],
    },
];

// Allow third parties to add their own icon types via filter.
export default function getIcons() {
    return applyFilters('iconBlock.icons', icons);
}
